import { ColorOptions } from '@jfs/ui-new'
import { convertMonth, convertYear, getAppOs, getDeviceType, getLocation, isCardExpired, isEmpty } from '@jfs/utils'
import { flow, getType, Instance, onSnapshot, types } from 'mobx-state-tree'
import { binService } from '../../network/api/binService'
import { cancelIntent } from '../../network/api/cancelIntent'
import { emiCardsEligibility, emiRetrieve } from '../../network/api/emiRetrieve'
import { generateQr, generateQrCodeRequest } from '../../network/api/generateQrCodeRequest'
import { getInstruments } from '../../network/api/getInstruments'
import { getIntentStatus } from '../../network/api/getIntentStatus'
import { getMerchantConfig } from '../../network/api/getMerchantConfig'
import { getOffers } from '../../network/api/getOffers'
import { getSodexoCardBalance } from '../../network/api/getSodexoCardBalance'
import { confirmPayment, getPaymentStatus } from '../../network/api/netBanking'
import { offerTxnApply } from '../../network/api/offerTxnApply'
import { offerValidate } from '../../network/api/offerValidate'
import { payLaterPreProcess } from '../../network/api/payLaterPreProcess'
import { resolveApi } from '../../network/api/resloveApi'
import { searchEntity } from '../../network/api/searchEntity'
import { searchMerchant } from '../../network/api/searchMerchant'
import { getRandomAlphaNumString, updateToken } from '../../network/config'
import {
  CARD_TYPE,
  formatAmount,
  getImageLocation,
  getOsName,
  getPaymentType,
  getScreenDimen,
  getUPIIcon,
  getWindow,
  isIFrame,
  isUpiNumber,
  isValidColorCode,
  UPI_SUBSCRIPTION_ENABLED_LIST
} from '../../utils'
import {
  CARD_METHOD_SC_SUBTYPE,
  CARD_METHOD_SC_TYPE,
  HEADER_TITILES,
  IS_NTC_ENABLED,
  MAX_RETRIES_EXCEEDED_ERROR,
  MERGE_NB_CNB,
  PAYMENT_SCREENS,
  PAYMENT_TYPE,
  SUBSCRIPTION_FREQUENCY,
  SUBSCRIPTION_RULE,
  TEMPLATE
} from '../../utils/constants'
import { errorMessage, staticStrings } from '../../utils/string'
import { CardlessEMIType } from '../models/CardlessEMI'
import { Client, ClientInitalData } from '../models/Client'
import { Config, ConfigInitialData } from '../models/Config'
import { EMIType } from '../models/EMI'
import { Merchant, MerchantInitialData } from '../models/Merchant'
import { Offer } from '../models/Offer'
import { PayLaterType } from '../models/PayLater'
import { Transaction, TransactionInitialData } from '../models/Transaction'
import { UPIType } from '../models/UPI'
import { User, UserInitialData } from '../models/User'
import { WalletType } from '../models/Wallet'
import { deleteCard } from './../../network/api/deleteCard'
import { fetchConvenienceFee } from './../../network/api/fetchConvenienceFee'
import { savedCard } from './../../network/api/savedCard'
import { upiValidateVpa } from './../../network/api/upiPayments'
import { AppConfig } from './../../network/config'
import { CardData } from './../../screens/SavedCard/types'
import {
  ADD_NEW_UPI,
  BIN_APP_CODE,
  BIN_CARD_LENGTH,
  BIN_OPERATION_CODE,
  CAPTURE_METHOD,
  DC_STATUS,
  EMI,
  EMI_CARDTYPE,
  EMI_METHOD_CARDLESS_SUBTYPE,
  EMI_SCHME_TYPE,
  EMI_TYPES,
  FINANCIAL_PROFILE,
  LIVE_MODE,
  MERCHANT_CONFIG_STATUS,
  MERCHANT_CONFIG_TYPE,
  MERCHANT_MEDIA_TYPE,
  MERCHANT_OUTPUT_DOMAIN,
  OFFER_TYPE,
  PAYMENT_MODE_SUBTYPES,
  PAYMENT_MODE_TYPE,
  SC_ENTITY_TYPE,
  SC_USER_ID,
  TOKEN_EXPIRY_CODE,
  TRANSACTION_METHOD,
  UPI_LIVEMODE,
  UPI_METHOD_TYPE,
  UPI_PAYEE_COUNTRY_CODE,
  UPI_PAYER_SUBTYPE,
  UPI_PAYER_TYPE
} from './../../utils/constants'
import { MessageTypes } from './../../utils/index'
import { AmountType } from './../models/Amount'
import { BankType } from './../models/Bank'
import { CardType, CardTypes } from './../models/Card'
import { JioPayFinanceHub, JioPayFinanceHubInitialData } from './../models/JioPayFinanceHub'
import { MerchantType } from './../models/Merchant'
import { Message, MessageInitalData } from './../models/Message'

const Root = types
  .model('Root', {
    user: User,
    merchant: Merchant,
    transaction: Transaction,
    config: Config,
    client: Client,
    message: Message,
    offer: types.optional(types.array(Offer), []),
    jioPayFinanceHub: JioPayFinanceHub,
  })
  .views((self) => ({
    getTransactionAmount() {
      return self.transaction.amount.payableAmount
    },
    showSCCheckBox() {
      return !!self.user.externalId
    },
    showSavedCards() {
      return !!self.user.externalId && self.merchant.miscellaneous.showSavedCards
    },
    getHeaderTitle(paymentType: string) {
      switch (paymentType) {
        case PAYMENT_SCREENS.netbanking:
          return HEADER_TITILES[PAYMENT_SCREENS.netbanking]
        case PAYMENT_SCREENS.debitcard:
          return HEADER_TITILES[PAYMENT_SCREENS.debitcard]
        case PAYMENT_SCREENS.creditcard:
          return HEADER_TITILES[PAYMENT_SCREENS.creditcard]
        case PAYMENT_SCREENS.ccdccard:
          // if (self.merchant.allowedPaymentModes?.length > 0) {
          //   const [cardPaymentMethod] = self.merchant.allowedPaymentModes?.filter((item: any) => {
          //     return (
          //       Number(item.methodType) === PAYMENT_MODE_TYPE.PURCHASE &&
          //       Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD
          //     )
          //   })
          //   if (cardPaymentMethod) {
          //     const found = [CARD_TYPE.CREDIT_CARD, CARD_TYPE.DEBIT_CARD].every((item: any) => {
          //       cardPaymentMethod?.cardType?.forEach((item1) => console.log('cardPaymentMethod9', item1, typeof item1))
          //       return cardPaymentMethod?.cardType?.includes(Number(item))
          //     })
          //     console.log('cardPaymentMethod isFound', found)
          //     if (!found) {
          //       if (cardPaymentMethod?.cardType?.includes(Number(CARD_TYPE.CREDIT_CARD))) {
          //         return 'Credit Card'
          //       } else if (cardPaymentMethod?.cardType?.includes(Number(CARD_TYPE.DEBIT_CARD))) {
          //         return 'Debit Card'
          //       }
          //     }
          //   }
          // } else if (self.merchant.notAllowedPaymentModes?.length > 0) {
          //   const [cardPaymentMethod] = self.merchant.notAllowedPaymentModes?.filter((item: any) => {
          //     return (
          //       Number(item.methodType) === PAYMENT_MODE_TYPE.PURCHASE &&
          //       Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD
          //     )
          //   })
          //   if (cardPaymentMethod) {
          //     if (!cardPaymentMethod?.cardType?.includes(Number(CARD_TYPE.CREDIT_CARD))) {
          //       return 'Credit Card'
          //     } else if (!cardPaymentMethod?.cardType?.includes(Number(CARD_TYPE.DEBIT_CARD))) {
          //       return 'Debit Card'
          //     }
          //   }
          // }
          return HEADER_TITILES[PAYMENT_SCREENS.ccdccard]
        case PAYMENT_SCREENS.upi:
          return HEADER_TITILES[PAYMENT_SCREENS.upi]
        case PAYMENT_SCREENS.wallet:
          return HEADER_TITILES[PAYMENT_SCREENS.wallet]
        case PAYMENT_SCREENS.emi:
          return HEADER_TITILES[PAYMENT_SCREENS.emi]
        case PAYMENT_SCREENS.offers:
          return HEADER_TITILES[PAYMENT_SCREENS.offers]
        case PAYMENT_SCREENS.paylater:
          return HEADER_TITILES[PAYMENT_SCREENS.paylater]
        default:
          return 'Select Payment Method'
      }
    },
    isValidTemplate(templateId: string) {
      const templateKeys: any = Object.keys(TEMPLATE)
      return templateKeys.find((item: any) => TEMPLATE[item] === templateId)
    },
    isCCEMIPlansAllowed() {
      if (self.merchant.allowedPaymentModes?.length > 0) {
        return self.merchant.allowedPaymentModes?.some((item: any) => {
          const isFound =
            Number(item.methodType) === PAYMENT_MODE_TYPE.EMI &&
              Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD &&
              item?.cardType?.includes(Number(CARD_TYPE.CREDIT_CARD))
              ? true
              : false
          return isFound
        })
      } else if (self.merchant.notAllowedPaymentModes?.length > 0) {
        const emiPaymentModes = self.merchant.notAllowedPaymentModes.filter((item: any) => {
          return Number(item.methodType) === PAYMENT_MODE_TYPE.EMI
        })
        const emiMethodSubTypes = emiPaymentModes?.map((item) => Number(item.methodSubType))
        if (emiMethodSubTypes.includes(PAYMENT_MODE_SUBTYPES.CARD)) {
          return self.merchant.notAllowedPaymentModes?.some((item: any) => {
            const isFound =
              Number(item.methodType) === PAYMENT_MODE_TYPE.EMI &&
                Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD &&
                !item?.cardType?.includes(Number(CARD_TYPE.CREDIT_CARD))
                ? true
                : false
            return isFound
          })
        } else {
          return true
        }
      }
      return true
    },
    isDCEMIPlansAllowed() {
      if (self.merchant.allowedPaymentModes?.length > 0) {
        return self.merchant.allowedPaymentModes?.some((item: any) => {
          return Number(item.methodType) === PAYMENT_MODE_TYPE.EMI &&
            Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD &&
            item?.cardType?.includes(Number(CARD_TYPE.DEBIT_CARD))
            ? true
            : false
        })
      } else if (self.merchant.notAllowedPaymentModes?.length > 0) {
        const emiPaymentModes = self.merchant.notAllowedPaymentModes.filter((item: any) => {
          return Number(item.methodType) === PAYMENT_MODE_TYPE.EMI
        })
        const emiMethodSubTypes = emiPaymentModes?.map((item) => Number(item.methodSubType))
        if (emiMethodSubTypes.includes(PAYMENT_MODE_SUBTYPES.CARD)) {
          return self.merchant.notAllowedPaymentModes?.some((item: any) => {
            const isFound =
              Number(item.methodType) === PAYMENT_MODE_TYPE.EMI &&
                Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD &&
                !item?.cardType?.includes(Number(CARD_TYPE.DEBIT_CARD))
                ? true
                : false
            return isFound
          })
        } else {
          return true
        }
      }
      return true
    },
    getEmiPlanCount(emitype: string, includeDCCardLess: boolean = true) {
      if (emitype === EMI.CARDLESS) {
        if (self.merchant.allowedPaymentModes?.length > 0) {
          const cardPaymentModes = self.merchant.allowedPaymentModes?.filter((item: any) => {
            return Number(item.methodType) === PAYMENT_MODE_TYPE.EMI &&
              Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARDLESS_EMI
              ? true
              : false
          })
          if (cardPaymentModes?.length > 0) {
            return self.merchant.preferences.cardLessEMIList.length
          }
        } else if (self.merchant.notAllowedPaymentModes?.length > 0) {
          const [cardPaymentMode]: any = self.merchant?.notAllowedPaymentModes?.filter((item: any) => {
            return (
              Number(item.methodType) === PAYMENT_MODE_TYPE.EMI &&
              Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARDLESS_EMI
            )
          })
          if (!cardPaymentMode) {
            return self.merchant.preferences.cardLessEMIList.length
          }
        } else {
          return self.merchant.preferences.cardLessEMIList.length
        }
      } else if (emitype === EMI.DEBIT_CARD_ALL) {
        if (self.merchant.allowedPaymentModes?.length > 0) {
          const cardPaymentModes = self.merchant.allowedPaymentModes?.filter((item: any) => {
            return Number(item.methodType) === PAYMENT_MODE_TYPE.EMI &&
              Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD &&
              (item?.cardType?.includes(Number(CARD_TYPE.DEBIT_CARD)) || item?.cardType?.length === 0)
              ? true
              : false
          })
          if (cardPaymentModes?.length > 0) {
            return self.merchant.preferences.EMILList.filter(
              (element) =>
                element.schemeSubType === EMI_CARDTYPE.DEBIT_CARD ||
                (includeDCCardLess && element.schemeSubType === EMI_CARDTYPE.CARDLESS_EMI),
            ).length
          }
        } else if (self.merchant.notAllowedPaymentModes?.length > 0) {
          const [cardPaymentMode]: any = self.merchant?.notAllowedPaymentModes?.filter((item: any) => {
            return (
              Number(item.methodType) === PAYMENT_MODE_TYPE.EMI &&
              Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD &&
              (item?.cardType?.includes(Number(CARD_TYPE.DEBIT_CARD)) || item?.cardType?.length === 0)
            )
          })
          if (!cardPaymentMode) {
            return self.merchant.preferences.EMILList.filter(
              (element) =>
                element.schemeSubType === EMI_CARDTYPE.DEBIT_CARD ||
                (includeDCCardLess && element.schemeSubType === EMI_CARDTYPE.CARDLESS_EMI),
            ).length
          }
        } else {
          return self.merchant.preferences.EMILList.filter(
            (element) =>
              element.schemeSubType === EMI_CARDTYPE.DEBIT_CARD ||
              (includeDCCardLess && element.schemeSubType === EMI_CARDTYPE.CARDLESS_EMI),
          ).length
        }
      } else if (emitype === EMI.CREDIT_CARD_ALL) {
        if (self.merchant.allowedPaymentModes?.length > 0) {
          const cardPaymentModes = self.merchant.allowedPaymentModes?.filter((item: any) => {
            return Number(item.methodType) === PAYMENT_MODE_TYPE.EMI &&
              Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD &&
              (item?.cardType?.includes(Number(CARD_TYPE.CREDIT_CARD)) || item?.cardType?.length === 0)
              ? true
              : false
          })
          if (cardPaymentModes?.length > 0) {
            return self.merchant.preferences.EMILList.filter(
              (element) => element.schemeSubType === EMI_CARDTYPE.CREDIT_CARD,
            ).length
          }
        } else if (self.merchant.notAllowedPaymentModes?.length > 0) {
          const [cardPaymentMode]: any = self.merchant?.notAllowedPaymentModes?.filter((item: any) => {
            return (
              Number(item.methodType) === PAYMENT_MODE_TYPE.EMI &&
              Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD &&
              (item?.cardType?.includes(Number(CARD_TYPE.CREDIT_CARD)) || item?.cardType?.length === 0)
            )
          })
          if (!cardPaymentMode) {
            return self.merchant.preferences.EMILList.filter(
              (element) => element.schemeSubType === EMI_CARDTYPE.CREDIT_CARD,
            ).length
          }
        } else {
          return self.merchant.preferences.EMILList.filter(
            (element) => element.schemeSubType === EMI_CARDTYPE.CREDIT_CARD,
          ).length
        }
      }
      return 0
    },
    getPaymentSupported(isSubscriptionEnabled: boolean) {
      let paymentsSupported: any = self.merchant.paymentsSupported
      if (isSubscriptionEnabled) {
        paymentsSupported = self.merchant.paymentsSupported.filter(
          (item: any) =>
            item === 'Credit/Debit Card' || item === 'Upi' || item === 'Credit Card' || item === 'Debit Card',
        )
      }
      if (MERGE_NB_CNB) {
        const isNbOrCnbSupported =
          self.merchant.paymentsSupported.includes('Netbanking') ||
          self.merchant.paymentsSupported.includes('Corporate Netbanking')
        paymentsSupported = self.merchant.paymentsSupported.filter(
          (item: any) => item !== 'Netbanking' || isNbOrCnbSupported,
        )
        const isNbSupported = self.merchant.paymentsSupported.includes('Netbanking')
        paymentsSupported = self.merchant.paymentsSupported.filter(
          (item: any) => item !== 'Corporate Netbanking' || !isNbSupported,
        )
      }
      const payments: any[] = paymentsSupported?.map((item: any) => {
        let modeName
        switch (item) {
          case PAYMENT_TYPE.CREDIT_CARD:
            modeName = PAYMENT_SCREENS.creditcard
            break
          case PAYMENT_TYPE.DEBIT_CARD:
            modeName = PAYMENT_SCREENS.debitcard
            break
          case PAYMENT_TYPE.CC_DC_CARD:
            modeName = PAYMENT_SCREENS.ccdccard
            break
          case PAYMENT_TYPE.UPI:
            modeName = PAYMENT_SCREENS.upi
            break
          case PAYMENT_TYPE.WALLET:
            modeName = PAYMENT_SCREENS.wallet
            break
          case PAYMENT_TYPE.NB:
            modeName = PAYMENT_SCREENS.netbanking
            break
          case PAYMENT_TYPE.EMI:
            modeName = 'jiopayfinancehub'
            break
          case PAYMENT_TYPE.PAY_LATER:
            modeName = PAYMENT_SCREENS.paylater
            break
          case PAYMENT_TYPE.SODEXO:
            modeName = PAYMENT_SCREENS.sodexo
            break
          case PAYMENT_TYPE.CORP_NB:
            modeName = MERGE_NB_CNB ? PAYMENT_SCREENS.netbanking : PAYMENT_SCREENS.corporateNetbanking
            break
          default:
            break
        }
        return modeName
      })
      return payments
    },
    isCardAllowed(cardType: string, scheme: string) {
      let isCardAllowed = true
      const isSubscriptionEnabled = self.merchant.subscription.isEnabled
      const [cardPaymentMode]: any = self.merchant.allowedPaymentModes?.filter((item: any) => {
        return isSubscriptionEnabled
          ? Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD_SUBSCRIPTION
          : Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD
      })
      if (cardPaymentMode) {
        if (cardPaymentMode?.cardType?.length > 0) {
          isCardAllowed = cardPaymentMode.cardType.includes(Number(cardType))
        }
      } else {
        const [cardPaymentMode]: any = self.merchant?.notAllowedPaymentModes?.filter((item: any) => {
          return isSubscriptionEnabled
            ? Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD_SUBSCRIPTION
            : Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD
        })
        if (cardPaymentMode) {
          isCardAllowed = !cardPaymentMode?.cardType?.includes(Number(cardType))
        }
      }
      if (isCardAllowed) {
        isCardAllowed = self.merchant.allowedCards.some((item) => item.type === cardType && item.scheme === scheme)
      }
      return isCardAllowed
    },
    isMerchantBanksAvailable(type: number) {
      if (type === PAYMENT_MODE_SUBTYPES.NB) {
        const [bankPaymentMode]: any = self.merchant.allowedPaymentModes?.filter((item: any) => {
          return Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.NB
        })
        return bankPaymentMode?.bankId?.length ? true : false
      } else if (type === PAYMENT_MODE_SUBTYPES.WALLET) {
        const [walletPaymentMode]: any = self.merchant.allowedPaymentModes?.filter((item: any) => {
          return Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.WALLET
        })
        return walletPaymentMode?.bankId?.length ? true : false
      }
      const [bankPaymentMode]: any = self.merchant.allowedPaymentModes?.filter((item: any) => {
        return Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.NB
      })
      return bankPaymentMode?.bankId?.length ? true : false
    },
    getCardNumber(paymentType: string) {
      if (paymentType === 'Card') {
        const [paymentMethod] = self.transaction.paymentMethod.slice(-1)
        const cardDetails = paymentMethod as CardType
        const number = String(cardDetails.number)
        let hideNum = []
        for (let i = 0; i < number.length; i++) {
          if (i < number.length - 4) {
            if (i % 4 === 3) {
              hideNum.push('x ')
            } else {
              hideNum.push('x')
            }
          } else {
            hideNum.push(number[i])
          }
        }
        return hideNum.join('')
      } else if (paymentType === 'UPI') {
        const [paymentMethod] = self.transaction.paymentMethod.slice(-1)
        const upiDetails = paymentMethod as UPIType
        return upiDetails.vpa
      }
      return ''
    },
    getFrequency(frequency: number) {
      return SUBSCRIPTION_FREQUENCY[frequency] || ''
    },
    getSubscriptionRule() {
      return SUBSCRIPTION_RULE[self.merchant.subscription.ruleAmount ?? 'MAX'] ?? 'Maximum'
    },
    isSubscriptionAllowedVPA(vpa: string) {
      return true
      // const [, vpaProvider] = vpa.split('@')
      // return UPI_SUBSCRIPTION_ENABLED_LIST.includes(vpaProvider)
    },
    isSubscriptionTxn() {
      const [paymentMethod] = self.transaction.paymentMethod.slice(-1)
      const paymentType = paymentMethod && getType(paymentMethod).name
      let isSubscription
      if (paymentType === 'Card') {
        const cardDetails = paymentMethod as CardType
        isSubscription = cardDetails.isSubscription
      }
      console.log('isSubscriptionTxn', isSubscription)
      return isSubscription
    },
    isDCExternalScheme(card: string, schemeSubType: string) {
      const cardEMIList = self.merchant.preferences.cardEMIList.get(`${card}_${schemeSubType}`)
      const dcExternalEMIList = cardEMIList?.emiList?.filter(
        (item) => item.schemeType === EMI_SCHME_TYPE.EXTERNAL && item.schemeSubType === schemeSubType,
      )
      return dcExternalEMIList && dcExternalEMIList?.length > 0 ? true : false
    },
    isNativeUpiHasHigherRank() {
      if (self?.merchant?.allowedPaymentModes?.length > 0) {
        const nativeUpiRank = self?.merchant?.allowedPaymentModes.find((item) => item.methodSubType === '580')?.rank
        const upiRank = self?.merchant?.allowedPaymentModes.find((item) => item.methodSubType === '566')?.rank
        return Number(nativeUpiRank) <= Number(upiRank)
      }
      return true
    },
  }))
  .views((self) => ({
    getCardConvenienceData() {
      return {
        // card: {
        //   cardBin: bin,
        //   scheme: scheme,
        //   type: type,
        // },
        method: {
          type: PAYMENT_MODE_TYPE.PURCHASE,
          subType: PAYMENT_MODE_SUBTYPES.CARD,
        },
      }
    },
    getNBConvenienceData() {
      return {
        method: {
          type: PAYMENT_MODE_TYPE.PURCHASE,
          subType: PAYMENT_MODE_SUBTYPES.NB,
        },
      }
    },
    getWalletConvenienceData() {
      return {
        method: {
          type: PAYMENT_MODE_TYPE.PURCHASE,
          subType: PAYMENT_MODE_SUBTYPES.WALLET,
        },
      }
    },
    getCorpNBConvenienceData() {
      return {
        method: {
          type: PAYMENT_MODE_TYPE.PURCHASE,
          subType: PAYMENT_MODE_SUBTYPES.CORP_NB,
        },
      }
    },
    getConvenienceData(isOfferApplied: boolean) {
      return {
        entity: {
          initiatingEntityId: self?.transaction?.initiatingEntity?.entityId,
          application: self?.transaction?.id?.application,
          type: SC_ENTITY_TYPE,
          entityId: self?.merchant?.id,
        },
        amount: {
          grossAmount: !isOfferApplied
            ? self.getTransactionAmount()
            : Number(self.getTransactionAmount()) - self.transaction.appliedOffer.instantDiscountAmount,
        },
      }
    },
    getBankEMIID() {
      const [filteredOffer]: any = self.offer.filter((item: any) => item.code === self.transaction.offerCode)
      const [emi] = filteredOffer.emi
      return emi?.bankEmiId
    },
    isDirectPayment() {
      //If we receive cvv and vaultId and if merchant is supporting card payment then directly we have to make payment
      //If we receive bankid and if merchant is supporting NB then directly we have to make payment
      //If there is only one payment mode and if it NB and there is only one bank availabe then directly we have to make payment.
      const isDirectPayment = self.transaction.isDirectPayment
      if (isDirectPayment) {
        if (self.transaction.cvv && self.transaction.token) {
          const [cardPaymentMode] = self.merchant.paymentModesSupported?.filter((item: any) => {
            return Number(item) === PAYMENT_MODE_SUBTYPES.CARD
          })
          if (cardPaymentMode) {
            return {
              isPay: true,
              type: String(PAYMENT_MODE_SUBTYPES.CARD),
              data: {
                bankId: '',
                cvv: self.transaction.cvv,
                vaultId: self.transaction.token,
              },
            }
          }
        } else if (!isEmpty(self.merchant.preferences.selectedVpa)) {
          const [upiMode] = self.merchant.paymentModesSupported?.filter((item: any) => {
            return Number(item) === PAYMENT_MODE_SUBTYPES.UPI
          })
          if (upiMode) {
            return {
              isPay: true,
              type: String(PAYMENT_MODE_SUBTYPES.UPI),
              data: {
                vpa: self.merchant.preferences.selectedVpa,
              },
            }
          }
        } else if (!isEmpty(self.merchant.preferences.selectedBankId)) {
          const [nbMode] = self.merchant.paymentModesSupported?.filter((item: any) => {
            return Number(item) === PAYMENT_MODE_SUBTYPES.NB
          })
          if (nbMode) {
            return {
              isPay: true,
              type: String(PAYMENT_MODE_SUBTYPES.NB),
              data: {
                bankId: self.merchant.preferences.selectedBankId,
              },
            }
          }
        } else if (!isEmpty(self.transaction.token) && isEmpty(self.transaction.cvv)) {
          const [foodCardPaymentMode] = self.merchant.paymentModesSupported?.filter((item: any) => {
            return Number(item) === PAYMENT_MODE_SUBTYPES.FOOD_CARD
          })
          if (foodCardPaymentMode) {
            return {
              isPay: true,
              type: String(PAYMENT_MODE_SUBTYPES.FOOD_CARD),
              data: {
                bankId: '',
                vaultId: self.transaction.token,
              },
            }
          }
        }
      } else if (self.merchant.isSinglePaymentModeAllowed()) {
        const paymentsSupported = self.getPaymentSupported(self.merchant.subscription.isEnabled)
        const [item] = paymentsSupported.map((item: string) => {
          return item
        })
        const paymentType = getPaymentType(item)
        if (paymentType === PAYMENT_MODE_SUBTYPES.NB) {
          const [netBankingPaymentMode]: any = self.merchant.allowedPaymentModes?.filter((item: any) => {
            return Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.NB
          })
          if (netBankingPaymentMode && netBankingPaymentMode?.bankId?.length === 1) {
            return {
              isPay: true,
              type: String(paymentType),
              data: {
                bankId: paymentType === PAYMENT_MODE_SUBTYPES.NB ? netBankingPaymentMode?.bankId : '',
              },
            }
          }
        } else if (paymentType === PAYMENT_MODE_SUBTYPES.CORP_NB && MERGE_NB_CNB) {
          const [corpNetBankingPaymentMode]: any = self.merchant.allowedPaymentModes?.filter((item: any) => {
            return Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CORP_NB
          })
          if (corpNetBankingPaymentMode && corpNetBankingPaymentMode?.bankId?.length === 1) {
            return {
              isPay: true,
              type: String(paymentType),
              data: {
                bankId: paymentType === PAYMENT_MODE_SUBTYPES.CORP_NB ? corpNetBankingPaymentMode?.bankId : '',
              },
            }
          }
        }
      }

      return {
        isPay: false,
        type: '',
      }
    },
    isValidBankEMIId(bankEmiId: string) {
      const [filteredOfferEMI]: any = self.offer.filter(
        (item: any) => item.code === self.transaction.offerCode && item.emi,
      )
      return (
        filteredOfferEMI?.emi?.length === 0 ||
        filteredOfferEMI?.emi?.map((item: any) => item.bankEmiId).includes(bankEmiId)
      )
    },
    getEMIOfferPaymentModes() {
      const [filteredOfferEMI]: any = self.offer.filter(
        (item: any) => item.code === self.transaction.offerCode && item.emi,
      )
      const bankIdList = filteredOfferEMI?.emi?.map((item: any) => item.bankEmiId)
      const offerCardEMIList = self.merchant.preferences.EMILList?.filter((item: any) =>
        bankIdList?.includes(item.bank),
      )
      const offerCardLessEMIList = self.merchant.preferences.cardLessEMIList.filter((item: any) =>
        bankIdList?.includes(item.bank),
      )
      const isDCOffers = offerCardEMIList?.some((item: any) => item.schemeSubType === EMI_CARDTYPE.DEBIT_CARD)
      const isCCOffers = offerCardEMIList?.some((item: any) => item.schemeSubType === EMI_CARDTYPE.CREDIT_CARD)
      const isCardLessOffers = offerCardLessEMIList?.some((item: any) => item.schemeSubType === EMI_CARDTYPE.CARDLESS)
      const creditEmiAvailable = self.getEmiPlanCount(EMI.CREDIT_CARD_ALL) > 0
      const debitEmiAvailable = self.getEmiPlanCount(EMI.DEBIT_CARD_ALL) > 0
      const cardlessEmiAvailable = self.getEmiPlanCount(EMI.CARDLESS) > 0
      const offerList = []
      const withoutOffersList = []
      isCCOffers
        ? offerList.push(EMI_CARDTYPE.CREDIT_CARD)
        : creditEmiAvailable && withoutOffersList.push(EMI_CARDTYPE.CREDIT_CARD)
      isDCOffers
        ? offerList.push(EMI_CARDTYPE.DEBIT_CARD)
        : debitEmiAvailable && withoutOffersList.push(EMI_CARDTYPE.DEBIT_CARD)
      isCardLessOffers
        ? offerList.push(EMI_CARDTYPE.CARDLESS)
        : cardlessEmiAvailable && withoutOffersList.push(EMI_CARDTYPE.CARDLESS)

      return {
        offerList,
        withoutOffersList,
      }
    },
    getCards() {
      const userCards = self.user.paymentMethod.filter((item) => getType(item).name === 'Card') as [CardType]
      const nonFoodCards = userCards.filter((item) => item.type && item.type !== CardTypes.FOODCARD)
      if (nonFoodCards && nonFoodCards.length > 0) {
        let savedCards = nonFoodCards.filter((item) => {
          return self.merchant.allowedCards.some((card) => card.type === item.subType && card.scheme === item.scheme)
        })
        if (self.merchant.allowedPaymentModes?.length > 0) {
          const isSubscriptionEnabled = self.merchant.subscription.isEnabled
          const [cardPaymentMethod] = self.merchant.allowedPaymentModes?.filter((item: any) => {
            return (
              (!isSubscriptionEnabled &&
                Number(item.methodType) === PAYMENT_MODE_TYPE.PURCHASE &&
                Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD) ||
              (isSubscriptionEnabled &&
                Number(item.methodType) === PAYMENT_MODE_TYPE.SUBSCRIPTION &&
                Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD_SUBSCRIPTION)
            )
          })

          if (cardPaymentMethod?.cardType?.length > 0) {
            savedCards = nonFoodCards.filter((item: any) => {
              return cardPaymentMethod?.cardType?.includes(Number(item.subType))
            })
          }
        } else if (self.merchant.notAllowedPaymentModes?.length > 0) {
          const [cardPaymentMethod] = self.merchant.notAllowedPaymentModes?.filter((item: any) => {
            return (
              Number(item.methodType) === PAYMENT_MODE_TYPE.PURCHASE &&
              Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD
            )
          })

          if (cardPaymentMethod) {
            savedCards = nonFoodCards.filter((item: any) => {
              return !cardPaymentMethod?.cardType?.includes(Number(item.subType))
            })
          }
        }
        const cards = savedCards?.map(
          (item) =>
          ({
            id: item.id,
            token: item.token,
            cardNumber: String(item.number),
            logo: item.issuerLogo,
            name: item.nickname,
            expiry: `${item.expmon}/${item.expyr}`,
            instrId: String(item.id.toString),
            scheme: item.scheme,
            isCvvLess: item.isCvvLess,
            isEmiEligible: item.isEMIEligible,
            type: item.type,
            subtype: item.subType,
            isExpired: isCardExpired(item.expmon, item.expyr),
            offerEligibility: item.offerEligibility,
            isShowOfferFooter: false,
          } as CardData),
        )
        if (self.transaction.isOfferApplied) {
          const offerEligibileItem = cards.filter((item: any) => item.offerEligibility === 'APPLICABLE')
          const eligibileItemCount = offerEligibileItem.length
          if (eligibileItemCount !== 0 && eligibileItemCount !== cards.length) {
            const lastItem: any = offerEligibileItem[eligibileItemCount - 1]
            lastItem.isShowOfferFooter = true
            offerEligibileItem[eligibileItemCount - 1] = lastItem

            const nonEligibleItems = cards.filter((item: any) => item.offerEligibility !== 'APPLICABLE')

            var retData: any = []
            if (offerEligibileItem.length) {
              retData = [
                {
                  title: 'Offer Eligibile',
                  type: 'HEADER',
                },
                ...offerEligibileItem,
              ]
            }
            if (nonEligibleItems.length > 0) {
              retData = [
                ...retData,
                {
                  title: 'Offer Not Eligibile',
                  type: 'HEADER',
                },
                ...offerEligibileItem,
              ]
            }
            return retData
          }
        }
        console.log('getCards cards', cards)
        return cards
      }

      return []
    },
    getEMISavedCards() {
      const userCards = self.user.paymentMethod.filter((item) => getType(item).name === 'Card') as [CardType]
      if (userCards && userCards.length > 0) {
        const eligibleCards = userCards.filter((item) => item.isEMIEligible && item.subType === CARD_TYPE.CREDIT_CARD)

        const emiEligibleCards = eligibleCards.map(
          (item) =>
          ({
            id: item.id,
            token: item.token,
            cardNumber: String(item.number),
            logo: item.issuerLogo,
            name: item.nickname,
            expiry: `${item.expmon}/${item.expyr}`,
            instrId: String(item.id.toString),
            scheme: item.scheme,
            isEmiEligible: item.isEMIEligible,
            type: item.type,
            subtype: item.subType,
            isExpired: isCardExpired(item.expmon, item.expyr),
          } as CardData),
        )

        console.log('emiEligibleCards', emiEligibleCards)

        const nonEligibleCards = userCards.filter(
          (item) => !item.isEMIEligible && item.subType === CARD_TYPE.CREDIT_CARD,
        )
        const emiNonEligibleCards = nonEligibleCards.map(
          (item) =>
          ({
            id: item.id,
            token: item.token,
            cardNumber: String(item.number),
            logo: item.issuerLogo,
            name: item.nickname,
            expiry: `${item.expmon}/${item.expyr}`,
            instrId: String(item.id.toString),
            scheme: item.scheme,
            isEmiEligible: item.isEMIEligible,
            type: item.type,
            subtype: item.subType,
            isExpired: isCardExpired(item.expmon, item.expyr),
          } as CardData),
        )
        return {
          emiCards: emiEligibleCards,
          nonEMICards: emiNonEligibleCards,
        }
      }

      return []
    },
    getDebitCardEMIList() {
      const emiList = self.merchant.preferences.EMILList
      const emiBanks = emiList.filter(
        (item) => item.schemeSubType === EMI_CARDTYPE.DEBIT_CARD || item.schemeSubType === EMI_CARDTYPE.CARDLESS_EMI,
      )
      const dcBanks = emiBanks.filter(
        (item: any, index) => emiBanks.findIndex((cItem: any) => cItem.bank === item.bank) === index,
      )
      const bankList = dcBanks.map((item) => {
        return {
          id: item.bank,
          text: item.bankName,
          imageUrl: item.bankImageUrl,
          isDirectTenurePlan: item.isDirectTenurePlan,
          schemeSubType: item.schemeSubType,
          scheme: item.scheme,
          schemeType: item.schemeType,
          position: 0,
          rank: 0,
        }
      })
      return bankList
    },
    getOfferDetails(): any {
      if (self.transaction.isOfferApplied) {
        const offerData = self.offer.filter((item: any) => item.code === self.transaction.offerCode)
        return { length: self.offer.length, selectedData: offerData[0] }
      } else {
        const offerData = self.offer.filter((item: any) => item.eligibility === 1)
        return { length: offerData.length, selectedData: null }
      }
    },
    getOfferData(): any {
      return self.offer
        .filter((filteredItem: any) => filteredItem.eligibility === 1)
        .map((item: any) => {
          return {
            id: item.code,
            code: item.code,
            title: item.name,
            paymentModeSubType: item.paymentModeSubType,
            paymentModeType: item.paymentModeType,
            offerType: item.offerType,
            subTitle: item.description,
            imageUrl: item.logo,
            isNoCostEmiOffer: item?.instantDiscountUnit?.type === 3,
            offerValue:
              item.offerType === OFFER_TYPE.INSTANT
                ? item?.instantDiscountAmount?.amount
                : item?.cashBackAmount?.amount,
            offerDetail: item?.termsConditions,
          }
        })
    },
    getOffersOfPaymentMode(pmType: any, pmSubType: any): any {
      if (!pmType || !pmSubType) {
        return []
      }
      const fileterdOffers =
        self.offer?.filter(
          (item: any) =>
            item.eligibility === 1 &&
            item.paymentModeType === pmType &&
            (pmType === pmSubType || item.paymentModeSubType === pmSubType),
        ) ?? []
      const retData = fileterdOffers.map((item: any) => {
        return {
          id: item.code,
          code: item.code,
          title: item.name,
          paymentModeSubType: item.paymentModeSubType,
          paymentModeType: item.paymentModeType,
          offerType: item.offerType,
          subTitle: item.description,
          imageUrl: item.logo,
          offerValue:
            item.offerType === OFFER_TYPE.INSTANT ? item?.instantDiscountAmount?.amount : item?.cashBackAmount?.amount,
          offerDetail: item?.termsConditions,
        }
      })
      return retData
    },
    getFoodCards() {
      const userCards = self.user.paymentMethod.filter((item) => getType(item).name === 'Card') as [CardType]
      const foodCards = userCards.filter((item) => item.type && item.type === CardTypes.FOODCARD)
      if (foodCards && foodCards.length > 0) {
        const cards = foodCards.map(
          (item) =>
          ({
            id: item.id,
            token: item.token,
            cardNumber: String(item.number),
            logo: item.issuerLogo,
            name: item.nickname,
            expiry: `${item.expmon}/${item.expyr}`,
            instrId: String(item.id.toString),
            scheme: item.scheme,
            isEmiEligible: item.isEMIEligible,
            type: item.type,
            subtype: item.subType,
            isExpired: isCardExpired(item.expmon, item.expyr),
            offerEligibility: item.offerEligibility,
            cardBalance: item.cardBalance,
            isShowOfferFooter: false,
          } as CardData),
        )
        if (self.transaction.isOfferApplied) {
          const offerEligibileItem = cards.filter((item: any) => item.offerEligibility === 'APPLICABLE')
          const eligibileItemCount = offerEligibileItem.length
          if (eligibileItemCount !== 0 && eligibileItemCount !== cards.length) {
            const lastItem: any = offerEligibileItem[eligibileItemCount - 1]
            lastItem.isShowOfferFooter = true
            offerEligibileItem[eligibileItemCount - 1] = lastItem

            const nonEligibleItems = cards.filter((item: any) => item.offerEligibility !== 'APPLICABLE')

            var retData: any = []
            if (offerEligibileItem.length) {
              retData = [
                {
                  title: 'Offer Eligibile',
                  type: 'HEADER',
                },
                ...offerEligibileItem,
              ]
            }
            if (nonEligibleItems.length > 0) {
              retData = [
                ...retData,
                {
                  title: 'Offer Not Eligibile',
                  type: 'HEADER',
                },
                ...offerEligibileItem,
              ]
            }
            return retData
          }
        }
        return cards
      }
      return []
    },
  }))
  .actions((self) => ({
    isOfferApplied(pmSubType: number, pmType: number = PAYMENT_MODE_TYPE.PURCHASE) {
      const applicable =
        self.transaction.isOfferApplied &&
        self.transaction.selectedOfferPMSubType === pmSubType &&
        self.transaction.selectedOfferPMType === pmType
      if (!applicable) {
        self.transaction.amount.payableAmount = self.transaction.amount.netAmount
      }
      return applicable
    },
    removeOffer() {
      self.transaction.amount.payableAmount = self.transaction.amount.netAmount
    },
    getNoBalanceCardTokens() {
      const savedCards = self.getFoodCards()
      let noBalanceCardTokens = []
      if (savedCards?.length > 0) {
        //Balance available cards
        const cardBalanceCards = savedCards.filter((card: CardData) => card?.cardBalance?.balance)
        //Max Allowed cards to fetch balance
        const MAX_ALLOWED_CARDS = savedCards.length >= 2 ? 2 : savedCards.length
        if (cardBalanceCards?.length < MAX_ALLOWED_CARDS) {
          //Balance not available cards
          const noBalanceCards = savedCards
            .filter((card: CardData) => !card?.cardBalance?.balance)
            .slice(0, MAX_ALLOWED_CARDS - cardBalanceCards.length)
          let card = 0
          while (card < MAX_ALLOWED_CARDS - cardBalanceCards.length) {
            noBalanceCardTokens.push(noBalanceCards[card]?.token)
            card++
          }
        }
      }
      return noBalanceCardTokens
    },
  }))
  .actions((self) => ({
    confirmPaymentData() {
      return {
        transaction: {
          idempotentKey: getRandomAlphaNumString(8),
          currency: self?.transaction?.amount?.currency,
          invoice: self?.transaction?.id?.invoiceno,
          mode: self?.transaction?.mode,
          captureMethod: CAPTURE_METHOD,
          method: {
            type: TRANSACTION_METHOD,
          },
          livemode: LIVE_MODE,
          application: self?.transaction?.id?.application,
          intentId: self?.transaction?.id.intentId,
          initiatingEntityTimestamp: self?.transaction?.initiatingEntity?.timeStamp,
          initiatingEntity: {
            entityId: self?.transaction?.initiatingEntity?.entityId,
            // callbackUrl: self?.transaction?.initiatingEntity?.callbackUrl,
          },
          responseTime: self?.transaction?.timestamp,
        },
        amount: {
          ...(self?.transaction?.amount?.grossAmount !== '0' && {
            grossAmount: Number(self?.transaction?.amount?.grossAmount),
          }),
          netAmount: Number(self?.transaction?.amount?.netAmount),
        },
        payer: {
          mobile: {
            countryCode: self?.transaction?.payer?.countryCode,
            number: self?.transaction?.payer?.number || null,
          },
          userId: self?.user?.id,
          gstIn: self.transaction.payer.gstIn ?? '',
          gstInvoice: self.transaction.payer.gstInvoice ?? '',
          gstConsent: self.transaction.payer.gstConsent ?? '',
          pan: self.transaction.payer.pan ?? '',
          ...(self?.user?.email && { email: self?.user?.email }),
          ...(self?.transaction?.payer?.type !== 0 && { type: self?.transaction?.payer?.type }),
        },
        payee: {
          type: self?.transaction?.payee?.type,
          terminalId: self?.transaction?.payee?.terminalId,
          merchantId: self.merchant.id,
          name: self?.transaction?.payee?.name,
        },
      }
    },
    getNoCostEMIAllPlans() {
      const data: any = []
      let noCostEMIList: any = []
      self.merchant.preferences.EMILList.filter((element) => {
        if (element.schemeType === EMI_SCHME_TYPE.EXTERNAL) {
          const products = element.product.filter(
            (product: any) =>
              product.emiPlan.allowZeroCost === EMI_TYPES.NO_COST ||
              product.emiPlan.allowZeroCost === EMI_TYPES.LOW_COST,
          )
          return products?.length > 0
        } else {
          return Number(element.discount) !== 0
        }
      }).forEach((item: any) => {
        const emiItem = noCostEMIList.find((emiElement: any) => {
          const [bankName] = Object.keys(emiElement)
          return item?.bankName === bankName
        })
        if (emiItem) {
          const [bankName] = Object.keys(emiItem)
          emiItem[bankName].push(item)
        } else {
          noCostEMIList.push({
            [item.bankName]: [item],
          })
        }
      })
      const isOfferApplied = self.isOfferApplied(PAYMENT_MODE_SUBTYPES.CARD, PAYMENT_MODE_TYPE.EMI)
      let bankIdList: any = []
      if (isOfferApplied) {
        const [filteredOfferEMI]: any = self.offer.filter(
          (item: any) => item.code === self.transaction.offerCode && item.emi,
        )
        bankIdList = filteredOfferEMI?.emi?.map((item: any) => item.bankEmiId)
      }
      console.log('noCostEMIList', noCostEMIList)
      noCostEMIList.forEach((element: any) => {
        const [bankName] = Object.keys(element)
        const emiList = element[bankName]
        const fromEMIList = emiList.map((emi: any) => {
          const isOfferApplicable = bankIdList?.includes(emi.emiBankId) ?? false
          const tenureId = emi.tenure
          const tenureVal = emi.tenure.substring(0, tenureId.length - 1)
          const tenurePeriod =
            emi.tenure.substring(tenureId.length - 1) === 'M'
              ? Number(tenureVal) > 1
                ? 'Months'
                : 'Month'
              : Number(tenureVal) > 1
                ? 'Years'
                : 'Year'
          const emiTenure = `${tenureVal} ${tenurePeriod}`

          const emiDetails = emi?.product?.map((product: any) => {
            console.log('emiDetails', product)
            return {
              productCode: product.productId,
              itemValue: product.productAmount,
              interest: product.emiPlan.bankInterestRate,
              emiDiscount: product.emiPlan.productDiscount,
              additionalCashback: product.emiPlan.additionalCashback,
            }
          })

          return {
            emi: emi.value,
            tenureId: emi.tenure,
            interest: emi.interest,
            interestRate: emi.interestRate,
            amount: emi.grossAmount,
            isOfferEligible: isOfferApplicable,
            scheme: emi.scheme,
            schemeType: emi.schemeType,
            instantDiscountPercentage: emi.discount,
            val: `₹${emi.value} X ${emiTenure} | ${emi.interestRate}% p.a`,
            emiDetails: emiDetails,
          }
        })
        data.push({
          header: { emiBankName: bankName },
          data: fromEMIList,
        })
      })
      return data
    },
    getNoCostCCEMIPlans() {
      const data: any = []
      let noCostEMIList: any = []
      self.merchant.preferences.EMILList.filter((element) => {
        if (element.schemeSubType === EMI_CARDTYPE.CREDIT_CARD) {
          if (element.schemeType === EMI_SCHME_TYPE.EXTERNAL) {
            const products = element.product.filter(
              (product: any) =>
                product.emiPlan.allowZeroCost === EMI_TYPES.NO_COST ||
                product.emiPlan.allowZeroCost === EMI_TYPES.LOW_COST,
            )
            return products?.length > 0
          }
          return Number(element.discount) !== 0
        }
        return false
      }).forEach((item: any) => {
        const emiItem = noCostEMIList.find((emiElement: any) => {
          const [bankName] = Object.keys(emiElement)
          return item.bankName === bankName
        })
        if (emiItem) {
          const [bankName] = Object.keys(emiItem)
          emiItem[bankName].push(item)
        } else {
          noCostEMIList.push({
            [item.bankName]: [item],
          })
        }
      })

      console.log('noCostEMIList', noCostEMIList)

      const isOfferApplied = self.isOfferApplied(PAYMENT_MODE_SUBTYPES.CARD, PAYMENT_MODE_TYPE.EMI)
      let bankIdList: any = []
      if (isOfferApplied) {
        const [filteredOfferEMI]: any = self.offer.filter(
          (item: any) => item.code === self.transaction.offerCode && item.emi,
        )
        console.log('filteredOfferEMI', filteredOfferEMI)
        bankIdList = filteredOfferEMI?.emi?.map((item: any) => item.bankEmiId)
      }
      console.log('bankIdList', bankIdList)
      noCostEMIList.forEach((element: any) => {
        const [bankName] = Object.keys(element)
        const emiList = element[bankName]
        const fromEMIList = emiList.map((emi: any) => {
          const isOfferApplicable = bankIdList?.includes(emi.emiBankId) ?? false
          const tenure = emi.tenure
          const tenureVal = emi.tenure.substring(0, tenure.length - 1)
          const tenurePeriod =
            emi.tenure.substring(tenure.length - 1) === 'M'
              ? Number(tenureVal) > 1
                ? 'Months'
                : 'Month'
              : Number(tenureVal) > 1
                ? 'Years'
                : 'Year'
          const emiTenure = `${tenureVal} ${tenurePeriod}`

          const emiDetails = emi?.product?.map((product: any) => {
            console.log('emiDetails', product)
            return {
              productCode: product.productId,
              itemValue: product.productAmount,
              interest: product.emiPlan.bankInterestRate,
              emiDiscount: product.emiPlan.productDiscount,
              additionalCashback: product.emiPlan.additionalCashback,
            }
          })

          return {
            emi: emi.value,
            tenureId: emi.tenure,
            interest: emi.interest,
            interestRate: emi.interestRate,
            amount: emi.grossAmount,
            scheme: emi.scheme,
            schemeType: emi.schemeType,
            isOfferEligible: isOfferApplicable,
            instantDiscountPercentage: emi.discount,
            val: `₹${emi.value} X ${emiTenure} | ${emi.interestRate}% p.a`,
            emiDetails: emiDetails,
          }
        })
        console.log('item32', fromEMIList)
        data.push({
          header: { emiBankName: bankName },
          data: fromEMIList,
        })
        console.log('data', data)
      })
      return data
    },
    getNoCostDCEMIPlans() {
      const data: any = []
      let noCostEMIList: any = []
      self.merchant.preferences.EMILList.filter((element) => {
        if (element.schemeSubType === EMI_CARDTYPE.DEBIT_CARD) {
          if (element.schemeType === EMI_SCHME_TYPE.EXTERNAL) {
            const products = element.product.filter(
              (product: any) =>
                product.emiPlan.allowZeroCost === EMI_TYPES.NO_COST ||
                product.emiPlan.allowZeroCost === EMI_TYPES.LOW_COST,
            )
            return products?.length > 0
          }
          return Number(element.discount) !== 0
        }
        return false
      }).forEach((item: any) => {
        const emiItem = noCostEMIList.find((emiElement: any) => {
          const [bankName] = Object.keys(emiElement)
          return item.bankName === bankName
        })
        if (emiItem) {
          const [bankName] = Object.keys(emiItem)
          emiItem[bankName].push(item)
        } else {
          noCostEMIList.push({
            [item.bankName]: [item],
          })
        }
      })

      console.log('noCostEMIList', noCostEMIList)

      const isOfferApplied = self.isOfferApplied(PAYMENT_MODE_SUBTYPES.CARD, PAYMENT_MODE_TYPE.EMI)
      let bankIdList: any = []
      if (isOfferApplied) {
        const [filteredOfferEMI]: any = self.offer.filter(
          (item: any) => item.code === self.transaction.offerCode && item.emi,
        )
        console.log('filteredOfferEMI', filteredOfferEMI)
        bankIdList = filteredOfferEMI?.emi?.map((item: any) => item.bankEmiId)
      }
      console.log('bankIdList', bankIdList)
      noCostEMIList.forEach((element: any) => {
        const [bankName] = Object.keys(element)
        const emiList = element[bankName]
        const fromEMIList = emiList.map((emi: any) => {
          const isOfferApplicable = bankIdList?.includes(emi.emiBankId) ?? false
          const tenure = emi.tenure
          const tenureVal = emi.tenure.substring(0, tenure.length - 1)
          const tenurePeriod =
            emi.tenure.substring(tenure.length - 1) === 'M'
              ? Number(tenureVal) > 1
                ? 'Months'
                : 'Month'
              : Number(tenureVal) > 1
                ? 'Years'
                : 'Year'
          const emiTenure = `${tenureVal} ${tenurePeriod}`

          const emiDetails = emi?.product?.map((product: any) => {
            console.log('emiDetails', product)
            return {
              productCode: product.productId,
              itemValue: product.productAmount,
              interest: product.emiPlan.bankInterestRate,
              emiDiscount: product.emiPlan.productDiscount,
              additionalCashback: product.emiPlan.additionalCashback,
            }
          })

          return {
            emi: emi.value,
            tenureId: emi.tenure,
            interest: emi.interest,
            interestRate: emi.interestRate,
            amount: emi.grossAmount,
            scheme: emi.scheme,
            schemeType: emi.schemeType,
            isOfferEligible: isOfferApplicable,
            instantDiscountPercentage: emi.discount,
            val: `₹${emi.value} X ${emiTenure} | ${emi.interestRate}% p.a`,
            emiDetails: emiDetails,
          }
        })
        console.log('item32', fromEMIList)
        data.push({
          header: { emiBankName: bankName },
          data: fromEMIList,
        })
        console.log('data', data)
      })
      return data
    },
    getDCEMIPlans(bankName: string) {
      const data: any = []
      let dcEMIList: any = []
      self.merchant.preferences.EMILList.filter(
        (element) =>
          (element.schemeSubType === EMI_CARDTYPE.DEBIT_CARD || element.schemeSubType === EMI_CARDTYPE.CARDLESS_EMI) &&
          element.bank === bankName,
      ).forEach((item: any) => {
        const emiItem = dcEMIList.find((emiElement: any) => {
          console.log('emiElement', emiElement)
          const [bank] = Object.keys(emiElement)
          return item.bank === bank
        })
        if (emiItem) {
          const [bank] = Object.keys(emiItem)
          emiItem[bank].push(item)
        } else {
          dcEMIList.push({
            [item.bank]: [item],
          })
        }
      })

      console.log('getDCEMIPlans dcEMIList', dcEMIList)

      dcEMIList.forEach((element: any) => {
        const [bank] = Object.keys(element)
        const emiList = element[bank]
        emiList.forEach((item: any, index: number) => {
          const tenure = item.tenure
          const tenureVal = item.tenure.substring(0, tenure.length - 1)
          const tenurePeriod =
            item.tenure.substring(tenure.length - 1) === 'M'
              ? Number(tenureVal) > 1
                ? 'Months'
                : 'Month'
              : Number(tenureVal) > 1
                ? 'Years'
                : 'Year'
          const emiTenure = `${tenureVal} ${tenurePeriod}`
          const emiDetails = item?.product?.map((product: any) => {
            return {
              productCode: product.productId,
              itemValue: product.productAmount,
              interest: product.emiPlan.bankInterestRate,
              emiDiscount: product.emiPlan.productDiscount,
              additionalCashback: product.emiPlan.additionalCashback,
            }
          })
          data.push({
            header: {
              emi: item.value,
              tenure: emiTenure,
              interestRate: item.interestRate,
              amount: item.grossAmount,
              schemeSubType: item.schemeSubType,
              instantDiscountPercentage: item.discount,
            },
            data: [
              {
                id: index + 1,
                emi: item.value,
                bank: item.bank,
                tenure: item.tenure,
                scheme: item.scheme,

                schemeType: item.schemeType,
                schemeSubType: item.schemeSubType,
                product: item.product,
                processingFees: {
                  type: item.processingFees.type,
                  value: item.processingFees.value,
                  amount: item.processingFees.amount,
                  tax: item.processingFees.tax,
                  taxPercentage: item.processingFees.taxPercentage,
                },
                convenienceFees: {
                  type: item.convenienceFees.type,
                  value: item.convenienceFees.value,
                  amount: item.convenienceFees.amount,
                  tax: item.convenienceFees.tax,
                  taxPercentage: item.convenienceFees.taxPercentage,
                },
                processingFee: Number(item.processingFees.amount).toFixed(2),
                processingFeeTax: item.processingFees.tax,
                convenienceFee: Number(item.convenienceFees.amount).toFixed(2),
                convenienceFeeTax: item.convenienceFees.tax,
                cashBack: item.cashBack,
                discount: item.discount,
                grossAmount: Number(item.grossAmount).toFixed(2),
                interestRate: item.interestRate,
                interest: Number(item.interest).toFixed(2),
                totalAmount: item.totalAmount,
                netAmount: item.netAmount,
                schemeNote: item.schemeNote,
                emiDetails: emiDetails,
                val: `₹${item.value} X ${item.tenure} - ${item.interest}% Interest`,
              },
            ],
          })
        })
      })
      return data
    },
    getCardEMIPlans(card: string, schemeSubType: string, emiType: string) {
      const data: any = []
      const isCardEMIExist = self.merchant.preferences.cardEMIList.has(`${card}_${schemeSubType}`)
      if (isCardEMIExist) {
        const cardEMIList = self.merchant.preferences.cardEMIList.get(`${card}_${schemeSubType}`)
        if (cardEMIList) {
          if (emiType === EMI.NO_COST_CARD_EMI) {
            const noCostEMIList = cardEMIList.emiList.filter((element) => {
              if (element.schemeSubType === schemeSubType) {
                if (element.schemeType === EMI_SCHME_TYPE.EXTERNAL) {
                  const products = element.product.filter(
                    (product: any) => product.emiPlan.allowZeroCost === EMI_TYPES.NO_COST,
                  )
                  return products?.length > 0
                }
                return Number(element.discount) !== 0
              }
              return false
            })
            noCostEMIList?.forEach((item: any, index: number) => {
              const object = data.find((obj: any) => obj.header.name === item.bankName)
              if (object) {
                object.data.push({
                  id: index + 1,
                  val: `₹${item.value} X ${item.tenure} - ${item.interestRate}% Interest`,
                })
              } else {
                const tenure = item.tenure
                const tenureVal = item.tenure.substring(0, tenure.length - 1)
                const tenurePeriod =
                  item.tenure.substring(tenure.length - 1) === 'M'
                    ? Number(tenureVal) > 1
                      ? 'Months'
                      : 'Month'
                    : Number(tenureVal) > 1
                      ? 'Years'
                      : 'Year'
                const emiTenure = `${tenureVal} ${tenurePeriod}`
                const emiDetails = item?.product?.map((product: any) => {
                  return {
                    productCode: product.productId,
                    itemValue: product.productAmount,
                    interest: product.emiPlan.bankInterestRate,
                    emiDiscount: product.emiPlan.productDiscount,
                    subventionCashbackDiscount: product.emiPlan.subventionCashbackDiscount,
                    additionalCashback: product.emiPlan.additionalCashback,
                  }
                })
                data.push({
                  header: {
                    emi: item.value,
                    tenure: emiTenure,
                    interestRate: item.interestRate,
                    amount: item.grossAmount,
                    schemeSubType: item.schemeSubType,
                    instantDiscountPercentage: item.discount,
                  },
                  data: [
                    {
                      id: index + 1,
                      emi: item.value,
                      bank: item.bank,
                      tenure: item.tenure,
                      metadata: item.metadata,
                      scheme: item.scheme,
                      schemeType: item.schemeType,
                      schemeSubType: item.schemeSubType,
                      product: item.product,
                      processingFees: {
                        type: item.processingFees.type,
                        value: item.processingFees.value,
                        amount: item.processingFees.amount,
                        tax: item.processingFees.tax,
                        taxPercentage: item.processingFees.taxPercentage,
                      },
                      convenienceFees: {
                        type: item.convenienceFees.type,
                        value: item.convenienceFees.value,
                        amount: item.convenienceFees.amount,
                        tax: item.convenienceFees.tax,
                        taxPercentage: item.convenienceFees.taxPercentage,
                      },
                      processingFee: Number(item.processingFees.amount).toFixed(2),
                      processingFeeTax: item.processingFees.tax,
                      convenienceFee: Number(item.convenienceFees.amount).toFixed(2),
                      convenienceFeeTax: item.convenienceFees.tax,
                      cashBack: item.cashBack,
                      discount: item.discount,
                      grossAmount: Number(item.grossAmount).toFixed(2),
                      interestRate: item.interestRate,
                      interest: Number(item.interest).toFixed(2),
                      totalAmount: item.totalAmount,
                      netAmount: item.netAmount,
                      schemeNote: item.schemeNote,
                      emiDetails: emiDetails,
                      val: `₹${item.value} X ${item.tenure} - ${item.interest}% Interest`,
                    },
                  ],
                })
              }
            })
          } else if (emiType === EMI.LOW_COST_CARD_EMI) {
            const lowCostEMIList = cardEMIList.emiList.filter((element) => {
              if (element.schemeSubType === schemeSubType) {
                const products = element.product.filter(
                  (product: any) => product.emiPlan.allowZeroCost === EMI_TYPES.LOW_COST,
                )
                return products?.length > 0
              }
              return false
            })
            lowCostEMIList?.forEach((item: any, index: number) => {
              const object = data.find((obj: any) => obj.header.name === item.bankName)
              if (object) {
                object.data.push({
                  id: index + 1,
                  val: `₹${item.value} X ${item.tenure} - ${item.interestRate}% Interest`,
                })
              } else {
                console.log('item.totalAmount', item.grossAmount)
                const tenure = item.tenure
                const tenureVal = item.tenure.substring(0, tenure.length - 1)
                const tenurePeriod =
                  item.tenure.substring(tenure.length - 1) === 'M'
                    ? Number(tenureVal) > 1
                      ? 'Months'
                      : 'Month'
                    : Number(tenureVal) > 1
                      ? 'Years'
                      : 'Year'
                const emiTenure = `${tenureVal} ${tenurePeriod}`
                const emiDetails = item?.product?.map((product: any) => {
                  return {
                    productCode: product.productId,
                    itemValue: product.productAmount,
                    interest: product.emiPlan.bankInterestRate,
                    emiDiscount: product.emiPlan.productDiscount,
                    subventionCashbackDiscount: product.emiPlan.subventionCashbackDiscount,
                    additionalCashback: product.emiPlan.additionalCashback,
                  }
                })
                data.push({
                  header: {
                    emi: item.value,
                    tenure: emiTenure,
                    interestRate: item.interestRate,
                    amount: item.grossAmount,
                    schemeSubType: item.schemeSubType,
                    instantDiscountPercentage: item.discount,
                  },
                  data: [
                    {
                      id: index + 1,
                      emi: item.value,
                      bank: item.bank,
                      tenure: item.tenure,
                      metadata: item.metadata,
                      scheme: item.scheme,
                      schemeType: item.schemeType,
                      schemeSubType: item.schemeSubType,
                      product: item.product,
                      processingFees: {
                        type: item.processingFees.type,
                        value: item.processingFees.value,
                        amount: item.processingFees.amount,
                        tax: item.processingFees.tax,
                        taxPercentage: item.processingFees.taxPercentage,
                      },
                      convenienceFees: {
                        type: item.convenienceFees.type,
                        value: item.convenienceFees.value,
                        amount: item.convenienceFees.amount,
                        tax: item.convenienceFees.tax,
                        taxPercentage: item.convenienceFees.taxPercentage,
                      },
                      processingFee: Number(item.processingFee).toFixed(2),
                      processingFeeTax: item.processingFeeTax,
                      convenienceFee: Number(item.convenienceFee).toFixed(2),
                      convenienceFeeTax: item.convenienceFeeTax,
                      cashBack: item.cashBack,
                      discount: item.discount,
                      grossAmount: Number(item.grossAmount).toFixed(2),
                      interestRate: item.interestRate,
                      interest: Number(item.interest).toFixed(2),
                      totalAmount: item.totalAmount,
                      netAmount: item.netAmount,
                      schemeNote: item.schemeNote,
                      emiDetails: emiDetails,
                      val: `₹${item.value} X ${item.tenure} - ${item.interest}% Interest`,
                    },
                  ],
                })
              }
            })
          } else if (emiType === EMI.STANDARD_CARD_EMI) {
            const standardCostEMIList = cardEMIList.emiList.filter((element) => {
              if (element.schemeSubType === schemeSubType) {
                if (element.schemeType === EMI_SCHME_TYPE.EXTERNAL) {
                  const products = element.product.filter(
                    (product: any) =>
                      product.emiPlan.allowZeroCost !== EMI_TYPES.LOW_COST &&
                      product.emiPlan.allowZeroCost !== EMI_TYPES.NO_COST &&
                      product,
                  )
                  return products?.length > 0
                }
                return Number(element.discount) === 0
              }
              return false
            })
            console.log('noCostEMIList', standardCostEMIList)
            standardCostEMIList?.forEach((item: any, index: number) => {
              const object = data.find((obj: any) => obj.header.name === item.bankName)
              if (object) {
                object.data.push({
                  id: index + 1,
                  val: `₹${item.value} X ${item.tenure} - ${item.interestRate}% Interest`,
                })
              } else {
                console.log('item.totalAmount', item.grossAmount)
                const tenure = item.tenure
                const tenureVal = item.tenure.substring(0, tenure.length - 1)
                const tenurePeriod =
                  item.tenure.substring(tenure.length - 1) === 'M'
                    ? Number(tenureVal) > 1
                      ? 'Months'
                      : 'Month'
                    : Number(tenureVal) > 1
                      ? 'Years'
                      : 'Year'
                const emiTenure = `${tenureVal} ${tenurePeriod}`
                const emiDetails = item?.product?.map((product: any) => {
                  return {
                    productCode: product.productId,
                    itemValue: product.productAmount,
                    interest: product.emiPlan.bankInterestRate,
                    emiDiscount: product.emiPlan.productDiscount,
                    subventionCashbackDiscount: product.emiPlan.subventionCashbackDiscount,
                    additionalCashback: product.emiPlan.additionalCashback,
                  }
                })
                data.push({
                  header: {
                    emi: item.value,
                    tenure: emiTenure,
                    interestRate: item.interestRate,
                    amount: item.grossAmount,
                    schemeSubType: item.schemeSubType,
                    instantDiscountPercentage: item.discount,
                  },
                  data: [
                    {
                      id: index + 1,
                      emi: item.value,
                      bank: item.bank,
                      metadata: item.metadata,
                      tenure: item.tenure,
                      scheme: item.scheme,
                      schemeType: item.schemeType,
                      schemeSubType: item.schemeSubType,
                      product: item.product,
                      processingFees: {
                        type: item.processingFees.type,
                        value: item.processingFees.value,
                        amount: item.processingFees.amount,
                        tax: item.processingFees.tax,
                        taxPercentage: item.processingFees.taxPercentage,
                      },
                      convenienceFees: {
                        type: item.convenienceFees.type,
                        value: item.convenienceFees.value,
                        amount: item.convenienceFees.amount,
                        tax: item.convenienceFees.tax,
                        taxPercentage: item.convenienceFees.taxPercentage,
                      },
                      processingFee: Number(item.processingFee).toFixed(2),
                      processingFeeTax: item.processingFeeTax,
                      convenienceFee: Number(item.convenienceFee).toFixed(2),
                      convenienceFeeTax: item.convenienceFeeTax,
                      cashBack: item.cashBack,
                      discount: item.discount,
                      grossAmount: Number(item.grossAmount).toFixed(2),
                      interestRate: item.interestRate,
                      interest: Number(item.interest).toFixed(2),
                      totalAmount: item.totalAmount,
                      netAmount: item.netAmount,
                      schemeNote: item.schemeNote,
                      emiDetails: emiDetails,
                      val: `₹${item.value} X ${item.tenure} - ${item.interest}% Interest`,
                    },
                  ],
                })
              }
            })
          } else if (emiType === EMI.CARD_EMI) {
            cardEMIList.emiList.forEach((item: any, index: number) => {
              const object = data.find((obj: any) => obj.header.name === item.bankName)
              if (object) {
                object.data.push({
                  id: index + 1,
                  val: `₹${item.value} X ${item.tenure} - ${item.interestRate}% Interest`,
                })
              } else {
                console.log('item.totalAmount', item.grossAmount)
                const tenure = item.tenure
                const tenureVal = item.tenure.substring(0, tenure.length - 1)
                const tenurePeriod =
                  item.tenure.substring(tenure.length - 1) === 'M'
                    ? Number(tenureVal) > 1
                      ? 'Months'
                      : 'Month'
                    : Number(tenureVal) > 1
                      ? 'Years'
                      : 'Year'
                const emiTenure = `${tenureVal} ${tenurePeriod}`
                const emiDetails = item?.product?.map((product: any) => {
                  return {
                    productCode: product.productId,
                    itemValue: product.productAmount,
                    interest: '0', //PCI todo
                    emiDiscount: product.emiPlan.productDiscount,
                    additionalCashback: '0', //PCI todo
                  }
                })
                data.push({
                  header: {
                    emi: item.value,
                    tenure: emiTenure,
                    interestRate: item.interestRate,
                    amount: item.grossAmount,
                    schemeSubType: item.schemeSubType,
                    instantDiscountPercentage: '25', //PCI todo
                  },
                  data: [
                    {
                      id: index + 1,
                      emi: item.value,
                      emiBankId: item.bank,
                      tenureId: item.tenure,
                      metadata: item.metadata,
                      scheme: item.scheme,
                      schemeType: item.schemeType,
                      emiInterest: item.interest,
                      product: item.product,
                      emiProcessingFee: {
                        feeAddtnTaxAmount: item.processingFee.feeAddtnTaxAmount,
                        feeAddtnTaxPercent: item.processingFee.feeAddtnTaxPercent,
                        feeAmount: item.processingFee.feeAmount,
                        feeCgstAmount: item.processingFee.feeCgstAmount,
                        feeCgstPercent: item.processingFee.feeCgstPercent,
                        feeIgstAmount: item.processingFee.feeIgstAmount,
                        feeIgstPercent: item.processingFee.feeIgstPercent,
                        feePercent: item.processingFee.feePercent,
                        feeSgstAmount: item.processingFee.feeSgstAmount,
                        feeSgstPercent: item.processingFee.feeSgstPercent,
                        feeTotalGstAmount: item.processingFee.feeTotalGstAmount,
                        feeTotalGstPercent: item.processingFee.feeTotalGstPercent,
                        feeType: item.processingFee.feeType,
                        feeUgstAmount: item.processingFee.feeUgstAmount,
                        feeUgstPercent: item.processingFee.feeUgstPercent,
                      },
                      emiConvenienceFee: {
                        feeAddtnTaxAmount: item.convenienceFee.feeAddtnTaxAmount,
                        feeAddtnTaxPercent: item.convenienceFee.feeAddtnTaxPercent,
                        feeAmount: item.convenienceFee.feeAmount,
                        feeCgstAmount: item.convenienceFee.feeCgstAmount,
                        feeCgstPercent: item.convenienceFee.feeCgstPercent,
                        feeIgstAmount: item.convenienceFee.feeIgstAmount,
                        feeIgstPercent: item.convenienceFee.feeIgstPercent,
                        feePercent: item.convenienceFee.feePercent,
                        feeSgstAmount: item.convenienceFee.feeSgstAmount,
                        feeSgstPercent: item.convenienceFee.feeSgstPercent,
                        feeTotalGstAmount: item.convenienceFee.feeTotalGstAmount,
                        feeTotalGstPercent: item.convenienceFee.feeTotalGstPercent,
                        feeType: item.convenienceFee.feeType,
                        feeUgstAmount: item.convenienceFee.feeUgstAmount,
                        feeUgstPercent: item.convenienceFee.feeUgstPercent,
                      },
                      processingFee: Number(item.processingFees.amount).toFixed(2),
                      processingFeePercent: item.processingFee.feePercent,
                      processingFeeTax: item.processingFees.tax,
                      processingFeeTaxPercent: item.processingFees.taxPercentage,
                      convenienceFee: Number(item.convenienceFees.amount).toFixed(2),
                      convenienceFeePercent: item.convenienceFee.feePercent,
                      convenienceFeeTax: item.convenienceFees.tax,
                      convenienceFeeTaxPercent: item.convenienceFees.taxPercentage,
                      cashBackAmount: item.cashBackAmount,
                      grossAmount: Number(item.grossAmount).toFixed(2),
                      interestRate: item.interestRate,
                      interest: Number(item.interest).toFixed(2),
                      gstRate: item.processingFee.feeTotalGstPercent,
                      gst: item.processingFee.feeTotalGstAmount,
                      totalAmount: item.totalAmount,
                      netAmount: item.netAmount,
                      schemeNote: item.schemeNote,
                      emiDuration: item.duration,
                      emiDetails: emiDetails,
                      val: `₹${item.emi} X ${item.tenureId} - ${item.interestRate}% Interest`,
                    },
                  ],
                })
              }
            })
          }
        }
      }
      return data
    },
    getCardLessEMIPlans(bankId: string) {
      const data: any = []
      self.merchant.preferences.cardLessEMIList
        .filter((item: any) => item.bank === bankId)
        ?.forEach((item: any, index: number) => {
          const tenure = item.tenure
          const tenureVal = item.tenure.substring(0, tenure.length - 1)
          const tenurePeriod =
            item.tenure.substring(tenure.length - 1) === 'M'
              ? Number(tenureVal) > 1
                ? 'Months'
                : 'Month'
              : Number(tenureVal) > 1
                ? 'Years'
                : 'Year'
          const emiTenure = `${tenureVal} ${tenurePeriod}`
          const emiDetails = item?.product?.map((product: any) => {
            return {
              productCode: product.productId,
              itemValue: product.productAmount,
              interest: product.emiPlan.bankInterestRate,
              emiDiscount: product.emiPlan.productDiscount,
              additionalCashback: product.emiPlan.additionalCashback,
            }
          })
          data.push({
            header: {
              emi: item.value,
              tenure: emiTenure,
              interestRate: item.interestRate,
              amount: item.grossAmount,
              schemeSubType: item.schemeSubType,
              instantDiscountPercentage: item.discount,
            },
            data: [
              {
                id: index + 1,
                emi: item.value,
                bank: item.bank,
                tenure: item.tenure,
                scheme: item.scheme,

                schemeType: item.schemeType,
                schemeSubType: item.schemeSubType,
                product: item.product,
                processingFees: {
                  type: item.processingFees.type,
                  value: item.processingFees.value,
                  amount: item.processingFees.amount,
                  tax: item.processingFees.tax,
                  taxPercentage: item.processingFees.taxPercentage,
                },
                convenienceFees: {
                  type: item.convenienceFees.type,
                  value: item.convenienceFees.value,
                  amount: item.convenienceFees.amount,
                  tax: item.convenienceFees.tax,
                  taxPercentage: item.convenienceFees.taxPercentage,
                },
                processingFee: Number(item.processingFees.amount).toFixed(2),
                processingFeeTax: item.processingFees.tax,
                convenienceFee: Number(item.convenienceFees.amount).toFixed(2),
                convenienceFeeTax: item.convenienceFees.tax,
                cashBack: item.cashBack,
                discount: item.discount,
                grossAmount: Number(item.grossAmount).toFixed(2),
                interestRate: item.interestRate,
                interest: Number(item.interest).toFixed(2),
                totalAmount: item.totalAmount,
                netAmount: item.netAmount,
                schemeNote: item.schemeNote,
                emiDetails: emiDetails,
                val: `₹${item.value} X ${item.tenure} - ${item.interest}% Interest`,
              },
            ],
          })
        })

      return data
    },
    savedCardsBody() {
      return {
        entity: {
          initiatingEntityId: self?.transaction?.initiatingEntity?.entityId,
          application: self?.transaction?.id?.application,
          type: SC_ENTITY_TYPE,
          entityId: self?.merchant?.id,
        },
        user: {
          externalId: self?.user?.externalId,
          name: self?.user?.name,
        },
      }
    },
    deleteCardBody(isSavedVpa: any = false) {
      const cardType = isSavedVpa ? 'upiVpa' : 'card'
      return {
        entity: {
          initiatingEntityId: self?.transaction?.initiatingEntity?.entityId,
          application: self?.transaction?.id?.application,
          type: SC_ENTITY_TYPE,
          entityId: self?.merchant?.id,
        },
        user: {
          userId: SC_USER_ID,
          externalId: self?.user?.externalId,
          mobile: {
            countryCode: '91',
            number: self?.user?.mobileNumber,
          },
          name: self?.user?.name,
          nickName: self?.user?.firstName,
        },
        [cardType]: {
          name: '',
          audit: {
            status: DC_STATUS,
          },
        },
      }
    },
    deviceInfo() {
      return {
        type: getDeviceType(),
        os: getAppOs(),
        appVersion: AppConfig.appVersion,
        appName: AppConfig.appName,
        appId: AppConfig.appName.concat(AppConfig.appVersion),
        capability: null,
        sdkVersion: null,
        mobile: self.user.mobileNumber,
        location: {
          latitude: self?.client?.latitude,
          longitude: self?.client?.longitude,
          name: null,
        },
        userAgent: navigator.userAgent?.length > 250 ? navigator.userAgent?.substring(0, 250) : navigator.userAgent,
      }
    },
    getBrowserInfo() {
      const colorDepths = [48, 32, 24, 16, 15, 8, 4, 1]
      return {
        browserAcceptHeader: 'application/json',
        browserLanguage: navigator.language,
        browserScreenHeight: getScreenDimen().height,
        browserScreenWidth: getScreenDimen().width,
        browserTZ: new Date().getTimezoneOffset(),
        browserUserAgent:
          navigator.userAgent?.length > 250 ? navigator.userAgent?.substring(0, 250) : navigator.userAgent,
        browserIP: '',
        browserColorDepth: colorDepths.find((e) => e <= (getWindow()?.screen?.colorDepth ?? 16)) ?? 16,
        browserJavaEnabled: true,
        browserJavascriptEnabled: true,
        deviceChannel: getWindow()?.JioPaymentWebViewInterface ? '01' : '02',
        challengeWindowSize: '05',
        browserType: getOsName(),
        httpAcceptContent: 'accept-content',
      }
    },
    searchMerchantParams() {
      return {
        inputFilter: {
          mid: self?.merchant.id,
        },
        outputDomains: [MERCHANT_OUTPUT_DOMAIN, FINANCIAL_PROFILE],
        configParams: {
          mediaType: MERCHANT_MEDIA_TYPE,
        },
      }
    },
    getMerchantConfigParams() {
      return {
        mid: self?.merchant?.id,
        configType: MERCHANT_CONFIG_TYPE,
        status: MERCHANT_CONFIG_STATUS,
      }
    },
    binServiceParams() {
      return {
        inputMap: {
          APP_CODE: BIN_APP_CODE,
          OPERATION_CODE: BIN_OPERATION_CODE,
          PAN_LENGTH: BIN_CARD_LENGTH,
        },
      }
    },
    updateSimulatorResponse(parsedData: any) {
      const merchant = {
        ...self.merchant,
        id: Number(parsedData.merchantid),
      } as MerchantType
      updateToken(parsedData.appaccesstoken, parsedData.appidtoken)
      self.merchant = merchant
      const { checkout } = parsedData
      self.merchant.updateTemplate(checkout?.template)
      if (checkout) {
        self.merchant.isAllowedPaymentModesAvailable = checkout?.allowed ? true : false
      }
      self.merchant.updateAllowedPaymentModes(checkout?.allowed)
      self.merchant.updateNotAllowedPaymentModes(checkout?.notAllowed)
      self.merchant.updateMiscellaneous(checkout?.miscellaneous)

      self.transaction.amount.netAmount = parsedData.amount
      self.transaction.amount.grossAmount = parsedData.amount
      self.transaction.id.intentId = parsedData.intentid
      self.transaction.id.appaccesstoken = parsedData.appaccesstoken
      self.transaction.id.appidtoken = parsedData.appidtoken
      self.transaction.mandate.frequency = parsedData.frequency
      self.transaction.mandate.tillDate = parsedData.tillDate
      self.transaction.initiatingEntity.callbackUrl = parsedData.callbackUrl
      self.transaction.cvv = parsedData.cvv
      self.transaction.token = parsedData.vaultId
      if (parsedData?.vaultId) {
        self.transaction.isDirectPayment = true
      }
      self.transaction.expiry = parsedData.expiry
      self.config.isIntegration = parsedData.isIntegration
      const { brandColor, headingText, bodyBgColor, bodyTextColor } = parsedData
      console.log('parsedData1========>', parsedData)
      console.log('brandColor========>', brandColor)
      console.log('headingText========>', headingText)
      console.log('bodyBgColor========>', bodyBgColor)
      console.log('bodyTextColor========>', bodyTextColor)
      if (brandColor || headingText) {
        self.config.merchantTheme.isMerchantThemeEnabled = true
      } else {
        self.config.merchantTheme.isMerchantThemeEnabled = false
      }

      const merchantBrandColor = checkout?.template?.brandColor
      if (isValidColorCode(brandColor)) {
        self.config.merchantTheme.brandColor = brandColor as ColorOptions
      } else if (isValidColorCode(merchantBrandColor)) {
        self.config.merchantTheme.brandColor = merchantBrandColor as ColorOptions
      }
      const merchantHeadingText = checkout?.template?.headingText
      if (isValidColorCode(headingText)) {
        self.config.merchantTheme.headingText = headingText as ColorOptions
      } else if (isValidColorCode(merchantHeadingText)) {
        self.config.merchantTheme.headingText = merchantHeadingText as ColorOptions
      }

      const merchantBodyBgColor = checkout?.template?.bodyBgColor
      if (isValidColorCode(bodyBgColor)) {
        self.config.merchantTheme.bodyBgColor = bodyBgColor as ColorOptions
      } else if (isValidColorCode(merchantBodyBgColor)) {
        self.config.merchantTheme.bodyBgColor = merchantBodyBgColor as ColorOptions
      }

      const merchantBodyTextColor = checkout?.template?.bodyTextColor
      if (isValidColorCode(bodyTextColor)) {
        self.config.merchantTheme.bodyTextColor = bodyTextColor as ColorOptions
      } else if (isValidColorCode(merchantBodyTextColor)) {
        self.config.merchantTheme.bodyTextColor = merchantBodyTextColor as ColorOptions
      }

      //Updating payment headers
    },
    applyOfferData() {
      const filteredOffer: any = self.offer.filter((item: any) => item.code === self.transaction.offerCode)
      const offer = filteredOffer[0]
      const products = offer?.products ?? []

      const prodobjArray = products.map((item: any) => {
        return {
          categoryId1: item.categoryId1 || undefined,
          categoryId2: item.categoryId2 || undefined,
          categoryId3: item.categoryId3 || undefined,
          categoryId4: item.categoryId4 || undefined,
          categoryId5: item.categoryId5 || undefined,
          productId: item.productId || undefined,
        }
      })

      return {
        idempotentKey: getRandomAlphaNumString(8),
        initiatingEntityTimestamp: self?.transaction?.initiatingEntity?.timeStamp,
        selectionCriteria: {
          merchantId: self.merchant.id,
          offerPeriod: {
            timeDuration: offer.offerPeriod.timeDuration || undefined,
            startDate: offer.offerPeriod.startDate || undefined,
            endDate: offer.offerPeriod.endDate || undefined,
          },
          ...(prodobjArray.length > 0 && { product: prodobjArray }),
          method: {
            type: TRANSACTION_METHOD,
            subType: 5,
          },
          transactionAmount: {
            amount: self.transaction.amount.netAmount,
          },
        },
        offer: {
          code: offer.code || undefined,
          name: offer.name || undefined,
          description: offer.description || undefined,
          status: offer.status || undefined,
          eligibility: offer.eligibility || undefined,
          offerType: offer.offerType || undefined,
          startDate: offer.startDate || undefined,
          endDate: offer.endDate || undefined,
          instantDiscountAmount: offer.instantDiscountAmount || undefined,
          cashBackAmount: offer.cashBackAmount || undefined,
          instantDiscountUnit: offer.instantDiscountUnit || undefined,
          cashBackUnit: offer.cashBackUnit || undefined,
          termsConditions: offer.termsConditions || undefined,
          logo: offer.logo || undefined,
        },
        customer: {
          customerId: self.user.id || undefined,
        },
        initiatingEntity: {
          entityId: 3133,
        },
        intentId: self?.transaction?.id?.intentId,
        invoiceNumber: self?.transaction?.id?.invoiceno,
      }
    },
    updateSelectedOffer(code: any, offerPMType: number, offerPMSubType: number) {
      console.log('offerPaymentMode', offerPMType, offerPMSubType)
      self.transaction.offerCode = code
      self.transaction.selectedOfferPMType = offerPMType
      self.transaction.selectedOfferPMSubType = offerPMSubType
      self.transaction.isOfferApplied = true
      const offerData: any = self.offer.find((offerObj) => offerObj.code === code)
      self.transaction.appliedOffer.offerReferenceId = offerData?.referenceId
      self.transaction.appliedOffer.transactionAmount = Number(self.transaction.amount.netAmount)
      self.transaction.appliedOffer.instantDiscountAmount = offerData?.instantDiscountAmount.amount
      self.transaction.appliedOffer.offerCode = offerData?.code
      self.transaction.appliedOffer.cashBackAmount = offerData?.cashBackAmount.amount
    },
    resetOffer() {
      self.transaction.offerCode = ''
      self.transaction.isOfferApplied = false
    },
    getOfferBankIds() {
      const offerData = self.offer.filter((item: any) => item.code === self.transaction.offerCode)
      console.log(self.transaction.offerCode + '*****offerData: ', offerData[0].bankIds)
      return offerData[0].bankIds
    },
    getOffer() {
      const product =
        self.transaction.metadata.product?.length > 0
          ? self.transaction.metadata.product.map((item) => ({
            productId: item.productId ? item.productId : undefined,
            transactionAmount: item.transactionAmount,
            categoryId1: item.categoryId1 ? item.categoryId1 : undefined,
            categoryId2: item.categoryId2 ? item.categoryId2 : undefined,
            categoryId3: item.categoryId3 ? item.categoryId3 : undefined,
            categoryId4: item.categoryId4 ? item.categoryId4 : undefined,
            categoryId5: item.categoryId5 ? item.categoryId5 : undefined,
          }))
          : undefined
      return {
        idempotentKey: getRandomAlphaNumString(8),
        initiatingEntityTimestamp: self?.transaction?.initiatingEntity?.timeStamp,
        selectionCriteria: {
          merchantId: self.merchant.id,
          transactionAmount: {
            amount: self.transaction.amount.netAmount,
          },
          product,
        },
      }
    },
    offerValidate(bodayInfo: any, methodInfo: any) {
      const code = self.transaction.offerCode
      const offer: any = self.offer.find((item: any) => item.code === code)
      const product =
        self.transaction.metadata.product?.length > 0
          ? self.transaction.metadata.product.map((item) => ({
            productId: item.productId,
            transactionAmount: item.transactionAmount,
            categoryId1: item.categoryId1 ? item.categoryId1 : undefined,
            categoryId2: item.categoryId2 ? item.categoryId2 : undefined,
            categoryId3: item.categoryId3 ? item.categoryId3 : undefined,
            categoryId4: item.categoryId4 ? item.categoryId4 : undefined,
            categoryId5: item.categoryId5 ? item.categoryId5 : undefined,
          }))
          : undefined

      return {
        idempotentKey: getRandomAlphaNumString(8),
        intentId: self.transaction.id.intentId,
        initiatingEntityTimestamp: self?.transaction?.initiatingEntity?.timeStamp,
        selectionCriteria: {
          product,
          merchantId: self.merchant.id,
          transactionAmount: {
            amount: self.transaction.amount.netAmount,
          },
          method: methodInfo,
          ...bodayInfo,
        },
        offer: {
          code: offer.code || undefined,
        },
        customer: {
          customerId: self.user.id || undefined,
        },
      }
    },
    getCardLessEMIList() {
      const cardLessBanks = self.merchant.preferences.cardLessEMIList.filter(
        (item: any, index) =>
          self.merchant.preferences.cardLessEMIList.findIndex((cItem: any) => cItem.bank === item.bank) === index,
      )
      const cardLessEMIList: any = cardLessBanks.map((item) => {
        return {
          id: item.bank,
          text: item.bankName,
          imageUrl: item.bankImageUrl,
          scheme: item.scheme,
          tenure: item.tenure,
          schemeType: item.schemeType,
          schemeSubType: item.schemeSubType,
          position: 0,
          rank: 0,
          planSource: item.planSource,
        }
      })
      return cardLessEMIList
    },
    getCardLessEMIBank(bankId: string, tenure: string) {
      const [cardLessEMIBank] = self.merchant.preferences.cardLessEMIList.filter(
        (item: any) => item.bank === bankId && item.tenure === tenure,
      )
      const products = cardLessEMIBank.product.map((item: any) => {
        return {
          productId: item.productId,
          productValidationKey: item.productValidationKey,
          productValidationValue: item.productValidationValue,
        }
      })
      const params = {
        bank: cardLessEMIBank.bank,
        value: cardLessEMIBank.value,
        interestRate: cardLessEMIBank.interestRate,
        tenure: cardLessEMIBank.tenure,
        paymentType: cardLessEMIBank.paymentType,
        scheme: cardLessEMIBank.scheme,
        schemeSubType: cardLessEMIBank.schemeSubType,
        product: products,
      } as CardlessEMIType
      return params
    },
    getInstrumentInputData(id: number) {
      console.log('**** id: ', id)
      const [payLaterInputData] = self.merchant.preferences.payLaterList.toJSON()?.filter((item: PayLaterType) => {
        return item.id === `${id}`
      })
      return {
        id: payLaterInputData?.id,
        text: payLaterInputData?.name,
        imageUrl: payLaterInputData?.logo,
        inputData: payLaterInputData?.inputData,
      }
    },
    isCnbAllowed() {
      const isSubscriptionEnabled = self.merchant.subscription.isEnabled
      const isCorpNbAllowedInConfigApi = self.merchant.allowedPaymentConfigs.split('|').includes('620')
      const isCorpNbAllowedForTnx =
        self.merchant.allowedPaymentModes.length === 0 ||
        self.merchant.allowedPaymentModes.filter(
          (item: any) => item.methodType === '110' && item.methodSubType === '620',
        )?.length > 0
      const isCorpNbNotAllowedForTnx =
        self.merchant.notAllowedPaymentModes.length > 0 &&
        self.merchant.notAllowedPaymentModes.filter(
          (item: any) => item.methodType === '110' && item.methodSubType === '620',
        )?.length > 0
      return !isSubscriptionEnabled && isCorpNbAllowedInConfigApi && isCorpNbAllowedForTnx && !isCorpNbNotAllowedForTnx
    },
    isNbAllowed() {
      const isSubscriptionEnabled = self.merchant.subscription.isEnabled
      const isNbAllowedInConfigApi = self.merchant.allowedPaymentConfigs.split('|').includes('581')
      const isNbAllowedForTnx =
        self.merchant.allowedPaymentModes.length === 0 ||
        self.merchant.allowedPaymentModes.filter(
          (item: any) => item.methodType === '110' && item.methodSubType === '581',
        )?.length > 0
      const isNbNotAllowedForTnx =
        self.merchant.notAllowedPaymentModes.length > 0 &&
        self.merchant.notAllowedPaymentModes.filter(
          (item: any) => item.methodType === '110' && item.methodSubType === '581',
        )?.length > 0
      return !isSubscriptionEnabled && isNbAllowedInConfigApi && isNbAllowedForTnx && !isNbNotAllowedForTnx
    },
    getInstrumentsList(type: number) {
      if (type === PAYMENT_MODE_SUBTYPES.PAYLATER) {
        const payLaterList = self.merchant.preferences.payLaterList.toJSON()?.map((item: PayLaterType) => {
          return { id: item.id, text: item.name, imageUrl: item.logo, inputData: item.inputData }
        })
        if (payLaterList.length === 0) {
          return []
        } else {
          const filter = payLaterList
            .map((item: any) => {
              const inputData = item?.inputData ?? []
              const validationData = inputData.filter((item: any) => item.usage === 'validation')

              if (validationData.length > 0) {
                const amount = self.transaction.amount.netAmount
                const valResult = validationData
                  .map((itemData: any) => {
                    return {
                      validation: eval(`${amount} ${itemData.validationPattern} ${itemData.labelString}`),
                    }
                  })
                  .filter((item: any) => item.validation === false)
                if (valResult.length === 0) {
                  return item
                }
              }
            })
            .filter((item: any) => item !== undefined)
          const payList = filter.sort((a, b) => a.text?.localeCompare(b?.text ?? ''))
          return payList
        }
      } else if (type === PAYMENT_MODE_SUBTYPES.WALLET) {
        const walletsRetData: any = []
        const walletList = self.merchant.preferences.walletList.toJSON()?.map((item: WalletType) => {
          return { id: item.id, text: item.name, imageUrl: item.logo, isPopular: item.isPopular, rank: item.rank }
        })
        if (walletList.length === 0) {
          return []
        }

        if (self.merchant.allowedPaymentModes?.length > 0) {
          const [walletPaymentMode]: any = self.merchant.allowedPaymentModes?.filter((item: any) => {
            return Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.WALLET
          })
          if (walletPaymentMode && walletPaymentMode?.bankId?.length > 0) {
            const filterWalletList = walletList.filter((item: any) => {
              return walletPaymentMode?.bankId.includes(Number(item.id))
            })
            const others = filterWalletList.map((item: any) => {
              return {
                id: item.id,
                text: item.text,
                imageUrl: item?.imageUrl || '',
              }
            })
            if (others.length !== 0) {
              others.sort((a, b) => a.text?.localeCompare(b?.text ?? ''))
              walletsRetData.push({
                title: 'Other Wallets',
                data: others,
              })
              return walletsRetData
            }
          }
        } else if (self.merchant.notAllowedPaymentModes?.length > 0) {
          const [walletPaymentMode]: any = self.merchant.notAllowedPaymentModes?.filter((item: any) => {
            return Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.WALLET
          })
          if (walletPaymentMode && walletPaymentMode?.bankId?.length > 0) {
            const filterWalletList = walletList.filter((item: any) => {
              return !walletPaymentMode?.bankId.includes(Number(item.id))
            })

            const popular = filterWalletList
              ?.filter((item: any) => item.isPopular)
              .sort((a: any, b: any) => (a.rank > b.rank ? 1 : -1))
            if (popular.length !== 0) {
              walletsRetData.push({
                title: 'Popular Wallets',
                data: popular,
              })
            }

            const others = filterWalletList.map((item: any) => {
              return {
                id: item.id,
                text: item.text,
                imageUrl: item?.imageUrl || '',
              }
            })
            if (others.length !== 0) {
              others.sort((a, b) => a.text?.localeCompare(b?.text ?? ''))
              walletsRetData.push({
                title: 'Other Wallets',
                data: others,
              })
              return walletsRetData
            }
          }
        }
        const popular = walletList
          ?.filter((item: any) => item.isPopular)
          .sort((a: any, b: any) => (a.rank > b.rank ? 1 : -1))
        if (popular.length !== 0) {
          walletsRetData.push({
            title: 'Popular Wallets',
            data: popular,
          })
        }
        const others = walletList.map((item: any) => {
          return {
            id: item.id,
            text: item.text,
            imageUrl: item?.imageUrl || '',
          }
        })

        if (others.length !== 0) {
          others.sort((a, b) => a.text?.localeCompare(b?.text ?? ''))

          // if (self.transaction.isOfferApplied) {
          //   console.log('***** self.transaction.isOfferApplied: ', self.transaction.isOfferApplied)
          //   const offerData = self.offer.filter((item: any) => item.code === self.transaction.offerCode)
          //   const bankIds = offerData[0].bankIds
          //   console.log('**** bankIds: ', bankIds)
          //   const data = others.filter((item: any) => bankIds.includes(item.id))
          //   console.log('#### data: ', data)

          //   walletsRetData.push({
          //     title: 'Other Wallets',
          //     data: data,
          //   })
          // } else {
          walletsRetData.push({
            title: 'Other Wallets',
            data: others,
          })
          // }
        }

        return walletsRetData
      } else if (type === PAYMENT_MODE_SUBTYPES.FOOD_CARD) {
        const retData: any = []
        const foodCardList = self.merchant.preferences?.foodCardList
        if (foodCardList.length === 0) {
          return []
        }
        const getShortName: any = {
          'Punjab National Bank - Retail': 'PNB Bank',
          'Axis Bank - Retail': 'Axis Bank',
          'Yes Bank - Retail': 'YES Bank',
          'ICICI Bank - Retail': 'ICICI Bank',
          'State Bank of India': 'SBI Bank',
          'HDFC Bank - Retail': 'HDFC Bank',
          'Kotak Bank': 'Kotak Bank',
        }

        if (self.merchant.allowedPaymentModes?.length > 0) {
          const [foodCardPaymentMode]: any = self.merchant.allowedPaymentModes?.filter((item: any) => {
            return Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.FOOD_CARD
          })
          if (foodCardPaymentMode && foodCardPaymentMode?.bankId?.length > 0) {
            const filterFoodCardList = foodCardList.filter((item: any) => {
              return foodCardPaymentMode?.bankId.includes(Number(item.id))
            })
            const others = filterFoodCardList.map((item: any) => {
              return {
                id: item.id,
                text: getShortName[item.name] ?? item.name,
                imageUrl: item.logo,
                position: getImageLocation(item.id),
                rank: item.rank,
              }
            })
            if (others.length !== 0) {
              others.sort((a, b) => a.text?.localeCompare(b?.text ?? ''))
              retData.push({
                title: 'Other banks',
                data: others,
              })
              return retData
            }
          }
        } else if (self.merchant.notAllowedPaymentModes?.length > 0) {
          const [foodCardPaymentMode]: any = self.merchant.notAllowedPaymentModes?.filter((item: any) => {
            return Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.FOOD_CARD
          })
          if (foodCardPaymentMode && foodCardPaymentMode?.bankId?.length > 0) {
            const filterFoodCardList = foodCardList.filter((item: any) => {
              return !foodCardPaymentMode?.bankId.includes(Number(item.id))
            })
            const popular = filterFoodCardList
              .filter((item) => item.isPopular)
              .map((item: BankType) => ({
                id: item.id,
                text: getShortName[item.name] ?? item.name,
                imageUrl: item.logo,
                position: getImageLocation(item.id),
                rank: item.rank,
              }))
              .sort((a, b) => (a.rank > b.rank ? 1 : -1))

            if (popular.length !== 0) {
              retData.push({
                title: 'Popular banks',
                data: popular,
              })
            }
            const others = filterFoodCardList.map((item: any) => {
              return {
                id: item.id,
                text: getShortName[item.name] ?? item.name,
                imageUrl: item.logo,
                position: getImageLocation(item.id),
                rank: item.rank,
              }
            })
            if (others.length !== 0) {
              others.sort((a, b) => a.text?.localeCompare(b?.text ?? ''))
              retData.push({
                title: 'Other banks',
                data: others,
              })
              return retData
            }
          }
        }

        const popular = foodCardList
          .toJSON()
          .filter((item) => item.isPopular)
          .map((item: BankType) => ({
            id: item.id,
            text: getShortName[item.name] ?? item.name,
            imageUrl: item.logo,
            position: getImageLocation(item.id),
            rank: item.rank,
          }))
          .sort((a, b) => (a.rank > b.rank ? 1 : -1))
        if (popular.length !== 0) {
          retData.push({
            title: 'Popular banks',
            data: popular,
          })
        }
        const others = foodCardList.toJSON().map((item: BankType) => {
          return {
            id: item.id,
            text: item.name,
            imageUrl: item?.logo || '',
            position: getImageLocation(item.id),
          }
        })

        if (others.length !== 0) {
          others.sort((a, b) => a.text.localeCompare(b.text))
          // if (self.transaction.isOfferApplied) {
          //   const offerData = self.offer.filter((item: any) => item.code === self.transaction.offerCode)
          //   const bankIds = offerData[0].bankIds
          //   const data = others.filter((item: any) => bankIds.includes(item.id))

          //   retData.push({
          //     title: 'Other banks',
          //     data: data,
          //   })
          // } else {
          retData.push({
            title: 'Other banks',
            data: others,
          })
          // }
        }
        console.log('redData', retData)
        return retData
      } else if (type === PAYMENT_MODE_SUBTYPES.CORP_NB) {
        const retData: any = []
        const bankList = self.merchant.preferences?.corpBankList
        if (bankList.length === 0) {
          return []
        }
        const getShortName: any = {
          'Punjab National Bank - Retail': 'PNB Bank',
          'Axis Bank - Retail': 'Axis Bank',
          'Yes Bank - Retail': 'YES Bank',
          'ICICI Bank - Retail': 'ICICI Bank',
          'State Bank of India': 'SBI Bank',
          'HDFC Bank - Retail': 'HDFC Bank',
          'Kotak Bank': 'Kotak Bank',
        }

        if (self.merchant.allowedPaymentModes?.length > 0) {
          const [netBankingPaymentMode]: any = self.merchant.allowedPaymentModes?.filter((item: any) => {
            return Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CORP_NB
          })
          if (netBankingPaymentMode && netBankingPaymentMode?.bankId?.length > 0) {
            const filterBankList = bankList.filter((item: any) => {
              return netBankingPaymentMode?.bankId.includes(Number(item.id))
            })
            const others = filterBankList.map((item: any) => {
              return {
                id: item.id,
                text: getShortName[item.name] ?? item.name,
                imageUrl: item.logo,
                position: getImageLocation(item.id),
                rank: item.rank,
              }
            })
            if (others.length !== 0) {
              others.sort((a, b) => a.text?.localeCompare(b?.text ?? ''))
              retData.push({
                title: 'Other banks',
                data: others,
              })
              return retData
            }
          }
        } else if (self.merchant.notAllowedPaymentModes?.length > 0) {
          const [netBankingPaymentMode]: any = self.merchant.notAllowedPaymentModes?.filter((item: any) => {
            return Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CORP_NB
          })
          if (netBankingPaymentMode && netBankingPaymentMode?.bankId?.length > 0) {
            const filterBankList = bankList.filter((item: any) => {
              return !netBankingPaymentMode?.bankId.includes(Number(item.id))
            })

            const others = filterBankList.map((item: any) => {
              return {
                id: item.id,
                text: getShortName[item.name] ?? item.name,
                imageUrl: item.logo,
                position: getImageLocation(item.id),
                rank: item.rank,
              }
            })
            if (others.length !== 0) {
              others.sort((a, b) => a.text?.localeCompare(b?.text ?? ''))
              retData.push({
                title: 'Other banks',
                data: others,
              })
              return retData
            }
          }
        }

        const others = bankList.toJSON().map((item: BankType) => {
          return {
            id: item.id,
            text: item.name,
            imageUrl: item?.logo || '',
            position: getImageLocation(item.id),
          }
        })

        if (others.length !== 0) {
          others.sort((a, b) => a.text.localeCompare(b.text))
          // if (self.transaction.isOfferApplied) {
          //   const offerData = self.offer.filter((item: any) => item.code === self.transaction.offerCode)
          //   const bankIds = offerData[0].bankIds
          //   const data = others.filter((item: any) => bankIds.includes(item.id))

          //   retData.push({
          //     title: 'Other banks',
          //     data: data,
          //   })
          // } else {
          retData.push({
            title: 'Other banks',
            data: others,
          })
          // }
        }
        console.log('redData', retData)
        return retData
      } else if (IS_NTC_ENABLED && type === PAYMENT_MODE_SUBTYPES.NEW_TO_CREDIT) {
        const retData: any = []
        const bankList = self.merchant.preferences?.bankList
        if (bankList.length === 0) {
          return []
        }
        const getShortName: any = {
          'Punjab National Bank - Retail': 'PNB Bank',
          'Axis Bank - Retail': 'Axis Bank',
          'Yes Bank - Retail': 'YES Bank',
          'ICICI Bank - Retail': 'ICICI Bank',
          'State Bank of India': 'SBI Bank',
          'HDFC Bank - Retail': 'HDFC Bank',
          'Kotak Bank': 'Kotak Bank',
        }
        const allBanks = bankList
          .toJSON()
          .map((item: BankType) => ({
            id: item.id,
            text: getShortName[item.name] ?? item.name,
            imageUrl: item.logo,
            position: getImageLocation(item.id),
            rank: item.rank,
          }))
          .sort((a, b) => (a.rank > b.rank ? 1 : -1))
        if (allBanks.length !== 0) {
          return allBanks
        }
        console.log('retData', retData)
        return retData
      } else {
        const retData: any = []
        const bankList = self.merchant.preferences?.bankList
        if (bankList.length === 0) {
          return []
        }
        const getShortName: any = {
          'Punjab National Bank - Retail': 'PNB Bank',
          'Axis Bank - Retail': 'Axis Bank',
          'Yes Bank - Retail': 'YES Bank',
          'ICICI Bank - Retail': 'ICICI Bank',
          'State Bank of India': 'SBI Bank',
          'HDFC Bank - Retail': 'HDFC Bank',
          'Kotak Bank': 'Kotak Bank',
        }
        const isSubscriptionEnabled = self.merchant.subscription.isEnabled
        const isCorpNbAllowedInConfigApi = self.merchant.allowedPaymentConfigs.split('|').includes('620')
        const isCorpNbAllowedForTnx =
          self.merchant.allowedPaymentModes.length === 0 ||
          self.merchant.allowedPaymentModes.filter(
            (item: any) => item.methodType === '110' && item.methodSubType === '620',
          )?.length > 0
        const isCorpNbNotAllowedForTnx =
          self.merchant.notAllowedPaymentModes.length > 0 &&
          self.merchant.notAllowedPaymentModes.filter(
            (item: any) => item.methodType === '110' && item.methodSubType === '620',
          )?.length > 0
        const isCnbAllowed =
          !isSubscriptionEnabled && isCorpNbAllowedInConfigApi && isCorpNbAllowedForTnx && !isCorpNbNotAllowedForTnx

        if (self.merchant.allowedPaymentModes?.length > 0) {
          const [netBankingPaymentMode]: any = self.merchant.allowedPaymentModes?.filter((item: any) => {
            return (
              Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.NB ||
              (MERGE_NB_CNB && (isCnbAllowed || Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CORP_NB))
            )
          })
          if (netBankingPaymentMode && netBankingPaymentMode?.bankId?.length > 0) {
            const filterBankList = bankList.filter((item: any) => {
              return netBankingPaymentMode?.bankId.includes(Number(item.id))
            })
            const others = filterBankList.map((item: any) => {
              return {
                id: item.id,
                text: getShortName[item.name] ?? item.name,
                imageUrl: item.logo,
                position: getImageLocation(item.id),
                rank: item.rank,
                isCnb: MERGE_NB_CNB && item.isCnb,
              }
            })
            if (others.length !== 0) {
              others.sort((a, b) => a.text?.localeCompare(b?.text ?? ''))
              retData.push({
                title: 'Other banks',
                data: others,
              })
              return retData
            }
          }
        } else if (self.merchant.notAllowedPaymentModes?.length > 0) {
          const [netBankingPaymentMode]: any = self.merchant.notAllowedPaymentModes?.filter((item: any) => {
            return (
              Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.NB ||
              isCnbAllowed ||
              Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CORP_NB
            )
          })
          if (netBankingPaymentMode && netBankingPaymentMode?.bankId?.length > 0) {
            const filterBankList = bankList.filter((item: any) => {
              return !netBankingPaymentMode?.bankId.includes(Number(item.id))
            })
            const popular = filterBankList
              .filter((item) => item.isPopular)
              .map((item: BankType) => ({
                id: item.id,
                text: getShortName[item.name] ?? item.name,
                imageUrl: item.logo,
                position: getImageLocation(item.id),
                rank: item.rank,
                isCnb: MERGE_NB_CNB && item.isCnb,
              }))
              .sort((a, b) => (a.rank > b.rank ? 1 : -1))

            if (popular.length !== 0) {
              retData.push({
                title: 'Popular banks',
                data: popular,
              })
            }
            const others = filterBankList.map((item: any) => {
              return {
                id: item.id,
                text: getShortName[item.name] ?? item.name,
                imageUrl: item.logo,
                position: getImageLocation(item.id),
                rank: item.rank,
                isCnb: MERGE_NB_CNB && item.isCnb,
              }
            })
            if (others.length !== 0) {
              others.sort((a, b) => a.text?.localeCompare(b?.text ?? ''))
              retData.push({
                title: 'Other banks',
                data: others,
              })
              return retData
            }
          }
        }

        const popular = bankList
          .toJSON()
          .filter((item) => item.isPopular)
          .map((item: BankType) => ({
            id: item.id,
            text: getShortName[item.name] ?? item.name,
            imageUrl: item.logo,
            position: getImageLocation(item.id),
            rank: item.rank,
          }))
          .sort((a, b) => (a.rank > b.rank ? 1 : -1))
        if (popular.length !== 0) {
          retData.push({
            title: 'Popular banks',
            data: popular,
          })
        }
        const others = bankList.toJSON().map((item: BankType) => {
          return {
            id: item.id,
            text: item.name,
            imageUrl: item?.logo || '',
            position: getImageLocation(item.id),
            isCnb: MERGE_NB_CNB && item.isCnb,
          }
        })

        if (others.length !== 0) {
          others.sort((a, b) => a.text.localeCompare(b.text))
          // if (self.transaction.isOfferApplied) {
          //   const offerData = self.offer.filter((item: any) => item.code === self.transaction.offerCode)
          //   const bankIds = offerData[0].bankIds
          //   const data = others.filter((item: any) => bankIds.includes(item.id))

          //   retData.push({
          //     title: 'Other banks',
          //     data: data,
          //   })
          // } else {
          retData.push({
            title: 'Other banks',
            data: others,
          })
          // }
        }
        console.log('redData', retData)
        return retData
      }
    },
    parseCards(data: any) {
      const getType: any = {
        creditcard: 'Credit card',
        debitcard: 'Debit Card',
      }
      return data.map((item: any) => {
        return {
          ...item,
          id: item.id,
          title: `${getType[item.type.toLowerCase()]}`,
          subTitle: item.cardNumber.slice(-8),
          url: item.logo,
          scheme: item.scheme,
          icon: 'DEFAULT_CARD',
        }
      })
    },
    parsedPaymentSupportedList(data: any, uiList: any) {
      let isNativeUpiHasHigherRank = true
      if (self?.merchant?.allowedPaymentModes?.length > 0) {
        const nativeUpiRank = self?.merchant?.allowedPaymentModes.find((item) => item.methodSubType === '580')?.rank
        const upiRank = self?.merchant?.allowedPaymentModes.find((item) => item.methodSubType === '566')?.rank
        isNativeUpiHasHigherRank = Number(nativeUpiRank) <= Number(upiRank)
      }

      const retData: any[] = data.filter((item: any) => uiList.indexOf(item) > -1)
      const others = data.filter((item: any) => uiList.indexOf(item) === -1)
      if (retData.includes('upi')) {
        const index = retData.indexOf('upi')
        const navigatorObj: any = navigator
        const isMobile = navigatorObj?.userAgentData?.mobile && !!(window as any).chrome
        const isMobileSdk = getWindow().JioPaymentWebViewInterface
        if (isMobile || isMobileSdk) {
          //TODO: confirm whether show savedVpa UI on mobile and mobile web
          self.merchant.isCollectVpaSupported && retData.splice(index, 0, 'savedVpa')
          self.merchant.isUpiIntentAllowed &&
            retData.splice(isNativeUpiHasHigherRank ? index : index + 2, 0, 'nativeUpi')
        } else {
          retData.splice(retData.indexOf('upi'), 1)
        }
        if (!self.merchant.isCollectVpaSupported) {
          retData.splice(retData.indexOf('upi'), 1)
        }
      }
      return others?.length > 0 ? [...retData, 'other'] : retData
    },
    otherPaymentSupportedList(data: any, uiList: any) {
      const othermodes = data.filter((item: any) => uiList.indexOf(item) === -1)
      const getIcon: any = {
        wallet: 'WALLET',
        paylater: 'REFUNDS',
        emi: 'CALENDAR',
        jiopayfinancehub: 'JIO_ICON',
        corporatenetbanking: 'BANK',
      }

      const getTitle: any = {
        wallet: 'Wallets',
        paylater: 'Buy Now Pay Later',
        emi: "Pay in EMI's",
        sodexo: staticStrings.sodexoHeader,
        jiopayfinancehub: 'JioPay EasyEMI',
        corporatenetbanking: 'Corporate NetBanking',
        upi: 'Scan and Pay',
      }
      const retArr: any = []
      othermodes.map((item: any) => {
        if (getTitle[item]) {
          let imageUrl = item === 'sodexo' ? require('../../assets/images/sodexo.png') : undefined
          retArr.push({
            type: item,
            title: getTitle[item] ?? item.toUpperCase(),
            icon: getIcon[item],
            imageUrl: imageUrl,
          })
        }
      })
      return retArr
    },
    parseInstrumentData(data: any, type: any) {
      if (type === 'netbanking') {
        const popularBanks = data.filter((item: any) => item.title === 'Popular banks')?.[0]?.data ?? []
        return popularBanks.map((item: any) => {
          return {
            ...item,
            id: item.id,
            title: item.text,
            url: item.imageUrl,
          }
        })
      }
    },
    getAllBanks(data: any, searchString = '') {
      const retData: any = []
      const filterdData =
        data.filter((item: any) => item.title === 'Other banks' || item.title === 'Other Wallets')?.[0]?.data ?? []
      filterdData.map((item: any) => {
        retData.push({
          ...item,
          id: item.id,
          title: item.text,
          url: item.imageUrl,
        })
        return retData
      })
      return retData.filter(
        (item: any) => isEmpty(searchString) || item.text.toLowerCase().includes(searchString?.toLowerCase()),
      )
    },
    getAllFoodcards(data: any) {
      const retData: any = []
      data?.map((item: any) => {
        retData.push({
          ...item,
          id: item.id,
          title: item.name,
          url: item.logo,
          subTitle: item.cardNumber,
          bal: item?.cardBalance?.balance,
        })
      })
      return retData
    },
    getVpaList() {
      const vpaList = self.user.paymentMethod.filter((item) => getType(item).name === 'UPI') as [UPIType]
      if (vpaList && vpaList.length > 0) {
        let list = vpaList.map((item: any) => {
          return {
            title: String(item.vpa),
            key: String(item.vpa),
            imageUrl: getUPIIcon(item?.vpa),
            instrumentId: item.instrumentId,
          }
        })
        // if (self.merchant.subscription.isEnabled) {
        //   list = list.filter((item) => UPI_SUBSCRIPTION_ENABLED_LIST.some((vpaSuf) => item.title.endsWith(vpaSuf)))
        // }
        const finalList = list.length > 0 ? [...list, { title: ADD_NEW_UPI }] : []
        return finalList
      }
      return []
    },
    setEMIPayment(id: string, type: string) {
      if (type === EMI.CARDLESS) {
        console.log('setEMIPayment id', id)
        const [selectedEMI] = self.merchant.preferences.cardLessEMIList.filter(
          (item: CardlessEMIType) => item.bank === id,
        )
        console.log('setEMIPayment selectedEMI', selectedEMI)
        const cardLessEMI = {
          bank: selectedEMI.bank,
          bankName: selectedEMI.bankName,
          bankImageUrl: selectedEMI.bankImageUrl,
          paymentType: 'CardlessEMI',
        } as CardlessEMIType
        self.transaction.addPaymentMethod(cardLessEMI)
      } else if (type === EMI.DEBIT_CARD) {
        const [selectedEMI] = self.merchant.preferences.EMILList.filter(
          (item: CardlessEMIType) =>
            item.bank === id &&
            (item.schemeSubType === EMI_CARDTYPE.DEBIT_CARD || item.schemeSubType === EMI_CARDTYPE.CARDLESS_EMI),
        )
        console.log('setEMIPayment selectedEMI', selectedEMI)
        const debitCardEMI = {
          bank: selectedEMI.bank,
          bankName: selectedEMI.bankName,
          bankImageUrl: selectedEMI.bankImageUrl,
          paymentType: 'EMI',
        } as CardlessEMIType
        self.transaction.addPaymentMethod(debitCardEMI)
      }
    },
    setSelectedPayment(id: string, type: number) {
      const isOfferApplied = self.isOfferApplied(
        type === PAYMENT_MODE_SUBTYPES.NB ? PAYMENT_MODE_SUBTYPES.NB : PAYMENT_MODE_SUBTYPES.WALLET,
      )
      const convenienceFee: any = self.transaction.getConvenienceFee(
        type === PAYMENT_MODE_SUBTYPES.NB ? PAYMENT_MODE_SUBTYPES.NB : PAYMENT_MODE_SUBTYPES.WALLET,
        isOfferApplied && self.transaction.isValidOffer,
        id,
      )
      if (type === PAYMENT_MODE_SUBTYPES.WALLET) {
        const [selectedWallet] = self.merchant.preferences.walletList
          .toJSON()
          .filter((item: WalletType) => `${item.id}` === id)
        const wallet = {
          id: selectedWallet.id,
          name: selectedWallet.name,
          logo: selectedWallet.logo,
          convenienceFee: [
            {
              cgst: convenienceFee?.cgst,
              igst: convenienceFee?.igst,
              sgst: convenienceFee?.sgst,
              tcs: convenienceFee?.tcs,
              tds: convenienceFee?.tds,
              ugst: convenienceFee?.ugst,
              totalFee: convenienceFee?.totalFee,
            },
          ],
          paymentType: 'Wallet',
        } as WalletType
        self.transaction.addPaymentMethod(wallet)
      } else if (type === PAYMENT_MODE_SUBTYPES.FOOD_CARD) {
        //TODO: change as per api
        const [selectedFoodCardProvider] = self.merchant.preferences.foodCardList
          .toJSON()
          .filter((item: BankType) => `${item.id}` === id)
        const foodCard = {
          id: selectedFoodCardProvider.id,
          name: selectedFoodCardProvider.name,
          accountNumber: selectedFoodCardProvider.accountNumber,
          logo: selectedFoodCardProvider.logo,
          isPopular: selectedFoodCardProvider.isPopular,
          rank: selectedFoodCardProvider.rank,
          paymentType: 'FoodCard', //TODO: check
        } as BankType
        self.transaction.addPaymentMethod(foodCard)
      } else if (type === PAYMENT_MODE_SUBTYPES.CORP_NB) {
        const [selectedBank] = MERGE_NB_CNB
          ? self.merchant.preferences.bankList
          : self.merchant.preferences.corpBankList.toJSON().filter((item: BankType) => `${item.id}` === id)

        if (selectedBank) {
          const bank = {
            id: selectedBank.id,
            name: selectedBank.name,
            accountNumber: selectedBank.accountNumber,
            logo: selectedBank.logo,
            isPopular: selectedBank.isPopular,
            rank: selectedBank.rank,
            convenienceFee: [
              {
                cgst: convenienceFee?.cgst,
                igst: convenienceFee?.igst,
                sgst: convenienceFee?.sgst,
                tcs: convenienceFee?.tcs,
                tds: convenienceFee?.tds,
                ugst: convenienceFee?.ugst,
                totalFee: convenienceFee?.totalFee,
              },
            ],
            paymentType: 'CpNetBank',
          } as BankType
          console.log('bank', bank)
          self.transaction.addPaymentMethod(bank)
        } else {
          const bank = {
            id: id,
            name: '',
            accountNumber: '',
            logo: '',
            convenienceFee: [
              {
                cgst: convenienceFee?.cgst,
                igst: convenienceFee?.igst,
                sgst: convenienceFee?.sgst,
                tcs: convenienceFee?.tcs,
                tds: convenienceFee?.tds,
                ugst: convenienceFee?.ugst,
                totalFee: convenienceFee?.totalFee,
              },
            ],
            paymentType: 'Bank',
          } as BankType
          self.transaction.addPaymentMethod(bank)
        }
      } else if (type === PAYMENT_MODE_SUBTYPES.NEW_TO_CREDIT) {
        const [selectedBank] = self.merchant.preferences.bankList
          .toJSON()
          .filter((item: BankType) => `${item.id}` === id)
        if (selectedBank) {
          const bank = {
            id: selectedBank.id,
            name: selectedBank.name,
            accountNumber: selectedBank.accountNumber,
            logo: selectedBank.logo,
            isPopular: selectedBank.isPopular,
            rank: selectedBank.rank,
            convenienceFee: [
              {
                cgst: convenienceFee?.cgst,
                igst: convenienceFee?.igst,
                sgst: convenienceFee?.sgst,
                tcs: convenienceFee?.tcs,
                tds: convenienceFee?.tds,
                ugst: convenienceFee?.ugst,
                totalFee: convenienceFee?.totalFee,
              },
            ],
            paymentType: 'NewToCredit',
          } as BankType
          self.transaction.addPaymentMethod(bank)
        } else {
          const bank = {
            id: id,
            name: '',
            accountNumber: '',
            logo: '',
            convenienceFee: [
              {
                cgst: convenienceFee?.cgst,
                igst: convenienceFee?.igst,
                sgst: convenienceFee?.sgst,
                tcs: convenienceFee?.tcs,
                tds: convenienceFee?.tds,
                ugst: convenienceFee?.ugst,
                totalFee: convenienceFee?.totalFee,
              },
            ],
            paymentType: 'Bank',
          } as BankType
          self.transaction.addPaymentMethod(bank)
        }
      } else {
        const [selectedBank] = self.merchant.preferences.bankList
          .toJSON()
          .filter((item: BankType) => `${item.id}` === id)
        if (selectedBank) {
          const bank = {
            id: selectedBank.id,
            name: selectedBank.name,
            accountNumber: selectedBank.accountNumber,
            logo: selectedBank.logo,
            isPopular: selectedBank.isPopular,
            rank: selectedBank.rank,
            convenienceFee: [
              {
                cgst: convenienceFee?.cgst,
                igst: convenienceFee?.igst,
                sgst: convenienceFee?.sgst,
                tcs: convenienceFee?.tcs,
                tds: convenienceFee?.tds,
                ugst: convenienceFee?.ugst,
                totalFee: convenienceFee?.totalFee,
              },
            ],
            paymentType: 'Bank',
          } as BankType
          self.transaction.addPaymentMethod(bank)
        } else {
          const bank = {
            id: id,
            name: '',
            accountNumber: '',
            logo: '',
            convenienceFee: [
              {
                cgst: convenienceFee?.cgst,
                igst: convenienceFee?.igst,
                sgst: convenienceFee?.sgst,
                tcs: convenienceFee?.tcs,
                tds: convenienceFee?.tds,
                ugst: convenienceFee?.ugst,
                totalFee: convenienceFee?.totalFee,
              },
            ],
            paymentType: 'Bank',
          } as BankType
          self.transaction.addPaymentMethod(bank)
        }
      }
    },
    deleteCardFromStore(token: string, isSavedVpa: any = false) {
      self.user.deleteCard(token, isSavedVpa)
    },
    getCardBalanceBody(token: string) {
      return {
        entity: {
          initiatingEntityId: self?.transaction?.initiatingEntity?.entityId,
          application: self?.transaction?.id?.application,
          type: 11,
          entityId: String(self?.merchant?.id),
        },
        transaction: {
          intentId: self.transaction.id.intentId,
        },
        amount: {
          netAmount: Number(self.transaction.amount.netAmount),
        },
        user: {
          vaultId: Number(token),
          externalId: self.user.externalId,
        },
      }
    },
  }))
  .actions((self) => ({
    getSavedCards: flow(function* getSavedCard() {
      try {
        let response: any
        self.config.savedCardApiStatus = 'pending'
        const params = self.savedCardsBody()
        response = yield savedCard(params)
        // if (response?.userCards?.length > 0) {
        //   self.user.addSavedCards(response.userCards)
        // }
        if (response?.vpaList?.length > 0) {
          self.user.addVPAList(response.vpaList)
        }
        if (response?.userCards?.length > 0 || response?.foodCards?.length > 0) {
          self.user.addSavedCards([...response.userCards, ...response.foodCards])
        }
        self.config.savedCardApiStatus = 'done'
        return response
      } catch (error) {
        self.config.savedCardApiStatus = 'done'
        const customError = {
          message: error?.message ?? errorMessage.defautCatchMessage,
        }
        if (error?.code === TOKEN_EXPIRY_CODE) {
          self.message.setMessage(customError.message, MessageTypes.error, error?.code)
        }
        throw customError
      }
    }),
    parseEmiPlans(arr: any, cardNumber: string) {
      const retArr: any = []
      const emiPlansWithBankId = RootStore.merchant.preferences.cardEMIList
      arr?.map((item: any, index: number) => {
        const cardBin = cardNumber.replace(/[^0-9]/g, '').slice(0, 6)
        const bankId = emiPlansWithBankId.get(`${cardBin}_${item?.data?.[index]?.schemeType}`)?.emiList?.[index].bank
        item?.data.map((emiItem: any) => {
          const value = emiItem?.val?.split('-')?.[0].trim()
          retArr.push({ ...emiItem, bankId: bankId, val: value })
        })
      })
      return retArr
    },
    getEMIPlans(emitype: string) {
      const data: any = []
      if (emitype === EMI.CARDLESS) {
        self.merchant.preferences.cardLessEMIList.forEach((item, index) => {
          const object = data.find((obj: any) => obj.header.name === item.bankName)
          if (object) {
            object.data.push({
              id: index++,
              val: item.value,
            })
          } else {
            data.push({
              header: { name: item.bankName },
              data: [
                {
                  id: index + 1,
                  val: `₹${formatAmount(item.value)} X ${item.tenure} - ${item.interestRate}% Interest`,
                },
              ],
            })
          }
        })
      } else if (emitype === EMI.ALL) {
        let creditCardList: any = []
        let debitCardList: any = []
        let creditCardEMIList: any = []
        let debitCardEMIList: any = []
        self.merchant.preferences.EMILList.forEach((element) => {
          if (element.schemeSubType === '00') {
            creditCardList.push(element)
          } else if (element.schemeSubType === '01') {
            debitCardList.push(element)
          }
        })

        console.log('creditCardList', creditCardList)
        console.log('debitCardList', debitCardList)
        creditCardList.forEach((item: any) => {
          const emiItem = creditCardEMIList.find((element: any) => {
            const [bankName] = Object.keys(element)
            return item.bankName === bankName
          })
          if (emiItem) {
            const [bankName] = Object.keys(emiItem)
            emiItem[bankName].push(item)
          } else {
            creditCardEMIList.push({
              [item.bankName]: [item],
            })
          }
        })
        debitCardList.forEach((item: any) => {
          console.log('debitCardList', item)
          const emiItem = debitCardEMIList.find((element: any) => {
            const [bankName] = Object.keys(element)
            return item.bankName === bankName
          })
          if (emiItem) {
            const [bankName] = Object.keys(emiItem)
            emiItem[bankName].push(item)
          } else {
            debitCardEMIList.push({
              [item.bankName]: [item],
            })
          }
        })
        return data
      } else if (emitype === EMI.DEBIT_CARD_ALL) {
        let dcEMIList: any = []
        // const dcList = self.merchant.preferences.EMILList.filter((element) => element.schemeSubType === '01')
        self.merchant.preferences.EMILList.filter((element) => {
          if (element.schemeSubType === EMI_CARDTYPE.DEBIT_CARD) {
            if (element.schemeType === EMI_SCHME_TYPE.EXTERNAL) {
              const products = element.product.filter(
                (product: any) =>
                  product.emiPlan.allowZeroCost !== EMI_TYPES.NO_COST &&
                  product.emiPlan.allowZeroCost !== EMI_TYPES.LOW_COST,
              )
              return products?.length > 0
            }
            return Number(element.discount) === 0
          }
          return false
        }).forEach((item: any) => {
          const emiItem = dcEMIList.find((emiElement: any) => {
            const [bankName] = Object.keys(emiElement)
            return item.bankName === bankName
          })
          if (emiItem) {
            const [bankName] = Object.keys(emiItem)
            emiItem[bankName].push(item)
          } else {
            dcEMIList.push({
              [item.bankName]: [item],
            })
          }
        })

        const isOfferApplied = self.isOfferApplied(PAYMENT_MODE_SUBTYPES.CARD, PAYMENT_MODE_TYPE.EMI)

        let bankIdList: any = []
        if (isOfferApplied) {
          const [filteredOfferEMI]: any = self.offer.filter(
            (item: any) => item.code === self.transaction.offerCode && item.emi,
          )
          console.log('filteredOfferEMI', filteredOfferEMI)
          bankIdList = filteredOfferEMI?.emi?.map((item: any) => item.bankEmiId)
        }

        dcEMIList.forEach((element: any) => {
          const [bankName] = Object.keys(element)
          const emiList = element[bankName]
          const fromEMIList = emiList.map((emi: any) => {
            const isOfferApplicable = bankIdList?.includes(emi.emiBankId) ?? false
            const tenure = emi.tenure
            const tenureVal = emi.tenure.substring(0, tenure.length - 1)
            const tenurePeriod =
              emi.tenure.substring(tenure.length - 1) === 'M'
                ? Number(tenureVal) > 1
                  ? 'Months'
                  : 'Month'
                : Number(tenureVal) > 1
                  ? 'Years'
                  : 'Year'
            const emiTenure = `${tenureVal} ${tenurePeriod}`

            const emiDetails = emi?.product?.map((product: any) => {
              return {
                productCode: product.productId,
                itemValue: product.productAmount,
                interest: product.emiPlan.bankInterestRate,
                emiDiscount: product.emiPlan.productDiscount,
                additionalCashback: product.emiPlan.additionalCashback,
              }
            })

            return {
              emi: emi.value,
              tenureId: emi.tenure,
              interest: emi.interest,
              interestRate: emi.interestRate,
              isOfferEligible: isOfferApplicable,
              scheme: emi.scheme,
              schemeType: emi.schemeType,
              amount: emi.grossAmount,
              instantDiscountPercentage: emi.discount,
              emiDetails: emiDetails,
              val: `₹${emi.value} X ${emiTenure} | ${emi.interestRate}% p.a`,
            }
          })
          console.log('item32', fromEMIList)
          data.push({
            header: { emiBankName: bankName },
            data: fromEMIList,
          })
          console.log('data', data)
        })
        return data
      } else if (emitype === EMI.CREDIT_CARD_ALL) {
        let ccEMIList: any = []

        self.merchant.preferences.EMILList.filter((element) => {
          if (element.schemeSubType === EMI_CARDTYPE.CREDIT_CARD) {
            if (element.schemeType === EMI_SCHME_TYPE.EXTERNAL) {
              const products = element?.product?.filter(
                (product: any) =>
                  product.emiPlan.allowZeroCost !== EMI_TYPES.NO_COST &&
                  product.emiPlan.allowZeroCost !== EMI_TYPES.LOW_COST,
              )
              return products?.length > 0
            }
            return Number(element.discount) === 0
          }
          return false
        }).forEach((item: any) => {
          const emiItem = ccEMIList.find((emiElement: any) => {
            const [bankName] = Object.keys(emiElement)
            return item.bankName === bankName
          })
          if (emiItem) {
            const [bankName] = Object.keys(emiItem)
            emiItem[bankName].push(item)
          } else {
            ccEMIList.push({
              [item.bankName]: [item],
            })
          }
        })

        const isOfferApplied = self.isOfferApplied(PAYMENT_MODE_SUBTYPES.CARD, PAYMENT_MODE_TYPE.EMI)
        let bankIdList: any = []
        if (isOfferApplied) {
          const [filteredOfferEMI]: any = self.offer.filter(
            (item: any) => item.code === self.transaction.offerCode && item.emi,
          )
          bankIdList = filteredOfferEMI?.emi?.map((item: any) => item.bankEmiId)
        }
        ccEMIList.forEach((element: any) => {
          const [bankName] = Object.keys(element)
          const emiList = element[bankName]
          const fromEMIList = emiList.map((emi: any) => {
            const isOfferApplicable = bankIdList?.includes(emi.emiBankId) ?? false
            const tenure = emi.tenure
            const tenureVal = emi.tenure.substring(0, tenure.length - 1)
            const tenurePeriod =
              emi.tenure.substring(tenure.length - 1) === 'M'
                ? Number(tenureVal) > 1
                  ? 'Months'
                  : 'Month'
                : Number(tenureVal) > 1
                  ? 'Years'
                  : 'Year'
            const emiTenure = `${tenureVal} ${tenurePeriod}`

            const emiDetails = emi?.product?.map((product: any) => {
              return {
                productCode: product.productId,
                itemValue: product.productAmount,
                interest: product.emiPlan.bankInterestRate,
                emiDiscount: product.emiPlan.productDiscount,
                additionalCashback: product.emiPlan.additionalCashback,
              }
            })

            return {
              emi: emi.value,
              tenureId: emi.tenure,
              interest: emi.interest,
              interestRate: emi.interestRate,
              amount: emi.grossAmount,
              scheme: emi.scheme,
              schemeType: emi.schemeType,
              isOfferEligible: isOfferApplicable,
              instantDiscountPercentage: emi.discount,
              emiDetails: emiDetails,
              val: `₹${emi.value} X ${emiTenure} | ${emi.interestRate}% p.a`,
            }
          })
          data.push({
            header: { emiBankName: bankName },
            data: fromEMIList,
          })
        })
        return data
      } else if (emitype === EMI.NO_LOW_COST_EMI_ALL) {
        if (self.merchant.allowedPaymentModes?.length > 0) {
          const [cardPaymentMode] = self.merchant.allowedPaymentModes?.filter((item: any) => {
            return (
              Number(item.methodType) === PAYMENT_MODE_TYPE.EMI &&
              Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD
            )
          })
          console.log('getEMIPlans allowedPaymentModes', cardPaymentMode)
          if (cardPaymentMode) {
            console.log('getEMIPlans if 1')
            if (
              [Number(CARD_TYPE.CREDIT_CARD), Number(CARD_TYPE.DEBIT_CARD)].every((item: any) =>
                cardPaymentMode?.cardType?.includes(item),
              ) ||
              cardPaymentMode?.cardType?.length === 0
            ) {
              return self.getNoCostEMIAllPlans()
            } else if (cardPaymentMode?.cardType?.includes(Number(CARD_TYPE.CREDIT_CARD))) {
              return self.getNoCostCCEMIPlans()
            } else if (cardPaymentMode?.cardType?.includes(Number(CARD_TYPE.DEBIT_CARD))) {
              return self.getNoCostDCEMIPlans()
            }
          }
        } else if (self.merchant.notAllowedPaymentModes?.length > 0) {
          const [cardPaymentMode] = self.merchant.notAllowedPaymentModes?.filter((item: any) => {
            return (
              Number(item.methodType) === PAYMENT_MODE_TYPE.EMI &&
              Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD
            )
          })
          if (cardPaymentMode) {
            console.log('getEMIPlans if 1')
            if (!cardPaymentMode?.cardType?.includes(Number(CARD_TYPE.CREDIT_CARD))) {
              return self.getNoCostCCEMIPlans()
            } else if (!cardPaymentMode?.cardType?.includes(Number(CARD_TYPE.DEBIT_CARD))) {
              return self.getNoCostDCEMIPlans()
            }
          }
        }
        return self.getNoCostEMIAllPlans()
      } else if (emitype === EMI.NO_LOW_COST_CC_ALL) {
        return self.getNoCostCCEMIPlans()
      } else if (emitype === EMI.STANDARD_EMI_ALL) {
        let standardEMIList: any = []
        self.merchant.preferences.EMILList.filter((element) => {
          if (element.schemeType === EMI_SCHME_TYPE.EXTERNAL) {
            const products = element?.product?.filter(
              (product: any) =>
                product.emiPlan.allowZeroCost !== EMI_TYPES.NO_COST &&
                product.emiPlan.allowZeroCost !== EMI_TYPES.LOW_COST &&
                product,
            )
            return (
              products?.length === element.product?.length &&
              element.schemeSubType === EMI_CARDTYPE.CREDIT_CARD &&
              element
            )
          } else {
            return element.schemeSubType === EMI_CARDTYPE.CREDIT_CARD && Number(element.discount) === 0
          }
        }).forEach((item: any) => {
          const emiItem = standardEMIList.find((emiElement: any) => {
            const [bankName] = Object.keys(emiElement)
            return item.bankName === bankName
          })
          if (emiItem) {
            const [bankName] = Object.keys(emiItem)
            emiItem[bankName].push(item)
          } else {
            standardEMIList.push({
              [item.bankName]: [item],
            })
          }
        })

        const isOfferApplied = self.isOfferApplied(PAYMENT_MODE_SUBTYPES.CARD, PAYMENT_MODE_TYPE.EMI)
        let bankIdList: any = []
        if (isOfferApplied) {
          const [filteredOfferEMI]: any = self.offer.filter(
            (item: any) => item.code === self.transaction.offerCode && item.emi,
          )
          console.log('filteredOfferEMI', filteredOfferEMI)
          bankIdList = filteredOfferEMI?.emi?.map((item: any) => item.bankEmiId)
        }
        console.log('bankIdList', bankIdList)
        standardEMIList.forEach((element: any) => {
          const [bankName] = Object.keys(element)
          const emiList = element[bankName]
          const fromEMIList = emiList.map((emi: any) => {
            const isOfferApplicable = bankIdList?.includes(emi.emiBankId) ?? false
            const tenure = emi.tenure
            const tenureVal = emi.tenure.substring(0, tenure.length - 1)
            const tenurePeriod =
              emi.tenure.substring(tenure.length - 1) === 'M'
                ? Number(tenureVal) > 1
                  ? 'Months'
                  : 'Month'
                : Number(tenureVal) > 1
                  ? 'Years'
                  : 'Year'
            const emiTenure = `${tenureVal} ${tenurePeriod}`
            return {
              emi: emi.value,
              tenureId: emi.tenure,
              interest: emi.interest,
              interestRate: emi.interestRate,
              amount: emi.grossAmount,
              isOfferEligible: isOfferApplicable,
              val: `₹${emi.value} X ${emiTenure} | ${emi.interestRate}% p.a`,
            }
          })
          console.log('item32', fromEMIList)
          data.push({
            header: { emiBankName: bankName },
            data: fromEMIList,
          })
          console.log('data', data)
        })
        return data
      }
    },
    updateConvenienceFeeDetails(feeDetails: any, paymentSubType: Number, isOfferApplied) {
      if (feeDetails) {
        console.log('getConvenienceApi called feeDetails', feeDetails)
        switch (paymentSubType) {
          case PAYMENT_MODE_SUBTYPES.CARD:
            feeDetails.forEach((feeDetail: any) => {
              const {
                fee: { feeTax, totalConvenienceFee },
                card,
              } = feeDetail
              const cardConvenienceFee = {
                card: {
                  cardBin: card?.cardBin,
                  scheme: card?.scheme,
                  type: card?.type,
                  isDomestic: String(card?.isDomestic ?? '*'),
                  product: card?.product ?? '*',
                },
                cgst: String(feeTax?.cgst),
                igst: String(feeTax?.igst),
                sgst: String(feeTax?.sgst),
                tcs: String(feeTax?.tcs),
                tds: String(feeTax?.tds),
                ugst: String(feeTax?.ugst),
                totalFee: String(totalConvenienceFee),
              }
              console.log('fetchConvenienceFee cardConvenienceFee', cardConvenienceFee)
              if (isOfferApplied) {
                self.transaction.convenienceFeeList.cardOffers.push(cardConvenienceFee)
              } else {
                self.transaction.convenienceFeeList.card.push(cardConvenienceFee)
              }
            })
            break
          case PAYMENT_MODE_SUBTYPES.NB:
            feeDetails.forEach((fee: any) => {
              const {
                fee: { feeTax, totalConvenienceFee },
                bankId,
              } = fee
              const nbConvenienceFee = {
                bankId: bankId,
                cgst: String(feeTax?.cgst),
                igst: String(feeTax?.igst),
                sgst: String(feeTax?.sgst),
                tcs: String(feeTax?.tcs),
                tds: String(feeTax?.tds),
                ugst: String(feeTax?.ugst),
                totalFee: String(totalConvenienceFee),
              }
              console.log('getConvenienceApi called', nbConvenienceFee)
              if (isOfferApplied) {
                self.transaction.convenienceFeeList.nbOffers.push(nbConvenienceFee)
              } else {
                self.transaction.convenienceFeeList.nb.push(nbConvenienceFee)
              }
            })
            break
          case PAYMENT_MODE_SUBTYPES.CORP_NB:
            feeDetails.forEach((fee: any) => {
              const {
                fee: { feeTax, totalConvenienceFee },
                bankId,
              } = fee
              const nbConvenienceFee = {
                bankId: bankId,
                cgst: String(feeTax?.cgst),
                igst: String(feeTax?.igst),
                sgst: String(feeTax?.sgst),
                tcs: String(feeTax?.tcs),
                tds: String(feeTax?.tds),
                ugst: String(feeTax?.ugst),
                totalFee: String(totalConvenienceFee),
              }
              console.log('getConvenienceApi called', nbConvenienceFee)
              if (isOfferApplied) {
                self.transaction.convenienceFeeList.corpNbOffers.push(nbConvenienceFee)
              } else {
                self.transaction.convenienceFeeList.corpNb.push(nbConvenienceFee)
              }
            })
            break
          case PAYMENT_MODE_SUBTYPES.WALLET:
            feeDetails.forEach((fee: any) => {
              const {
                fee: { feeTax, totalConvenienceFee },
                bankId,
              } = fee
              const walletConvenienceFee = {
                bankId: bankId,
                cgst: String(feeTax?.cgst),
                igst: String(feeTax?.igst),
                sgst: String(feeTax?.sgst),
                tcs: String(feeTax?.tcs),
                tds: String(feeTax?.tds),
                ugst: String(feeTax?.ugst),
                totalFee: String(totalConvenienceFee),
              }
              if (isOfferApplied) {
                self.transaction.convenienceFeeList.walletOffers.push(walletConvenienceFee)
              } else {
                self.transaction.convenienceFeeList.wallet.push(walletConvenienceFee)
              }
            })
            break
        }
      } else {
        console.log('fetchConvenienceFee response is empty')
        switch (paymentSubType) {
          case PAYMENT_MODE_SUBTYPES.CARD:
            const cardConvenienceFee = {
              card: {
                cardBin: '0',
                scheme: '0',
                type: '0',
              },
              sgst: '0',
              igst: '0',
              cgst: '0',
              totalFee: '0',
            }
            console.log('fetchConvenienceFee cardConvenienceFee', cardConvenienceFee)
            if (isOfferApplied) {
              self.transaction.convenienceFeeList.cardOffers.push(cardConvenienceFee)
            } else {
              self.transaction.convenienceFeeList.card.push(cardConvenienceFee)
            }
            break
          case PAYMENT_MODE_SUBTYPES.NB:
            const nbConvenienceFee = {
              bankId: '0',
              sgst: '0',
              igst: '0',
              cgst: '0',
              totalFee: '0',
            }
            if (isOfferApplied) {
              self.transaction.convenienceFeeList.nbOffers.push(nbConvenienceFee)
            } else {
              self.transaction.convenienceFeeList.nb.push(nbConvenienceFee)
            }
            break
          case PAYMENT_MODE_SUBTYPES.CORP_NB:
            const corpNbConvenienceFee = {
              bankId: '0',
              sgst: '0',
              igst: '0',
              cgst: '0',
              totalFee: '0',
            }
            if (isOfferApplied) {
              self.transaction.convenienceFeeList.corpNbOffers.push(corpNbConvenienceFee)
            } else {
              self.transaction.convenienceFeeList.corpNb.push(corpNbConvenienceFee)
            }
            break
          case PAYMENT_MODE_SUBTYPES.WALLET:
            const walletConvenienceFee = {
              walletId: '0',
              sgst: '0',
              igst: '0',
              cgst: '0',
              totalFee: '0',
            }
            if (isOfferApplied) {
              self.transaction.convenienceFeeList.walletOffers.push(walletConvenienceFee)
            } else {
              self.transaction.convenienceFeeList.wallet.push(walletConvenienceFee)
            }
            break
        }
      }
    },
  }))
  .actions((self) => ({
    getPaymentType: function getPaymentType() {
      const [paymentMethod]: any = self.transaction.paymentMethod.slice(-1)
      return paymentMethod && getType(paymentMethod).name
    },
    confirmPaymentApi: flow(function* confirmPaymentApi() {
      let isSubscription = false
      let paymentType
      try {
        const paymentInfo = self.confirmPaymentData()
        const [paymentMethod]: any = self.transaction.paymentMethod.slice(-1)
        paymentType = paymentMethod && getType(paymentMethod).name
        const deviceDetails = {
          ...self.deviceInfo(),
          browserInfo: self.getBrowserInfo(),
        }

        let paymentData
        if (paymentType === 'Card') {
          const cardDetails = paymentMethod as CardType
          const [convenienceFee] = cardDetails?.convenienceFee
          const expYR = convertYear(String(cardDetails.expyr))
          const expMonth = convertMonth(String(cardDetails.expmon))
          const isSave = cardDetails.isSave
          isSubscription = cardDetails.isSubscription
          paymentData = {
            ...paymentInfo,
            transaction: {
              ...paymentInfo.transaction,
              ...(isSubscription && {
                remarks: self.transaction.remarks,
                statementDescriptor: self.transaction.statementDescriptor,
              }),
              method: {
                ...paymentInfo.transaction.method,
                subType:
                  paymentMethod?.type === CardTypes.FOODCARD
                    ? PAYMENT_MODE_SUBTYPES.FOOD_CARD
                    : PAYMENT_MODE_SUBTYPES.CARD,
                ...(isSubscription && {
                  type: CARD_METHOD_SC_TYPE,
                  subType: CARD_METHOD_SC_SUBTYPE,
                }),
              },
              ...(isSave && {
                saveInstrument: {
                  consentId: getRandomAlphaNumString(8),
                },
              }),
              ...(self.transaction.isOfferApplied &&
                self.transaction.isValidOffer &&
                self.transaction.selectedOfferPMType === PAYMENT_MODE_TYPE.PURCHASE &&
                self.transaction.selectedOfferPMSubType === PAYMENT_MODE_SUBTYPES.CARD && {
                metadata: {
                  offer: {
                    offerCode: self.transaction.appliedOffer.offerCode,
                    offerReferenceId: self.transaction.appliedOffer.offerReferenceId,
                    transactionAmount: self.transaction.appliedOffer.transactionAmount,
                    instantDiscountAmount: self.transaction.appliedOffer.instantDiscountAmount,
                    cashBackAmount: self.transaction.appliedOffer.cashBackAmount,
                  },
                },
              }),
            },
            ...(self.transaction.isOfferApplied &&
              self.transaction.isValidOffer &&
              self.transaction.selectedOfferPMType === PAYMENT_MODE_TYPE.PURCHASE &&
              self.transaction.selectedOfferPMSubType === PAYMENT_MODE_SUBTYPES.CARD && {
              amount: {
                grossAmount: Number(self?.transaction?.amount?.grossAmount),
                netAmount: (
                  Number(self?.transaction?.amount?.netAmount) - self.transaction.appliedOffer.instantDiscountAmount
                ).toFixed(2),
              },
            }),
            payer: {
              ...paymentInfo.payer,
              ...(isSubscription && {
                externalId: self.user.externalId,
              }),
              ...(cardDetails?.token
                ? {
                  card: { token: cardDetails.token, ...(cardDetails.cvv && { cvv: String(cardDetails.cvv) }) },
                }
                : {
                  card: {
                    ...(cardDetails?.subType && { type: Number(cardDetails.subType) }),
                    expiryMm: expMonth,
                    expiryYy: expYR,
                    name: cardDetails.ownerName,
                    cvv: String(cardDetails.cvv),
                    number: String(cardDetails.number),
                    ...(cardDetails?.scheme && { scheme: Number(cardDetails.scheme) }),
                  },
                }),
            },
            ...(convenienceFee?.totalFee && {
              amount: {
                ...paymentInfo.amount,
                charges: [
                  {
                    type: '',
                    value: convenienceFee?.totalFee,
                    cgst: convenienceFee?.cgst,
                    igst: convenienceFee?.igst,
                    sgst: convenienceFee?.sgst,
                    ugst: convenienceFee?.ugst,
                    serviceCharge: '',
                    tcs: convenienceFee?.tcs,
                    tds: convenienceFee?.tds,
                  },
                ],
              },
            }),
          }
        } else if (paymentType === 'Bank' || paymentType === 'CpNetBank') {
          const bankDetails = paymentMethod as BankType
          const [convenienceFee] = bankDetails?.convenienceFee
          paymentData = {
            ...paymentInfo,
            transaction: {
              ...paymentInfo.transaction,
              method: {
                ...paymentInfo.transaction.method,
                subType:
                  paymentMethod?.paymentType === 'CpNetBank' ? PAYMENT_MODE_SUBTYPES.CORP_NB : PAYMENT_MODE_SUBTYPES.NB,
              },
              ...(self.transaction.isOfferApplied &&
                self.transaction.isValidOffer &&
                self.transaction.selectedOfferPMSubType === PAYMENT_MODE_SUBTYPES.NB && {
                metadata: {
                  offer: {
                    offerCode: self.transaction.appliedOffer.offerCode,
                    offerReferenceId: self.transaction.appliedOffer.offerReferenceId,
                    transactionAmount: self.transaction.appliedOffer.transactionAmount,
                    instantDiscountAmount: self.transaction.appliedOffer.instantDiscountAmount,
                    cashBackAmount: self.transaction.appliedOffer.cashBackAmount,
                  },
                },
              }),
            },
            ...(self.transaction.isOfferApplied &&
              self.transaction.isValidOffer &&
              self.transaction.selectedOfferPMSubType === PAYMENT_MODE_SUBTYPES.NB && {
              amount: {
                grossAmount: Number(self?.transaction?.amount?.grossAmount),
                netAmount: (
                  Number(self?.transaction?.amount?.netAmount) - self.transaction.appliedOffer.instantDiscountAmount
                ).toFixed(2),
              },
            }),
            payer: {
              ...paymentInfo.payer,
              bankId: bankDetails.id,
              bankName: bankDetails.name,
            },
            ...(convenienceFee?.totalFee && {
              amount: {
                ...paymentInfo.amount,
                charges: [
                  {
                    type: '',
                    value: convenienceFee?.totalFee,
                    cgst: convenienceFee?.cgst,
                    igst: convenienceFee?.igst,
                    sgst: convenienceFee?.sgst,
                    ugst: convenienceFee?.ugst,
                    serviceCharge: '',
                    tcs: convenienceFee?.tcs,
                    tds: convenienceFee?.tds,
                  },
                ],
              },
            }),
          }
        } else if (paymentType === 'Wallet') {
          const walletDetails = paymentMethod as WalletType
          const [convenienceFee] = walletDetails.convenienceFee
          paymentData = {
            ...paymentInfo,
            transaction: {
              ...paymentInfo.transaction,
              method: {
                ...paymentInfo.transaction.method,
                subType: PAYMENT_MODE_SUBTYPES.WALLET,
              },
              ...(self.transaction.isOfferApplied &&
                self.transaction.isValidOffer &&
                self.transaction.selectedOfferPMSubType === PAYMENT_MODE_SUBTYPES.WALLET && {
                metadata: {
                  offer: {
                    offerCode: self.transaction.appliedOffer.offerCode,
                    offerReferenceId: self.transaction.appliedOffer.offerReferenceId,
                    transactionAmount: self.transaction.appliedOffer.transactionAmount,
                    instantDiscountAmount: self.transaction.appliedOffer.instantDiscountAmount,
                    cashBackAmount: self.transaction.appliedOffer.cashBackAmount,
                  },
                },
              }),
            },
            ...(self.transaction.isOfferApplied &&
              self.transaction.isValidOffer &&
              self.transaction.selectedOfferPMSubType === PAYMENT_MODE_SUBTYPES.WALLET && {
              amount: {
                grossAmount: Number(self?.transaction?.amount?.grossAmount),
                netAmount: (
                  Number(self?.transaction?.amount?.netAmount) - self.transaction.appliedOffer.instantDiscountAmount
                ).toFixed(2),
              },
            }),
            payer: {
              ...paymentInfo.payer,
              bankId: walletDetails.id,
              bankName: walletDetails.name,
            },
            ...(convenienceFee?.totalFee && {
              amount: {
                ...paymentInfo.amount,
                charges: [
                  {
                    type: '',
                    value: convenienceFee?.totalFee,
                    cgst: convenienceFee?.cgst,
                    igst: convenienceFee?.igst,
                    sgst: convenienceFee?.sgst,
                    ugst: convenienceFee?.ugst,
                    serviceCharge: '',
                    tcs: convenienceFee?.tcs,
                    tds: convenienceFee?.tds,
                  },
                ],
              },
            }),
          }
        } else if (paymentType === 'UPI') {
          if (self.merchant.preferences.upiMaxRetryLimit <= 0) {
            throw { message: MAX_RETRIES_EXCEEDED_ERROR }
          } else {
            const upiDetails = paymentMethod as UPIType
            isSubscription = upiDetails.isSubscription
            paymentData = {
              ...paymentInfo,
              transaction: {
                ...paymentInfo.transaction,
                expireAfter: '10',
                ...(isSubscription && {
                  remarks: self.transaction.remarks,
                  statementDescriptor: self.transaction.statementDescriptor,
                }),
                method: {
                  ...paymentInfo.transaction.method,
                  subType: PAYMENT_MODE_SUBTYPES.UPI,
                  ...(isSubscription && {
                    type: 310,
                    subType: 589,
                  }),
                },
                ...(upiDetails.isSave && {
                  saveInstrument: {
                    consentId: getRandomAlphaNumString(8),
                  },
                }),
                ...(self.transaction.isOfferApplied &&
                  self.transaction.isValidOffer &&
                  self.transaction.selectedOfferPMSubType === PAYMENT_MODE_SUBTYPES.UPI && {
                  metadata: {
                    offer: {
                      offerCode: self.transaction.appliedOffer.offerCode,
                      offerReferenceId: self.transaction.appliedOffer.offerReferenceId,
                      transactionAmount: self.transaction.appliedOffer.transactionAmount,
                      instantDiscountAmount: self.transaction.appliedOffer.instantDiscountAmount,
                      cashBackAmount: self.transaction.appliedOffer.cashBackAmount,
                    },
                  },
                }),
              },
              ...(self.transaction.isOfferApplied &&
                self.transaction.isValidOffer &&
                self.transaction.selectedOfferPMSubType === PAYMENT_MODE_SUBTYPES.UPI && {
                amount: {
                  grossAmount: Number(self?.transaction?.amount?.grossAmount),
                  netAmount: (
                    Number(self?.transaction?.amount?.netAmount) - self.transaction.appliedOffer.instantDiscountAmount
                  ).toFixed(2),
                },
              }),
              payer: {
                // type: self?.transaction?.payer?.type,
                ...(self?.transaction?.payer?.type !== 0 && { type: self?.transaction?.payer?.type }),
                ...(isSubscription && {
                  externalId: self.user.externalId,
                }),
                vpa: upiDetails?.vpa,
              },
              payee: {
                type: self?.transaction?.payee?.type,
                merchantId: self.merchant.id,
              },
            }
          }
        } else if (paymentType === 'PayLater') {
          const bankDetails = self.transaction.paymentMethod[0] as any
          paymentData = {
            ...paymentInfo,
            transaction: {
              ...paymentInfo.transaction,
              originalId: self.transaction.id.preProcessId,
              method: {
                ...paymentInfo.transaction.method,
                subType: PAYMENT_MODE_SUBTYPES.PAYLATER,
              },
              ...(self.transaction.isOfferApplied &&
                self.transaction.isValidOffer &&
                self.transaction.selectedOfferPMSubType === PAYMENT_MODE_SUBTYPES.PAYLATER && {
                metadata: {
                  offer: {
                    offerCode: self.transaction.appliedOffer.offerCode,
                    offerReferenceId: self.transaction.appliedOffer.offerReferenceId,
                    transactionAmount: self.transaction.appliedOffer.transactionAmount,
                    instantDiscountAmount: self.transaction.appliedOffer.instantDiscountAmount,
                    cashBackAmount: self.transaction.appliedOffer.cashBackAmount,
                  },
                },
              }),
            },
            ...(self.transaction.isOfferApplied &&
              self.transaction.isValidOffer &&
              self.transaction.selectedOfferPMSubType === PAYMENT_MODE_SUBTYPES.PAYLATER && {
              amount: {
                grossAmount: Number(self?.transaction?.amount?.grossAmount),
                netAmount: (
                  Number(self?.transaction?.amount?.netAmount) - self.transaction.appliedOffer.instantDiscountAmount
                ).toFixed(2),
              },
            }),
            payer: {
              ...paymentInfo.payer,
              bankId: bankDetails.id,
              bankName: bankDetails.name,
            },
          }
        } else if (paymentType === 'EMI') {
          const emiDetails = self.transaction.paymentMethod[0] as EMIType
          console.log(
            'isOfferApplied',
            self.transaction.isOfferApplied,
            self.transaction.selectedOfferPMType === PAYMENT_MODE_TYPE.EMI,
          )
          const offerAmount =
            self.transaction.isOfferApplied &&
              self.transaction.isValidOffer &&
              self.transaction.selectedOfferPMType === PAYMENT_MODE_TYPE.EMI &&
              self.transaction.selectedOfferPMSubType === PAYMENT_MODE_SUBTYPES.CARD
              ? self.transaction.appliedOffer.instantDiscountAmount
              : 0
          const netAmount = emiDetails.netAmount || self.transaction.amount.netAmount

          console.log('emiDetails netAmount', netAmount, offerAmount)
          const expYR = convertYear(String(emiDetails?.card?.expyr))
          const expMonth = convertMonth(String(emiDetails?.card?.expmon))
          paymentData = {
            ...paymentInfo,
            transaction: {
              ...paymentInfo.transaction,
              method: {
                ...paymentInfo.transaction.method,
                type: PAYMENT_MODE_TYPE.EMI,
                subType:
                  emiDetails.schemeSubType === EMI_CARDTYPE.CARDLESS_EMI
                    ? EMI_METHOD_CARDLESS_SUBTYPE
                    : PAYMENT_MODE_SUBTYPES.CARD,
              },
              ...(emiDetails?.card?.isSave && {
                saveInstrument: {
                  consentId: getRandomAlphaNumString(8),
                },
              }),
              metadata: {
                product: emiDetails.product,
              },
              ...(self.transaction.isOfferApplied &&
                self.transaction.isValidOffer &&
                self.transaction.selectedOfferPMType === PAYMENT_MODE_TYPE.EMI &&
                self.transaction.selectedOfferPMSubType === PAYMENT_MODE_SUBTYPES.CARD && {
                metadata: {
                  offer: {
                    offerCode: self.transaction.appliedOffer.offerCode,
                    offerReferenceId: self.transaction.appliedOffer.offerReferenceId,
                    transactionAmount: self.transaction.appliedOffer.transactionAmount,
                    instantDiscountAmount: self.transaction.appliedOffer.instantDiscountAmount,
                    cashBackAmount: self.transaction.appliedOffer.cashBackAmount,
                  },
                  product: emiDetails.product,
                },
              }),
              emi: {
                bank: emiDetails.bank || undefined,
                tenure: emiDetails.tenure || undefined,
                scheme: emiDetails.scheme || undefined,
                metadata: (emiDetails.metadata && JSON.parse(emiDetails.metadata)) || undefined,
                ...(emiDetails.schemeSubType !== EMI_CARDTYPE.CARDLESS_EMI && {
                  value: emiDetails.value || undefined,
                  schemeSubType: emiDetails.schemeSubType || undefined,
                  interest: emiDetails.interest || undefined,
                  interestRate: emiDetails.interestRate || undefined,
                  discount: emiDetails.discount || '0',
                  cashBack: emiDetails.cashBack || '0',
                }),
              },
            },
            amount: {
              grossAmount: Number(self?.transaction?.amount?.grossAmount),
              netAmount: Number(netAmount).toFixed(2),
            },

            payer: {
              ...paymentInfo.payer,
              ...(emiDetails.mobileNumber && {
                mobile: {
                  countryCode: '+91',
                  number: emiDetails.mobileNumber || null,
                },
              }),
              ...(emiDetails.schemeSubType === EMI_CARDTYPE.CARDLESS_EMI && { bank: emiDetails.bank }),
              ...(emiDetails.schemeSubType !== EMI_CARDTYPE.CARDLESS_EMI && {
                ...(emiDetails?.card?.token
                  ? {
                    card: { token: emiDetails?.card?.token, cvv: String(emiDetails?.card?.cvv) },
                  }
                  : {
                    card: {
                      ...(emiDetails?.card?.subType && { type: Number(emiDetails?.card?.subType) }),
                      expiryMm: expMonth,
                      expiryYy: expYR,
                      name: emiDetails?.card?.ownerName,
                      cvv: String(emiDetails?.card?.cvv),
                      number: String(emiDetails?.card?.number),
                      ...(emiDetails?.card?.scheme && { scheme: Number(emiDetails?.card?.scheme) }),
                    },
                  }),
              }),
            },
            payee: {
              type: self?.transaction?.payee?.type,
              merchantId: self.merchant.id,
            },
          }
        } else if (paymentType === 'CardlessEMI') {
          const emiDetails = self.transaction.paymentMethod[0] as EMIType
          const product = self.transaction.product

          paymentData = {
            ...paymentInfo,
            transaction: {
              ...paymentInfo.transaction,
              originalId: self.transaction.id.preProcessId,
              method: {
                ...paymentInfo.transaction.method,
                type: PAYMENT_MODE_TYPE.EMI,
                subType: PAYMENT_MODE_SUBTYPES.CARDLESS_EMI,
              },
              emi: {
                bank: emiDetails.bank || undefined,
                tenure: emiDetails.tenure || undefined,
                scheme: emiDetails.scheme || undefined,
                product: product?.productId || undefined,
                value: emiDetails.value || undefined,
                interest: emiDetails.interestRate || undefined,
                processingFee: emiDetails.processingFees.value || undefined,
                processingFeeTax: emiDetails.processingFees.tax || undefined,
                convenienceFee: emiDetails.convenienceFees.value || undefined,
                convenienceFeeTax: emiDetails.convenienceFees.tax || undefined,
                cashback: emiDetails.cashBack || undefined,
                validationKey: product?.productValidationKey || undefined,
                validationValue: product?.productValidationValue || undefined,
              },
            },
            payer: {
              ...paymentInfo.payer,
              bankId: emiDetails.bank,
            },
            payee: {
              type: self?.transaction?.payee?.type,
              merchantId: self.merchant.id,
            },
          }
        } else if (paymentType === 'FoodCard') {
          const bankDetails = paymentMethod as BankType
          paymentData = {
            ...paymentInfo,
            transaction: {
              ...paymentInfo.transaction,
              method: {
                ...paymentInfo.transaction.method,
                subType: PAYMENT_MODE_SUBTYPES.FOOD_CARD,
              },
              ...(self.transaction.isOfferApplied &&
                self.transaction.isValidOffer &&
                self.transaction.selectedOfferPMSubType === PAYMENT_MODE_SUBTYPES.NB && {
                metadata: {
                  offer: {
                    offerCode: self.transaction.appliedOffer.offerCode,
                    offerReferenceId: self.transaction.appliedOffer.offerReferenceId,
                    transactionAmount: self.transaction.appliedOffer.transactionAmount,
                    instantDiscountAmount: self.transaction.appliedOffer.instantDiscountAmount,
                    cashBackAmount: self.transaction.appliedOffer.cashBackAmount,
                  },
                },
              }),
            },
            ...(self.transaction.isOfferApplied &&
              self.transaction.isValidOffer &&
              self.transaction.selectedOfferPMSubType === PAYMENT_MODE_SUBTYPES.NB && {
              amount: {
                grossAmount: Number(self?.transaction?.amount?.grossAmount),
                netAmount: (
                  Number(self?.transaction?.amount?.netAmount) - self.transaction.appliedOffer.instantDiscountAmount
                ).toFixed(2),
              },
            }),
            payer: {
              //TODO: check
              ...paymentInfo.payer,
              bankId: bankDetails.id,
              bankName: bankDetails.name,
              ...(bankDetails?.token && {
                card: {
                  token: bankDetails?.token,
                },
              }),
              type: 11,
            },
          }
        } else if (paymentType === 'NewToCredit') {
          const bankDetails = paymentMethod as BankType
          const [convenienceFee] = bankDetails?.convenienceFee
          paymentData = {
            ...paymentInfo,
            transaction: {
              ...paymentInfo.transaction,
              method: {
                ...paymentInfo.transaction.method,
                type: PAYMENT_MODE_TYPE.EMI,
                subType: PAYMENT_MODE_SUBTYPES.NEW_TO_CREDIT,
              },
              ...(self.transaction.isOfferApplied &&
                self.transaction.selectedOfferPMSubType === PAYMENT_MODE_SUBTYPES.NB && {
                metadata: {
                  offer: {
                    offerCode: self.transaction.appliedOffer.offerCode,
                    offerReferenceId: self.transaction.appliedOffer.offerReferenceId,
                    transactionAmount: self.transaction.appliedOffer.transactionAmount,
                    instantDiscountAmount: self.transaction.appliedOffer.instantDiscountAmount,
                    cashBackAmount: self.transaction.appliedOffer.cashBackAmount,
                  },
                },
              }),
            },
            ...(self.transaction.isOfferApplied &&
              self.transaction.selectedOfferPMSubType === PAYMENT_MODE_SUBTYPES.NB && {
              amount: {
                grossAmount: Number(self?.transaction?.amount?.grossAmount),
                netAmount: (
                  Number(self?.transaction?.amount?.netAmount) - self.transaction.appliedOffer.instantDiscountAmount
                ).toFixed(2),
              },
            }),
            payer: {
              ...paymentInfo.payer,
              bankId: bankDetails.id,
              bankName: bankDetails.name,
            },
            ...(convenienceFee?.totalFee && {
              amount: {
                ...paymentInfo.amount,
                charges: [
                  {
                    type: '',
                    value: convenienceFee?.totalFee,
                    cgst: convenienceFee?.cgst,
                    igst: convenienceFee?.igst,
                    sgst: convenienceFee?.sgst,
                    ugst: convenienceFee?.ugst,
                    serviceCharge: '',
                    tcs: convenienceFee?.tcs,
                    tds: convenienceFee?.tds,
                  },
                ],
              },
            }),
          }
        } else if (paymentType === 'JioFinanceHub') {
          const jioFinanceData = paymentMethod
          const emi = {
            bank: paymentMethod.emi.bank,
            tenure: paymentMethod.emi.tenure,
            scheme: paymentMethod.emi.scheme,
            interestRate: paymentMethod.emi.interestRate,
            discount: paymentMethod.emi.discount,
            cashBack: paymentMethod.emi.cashBack,
            processingEntityId: paymentMethod.emi.processingEntityId,
            processingEntitySchemeId: paymentMethod.emi.processingEntitySchemeId,
            processingMethod: paymentMethod.emi.processingMethod,
            schemeSubType: paymentMethod.emi.schemeSubType,
            schemeType: paymentMethod.emi.schemeType,
          }

          const metaData = JSON.parse(jioFinanceData.metadata)
          const { cardnumber, cvv, expiry, cardholdername } = metaData
          let expYR, expMonth
          if (expiry) {
            ;[expMonth, expYR] = expiry.split('/')
            expYR = convertYear(expYR?.trim())
            expMonth = convertMonth(expMonth?.trim())
          }
          if (cardnumber) {
            delete metaData.cardnumber
            delete metaData.cvv
            delete metaData.expiry
            delete metaData.cardholdername
          }
          const pan = metaData.pan
          if (pan) {
            delete metaData.pan
          }
          paymentData = {
            ...paymentInfo,
            transaction: {
              ...paymentInfo.transaction,
              method: {
                ...paymentInfo.transaction.method,
                type: 114,
                subType: jioFinanceData.subType,
                //subType: 592,
              },
              metadata: {
                eligibilityId: jioFinanceData.eligibilityResponseID,
                routingId: jioFinanceData.routingId,
              },
              emi,
            },
            payer: {
              ...paymentInfo.payer,
              ...(cardnumber && {
                card: {
                  number: cardnumber,
                  expiryMm: expMonth,
                  expiryYy: expYR,
                  name: cardholdername,
                  cvv: cvv,
                },
              }),
              ...(pan && { pan }),
              metadata: metaData,
            },
          }
        }

        const response = yield confirmPayment(paymentData, deviceDetails, isSubscription)
        console.log(JSON.stringify(response))
        const transaction = response?.transaction
        self.transaction.paymentStatus = transaction?.status
        const lPayLoad = transaction?.metadata?.payload
        self.transaction.id.id = transaction?.id

        if (transaction?.status === 'FAILED') {
          if (isSubscription && transaction?.failureMessage === 'TRANSACTION DECLINED') {
            const customError = {
              message: transaction?.failureMessage ?? errorMessage.defautCatchMessage,
            }
            self.transaction.subscriptionError = transaction?.failureMessage ?? errorMessage.defautCatchMessage
            throw customError
          } else {
            const customError = {
              message: transaction?.failureMessage ?? errorMessage.defautCatchMessage,
            }
            if (paymentType !== 'FoodCard' || self.transaction.isDirectPayment) {
              self.message.setMessage(transaction?.failureMessage, MessageTypes.info)
            }
            throw customError
          }
        } else if (!isSubscription && paymentType !== 'UPI' && !transaction?.metadata?.integrationType?.rUrl) {
          const customError = {
            message: transaction?.failureMessage ?? errorMessage.defautCatchMessage,
          }
          self.transaction.isDirectPayment = true
          self.message.setMessage(transaction?.failureMessage ?? errorMessage.defautCatchMessage, MessageTypes.info)
          throw customError
        } else if (isIFrame() && paymentType === 'Card' && transaction?.metadata?.redirectIframe?.redirectHtml) {
          const count = self.merchant.preferences.upiMaxRetryLimit
          self.merchant.updateMaxRetryLimit(count - 1)
          window.currentChild.close()
        }

        self.transaction.amount = {
          ...self.transaction.amount,
          netAmount: response?.amount?.grossAmount?.toString() ?? '0',
          grossAmount: response?.amount?.netAmount?.toString() ?? '0',
        } as AmountType
        self.transaction.timestamp = transaction?.responseTime
        self.transaction.txnMeta = {
          payLoad: lPayLoad,
          method: transaction?.metadata?.integrationType?.method,
          returnUrl: transaction?.metadata?.integrationType?.rUrl,
          contentType: transaction?.metadata?.integrationType?.contentType,
          redirectHtml: transaction?.metadata?.redirectIframe?.redirectHtml,
        }
      } catch (error) {
        console.log('ConfirmPayment error', error)
        const count = self.merchant.preferences.upiMaxRetryLimit
        self.merchant.updateMaxRetryLimit(count - 1)
        if (!isSubscription || error?.message !== 'TRANSACTION DECLINED') {
          const customError = {
            message: error?.message ?? errorMessage.defautCatchMessage,
          }
          if (paymentType !== 'FoodCard') {
            self.message.setMessage(customError.message, MessageTypes.info, error?.code)
          }
          throw customError
        } else {
          const customError = {
            message: error?.message ?? errorMessage.defautCatchMessage,
          }
          throw customError
        }
      }
    }),
    getOffersApi: flow(function* getOffersApi() {
      try {
        const response = yield getOffers(self.getOffer())
        self.offer = response
      } catch (error) {
        console.log('##### error: ', error)
        const customError = {
          message: error?.message ?? errorMessage.defautCatchMessage,
        }
        throw customError
      }
    }),
    offerCardsValidateApi: flow(function* offerCardsValidateApi() {
      try {
        const cards = self.getCards().filter((item: any) => item.offerEligibility === '')

        const responseArray = []
        for (let i = 0; i < cards.length; i++) {
          const cardItem: any = cards[i]
          const response = yield offerValidate(
            self.offerValidate(
              { card: cardItem.token },
              { type: PAYMENT_MODE_TYPE.PURCHASE, subType: PAYMENT_MODE_SUBTYPES.CARD },
              { emi: '' },
            ),
          )
          let eligibility = 'NOT_APPLICABLE'

          if (response?.offer?.eligibility === 'APPLICABLE') {
            eligibility = 'APPLICABLE'
          }
          responseArray.push({ token: cardItem.token, offerEligibility: eligibility })

          const userCards = self.user.paymentMethod.filter(
            (item: any) => getType(item).name === 'Card' && item.token === cardItem.token,
          ) as [CardType]
          if (userCards && userCards.length > 0) {
            const currentCard: CardType = userCards[0]
            currentCard.offerEligibility = eligibility
            self.user.updateSaveCards(currentCard)
          }
        }
      } catch (error) {
        const customError = {
          message: error?.message ?? errorMessage.defautCatchMessage,
        }
        throw customError
      }
    }),
    offerValidateApi: flow(function* offerValidateApi(bodayInfo: any, methodInfo: any, emiInfo: any = '') {
      try {
        const offerData = self.offerValidate(bodayInfo, methodInfo)
        // const offer1 = {
        //   ...offerData,
        //   offer: {
        //     ...offerData.offer,
        //     code: '13',
        //   },
        // }
        const response = yield offerValidate(offerData)
        console.log('offerValidateApi response', response)
        if (response.failureCode || response.failureMessage) {
          self.transaction.amount.payableAmount = self.transaction.amount.netAmount
          const customError = {
            message: response.failureMessage ?? errorMessage.defautCatchMessage,
          }
          self.transaction.isValidOffer = false
          throw customError
        } else if (response?.offer?.eligibility === 1) {
          self.transaction.amount.payableAmount = (
            Number(self?.transaction?.amount?.netAmount) -
            ((self.transaction.appliedOffer.instantDiscountAmount || response?.offer?.instantDiscountAmount?.amount) ??
              0)
          ).toFixed(2)
          self.transaction.isValidOffer = true
          return response?.offer
        } else {
          self.transaction.amount.payableAmount = self.transaction.amount.netAmount
          console.log('response: ', response)
          const customError = {
            message: response?.error ?? errorMessage.offerNotApplicable,
          }
          self.transaction.isValidOffer = false
          throw customError
        }
      } catch (error) {
        self.transaction.amount.payableAmount = self.transaction.amount.netAmount
        self.transaction.isValidOffer = false
        const customError = {
          message: error?.message ?? errorMessage.defautCatchMessage,
        }
        throw customError
      }
    }),
    offerTxnApplyApi: flow(function* offerTxnApplyApi() {
      try {
        const offerData = self.applyOfferData()
        const [paymentMethod] = self.transaction.paymentMethod
        const paymentType = paymentMethod && getType(paymentMethod).name
        const product =
          self.transaction.metadata.product?.length > 0
            ? self.transaction.metadata.product.map((item) => ({
              productId: item.productId,
              transactionAmount: item.transactionAmount,
              categoryId1: item.categoryId1 ? item.categoryId1 : undefined,
              categoryId2: item.categoryId2 ? item.categoryId2 : undefined,
              categoryId3: item.categoryId3 ? item.categoryId3 : undefined,
              categoryId4: item.categoryId4 ? item.categoryId4 : undefined,
              categoryId5: item.categoryId5 ? item.categoryId5 : undefined,
            }))
            : undefined
        let applyOfferData
        if (paymentType === 'Card') {
          const cardDetails = paymentMethod as CardType
          applyOfferData = {
            ...offerData,
            selectionCriteria: {
              ...offerData.selectionCriteria,
              method: {
                ...offerData.selectionCriteria.method,
                subType: PAYMENT_MODE_SUBTYPES.CARD,
              },
              card: {
                type: Number(cardDetails.subType),
                scheme: Number(cardDetails.scheme),
                token: cardDetails.token,
                number: String(cardDetails.number),
              },
              product,
            },
          }
        } else if (paymentType === 'Bank') {
          const bankDetails = self.transaction.paymentMethod[0] as BankType
          applyOfferData = {
            ...offerData,
            selectionCriteria: {
              ...offerData.selectionCriteria,
              method: {
                ...offerData.selectionCriteria.method,
                subType: PAYMENT_MODE_SUBTYPES.NB,
              },
              bankId: bankDetails.id,
              product,
            },
          }
        } else if (paymentType === 'Wallet') {
          const walletDetails = self.transaction.paymentMethod[0] as WalletType
          applyOfferData = {
            ...offerData,
            selectionCriteria: {
              ...offerData.selectionCriteria,
              method: {
                ...offerData.selectionCriteria.method,
                subType: PAYMENT_MODE_SUBTYPES.WALLET,
              },
              bankId: walletDetails.id,
              product,
            },
          }
        } else if (paymentType === 'UPI') {
          const upiDetails = self.transaction.paymentMethod[0] as UPIType

          console.log('upiDetails called', upiDetails)
          applyOfferData = {
            ...offerData,
            selectionCriteria: {
              ...offerData.selectionCriteria,
              method: {
                ...offerData.selectionCriteria.method,
                subType: PAYMENT_MODE_SUBTYPES.UPI,
              },
              vpa: upiDetails?.vpa,
              product,
            },
          }
        } else if (paymentType === 'EMI') {
          const emiDetails = paymentMethod as EMIType
          const [filteredOffer]: any = self.offer.filter((item: any) => item.code === self.transaction.offerCode)
          const [emi] = filteredOffer.emi

          console.log('EMI', emiDetails)
          applyOfferData = {
            ...offerData,
            selectionCriteria: {
              ...offerData.selectionCriteria,
              method: {
                ...offerData.selectionCriteria.method,
                type: PAYMENT_MODE_TYPE.EMI,
                subType: PAYMENT_MODE_SUBTYPES.CARD,
              },
              card: {
                type: Number(emiDetails.card.subType),
                scheme: Number(emiDetails.card.scheme),
                token: emiDetails.card.token,
                number: String(emiDetails.card.number),
              },
              bankEmiId: emi?.bankEmiId ?? emiDetails.bank,
              bankTenure: emiDetails.tenure,
              product,
            },
            offer: {
              ...offerData.offer,
            },
          }
        } else if (paymentType === 'PayLater') {
          const bankDetails = self.transaction.paymentMethod[0] as BankType
          applyOfferData = {
            ...offerData,
            selectionCriteria: {
              ...offerData.selectionCriteria,
              method: {
                ...offerData.selectionCriteria.method,
                subType: PAYMENT_MODE_SUBTYPES.PAYLATER,
              },
              bankId: bankDetails.id,
              product,
            },
          }
        }

        const response = yield offerTxnApply(applyOfferData)
        if (response.failureCode || response.failureMessage) {
          self.transaction.amount.payableAmount = self.transaction.amount.netAmount
          self.transaction.isOfferApplied = false
          const customError = {
            message: response.failureMessage ?? errorMessage.defautCatchMessage,
          }
          throw customError
        } else if (response?.offer?.offerCode) {
          self.transaction.appliedOffer.offerReferenceId = String(response?.offer?.offerReferenceId)
          self.transaction.appliedOffer.transactionAmount = response?.offer?.transactionAmount
          self.transaction.appliedOffer.instantDiscountAmount = response?.offer?.instantDiscountAmount
          self.transaction.appliedOffer.offerCode = response?.offer?.offerCode
          self.transaction.appliedOffer.cashBackAmount = response?.offer?.cashBackAmount
          return response
        } else {
          self.transaction.amount.payableAmount = self.transaction.amount.netAmount
          self.transaction.isOfferApplied = false
          const customError = {
            message: errorMessage.defautCatchMessage,
          }
          throw customError
        }
      } catch (error) {
        self.transaction.amount.payableAmount = self.transaction.amount.netAmount
        self.transaction.isOfferApplied = false
        console.log('##### error: ', error)
        const customError = {
          message: error?.message ?? errorMessage.defautCatchMessage,
        }
        throw customError
      }
    }),
    updateInputData(id: string, value: any) {
      const [payLaterInputData] = self.merchant.preferences.payLaterList.toJSON()?.filter((item: any) => item.id === id)
      payLaterInputData.inputData.forEach((item: any) => {
        item.value = value[item.labelName]
      })
    },
    getIntentStatusApi: flow(function* getIntentStatusApi(isQrIntentReq: false) {
      try {
        const resData = yield getIntentStatus(self?.transaction?.id?.id)
        const intentStatus = resData.intentDetails.status
        self.transaction.paymentStatus = intentStatus
        if (intentStatus === 'SUCCESS' && resData?.transactionList?.length > 0) {
          const [response] = resData?.transactionList?.filter((item) => item.transaction.status === 'SUCCESS')
          if (response) {
            const { transaction, amount } = response
            const lPayLoad = transaction?.metadata?.payload
            self.transaction.amount = {
              ...self.transaction.amount,
              netAmount: amount?.grossAmount?.toString() ?? '0',
              grossAmount: amount?.netAmount?.toString() ?? '0',
            } as AmountType
            self.transaction.id.id = transaction?.id
            self.transaction.id.invoiceno = transaction?.invoice
            self.transaction.timestamp = transaction?.responseTime
            self.transaction.txnMeta = {
              payLoad: lPayLoad,
              method: transaction?.metadata?.integrationType?.method,
              returnUrl: transaction?.metadata?.integrationType?.rUrl,
              contentType: transaction?.metadata?.integrationType?.contentType,
              redirectHtml: transaction?.metadata?.redirectIframe?.redirectHtml,
            }
            self.transaction.initiatingEntity.callbackUrl = self.transaction.initiatingEntity.callbackUrl
              ? self.transaction.initiatingEntity.callbackUrl
              : transaction?.initiatingEntity?.callbackUrl
            return response
          }
        }
        return resData
      } catch (error) {
        const customError = {
          message: error?.message ?? errorMessage.defautCatchMessage,
        }
        if (!isQrIntentReq) {
          self.message.setMessage(customError.message, MessageTypes.error, error?.code)
          throw customError
        }
      }
    }),
    getPaymentStatusApi: flow(function* getPaymentStatusApi() {
      try {
        const resData = yield getPaymentStatus(self?.transaction?.id?.id)
        const [response] = resData?.transactionList.slice(-1)
        const { transaction, amount } = response
        self.transaction.paymentStatus = transaction?.status
        const lPayLoad = transaction?.metadata?.payload
        self.transaction.amount = {
          ...self.transaction.amount,
          netAmount: amount?.grossAmount?.toString() ?? '0',
          grossAmount: amount?.netAmount?.toString() ?? '0',
        } as AmountType
        self.transaction.id.id = transaction?.id
        self.transaction.id.invoiceno = transaction?.invoice
        self.transaction.timestamp = transaction?.responseTime
        self.transaction.txnMeta = {
          payLoad: lPayLoad,
          method: transaction?.metadata?.integrationType?.method,
          returnUrl: transaction?.metadata?.integrationType?.rUrl,
          contentType: transaction?.metadata?.integrationType?.contentType,
        }
        self.transaction.initiatingEntity.callbackUrl = self.transaction.initiatingEntity.callbackUrl
          ? self.transaction.initiatingEntity.callbackUrl
          : transaction?.initiatingEntity?.callbackUrl
        return response
      } catch (error) {
        const customError = {
          message: error?.message ?? errorMessage.defautCatchMessage,
        }
        self.message.setMessage(customError.message, MessageTypes.error, error?.code)
        throw customError
      }
    }),
    deleteCardApi: flow(function* deleteCardApi(token, isSavedVpa = false) {
      try {
        const params = self.deleteCardBody(isSavedVpa)
        const response = yield deleteCard(params, token)
        if (response.status === 'SUCCESS') {
          self.deleteCardFromStore(String(token), isSavedVpa) // We need to delete before calling the API as the card available in the store
        } else {
          self.message.setMessage(response?.error?.message, MessageTypes.error)
        }
        return response
      } catch (error) {
        const customError = {
          message: error?.message ?? errorMessage.defautCatchMessage,
        }
        self.message.setMessage(customError.message, MessageTypes.error, error?.code)
        throw customError
      }
    }),
    merchantApi: flow(function* searchMerchantApi() {
      try {
        const intentId = self?.transaction?.id?.intentId
        const paymentStatus = yield getPaymentStatus(intentId)
        const [transactionStatus] = paymentStatus?.transactionList
        const { transaction, amount, payer, payee, checkout = {} } = transactionStatus
        self.transaction.amount = {
          ...self.transaction.amount,
          netAmount: amount?.netAmount?.toString() ?? '0',
          payableAmount: amount?.netAmount?.toString() ?? '0',
          grossAmount: amount?.grossAmount?.toString() ?? '0',
        } as AmountType
        self.transaction.metadata.product = transaction.metadata.product
        self.merchant.id = Number(payee?.merchantId ?? '0')
        // self.merchant.template = checkout?.template
        // self.merchant.allowedPaymentModes = checkout?.allowed
        // self.merchant.notAllowedPaymentModes = checkout?.notAllowed
        // self.merchant.miscellaneous = checkout?.miscellaneous

        if (transaction?.standingInstruction) {
          self.merchant.subscription = transaction?.standingInstruction
          self.merchant.updateIsSubscriptionEnabled(true)
        }
        self.transaction.id.id = transaction?.id
        self.transaction.id.application = transaction?.application
        self.transaction.amount.currency = String(transaction?.currency)
        self.transaction.id.invoiceno = transaction?.invoice
        self.transaction.timestamp = transaction?.responseTime
        self.transaction.methodType = transaction?.method?.type
        self.transaction.mode = transaction?.mode
        self.transaction.initiatingEntity.entityId = transaction?.initiatingEntity?.entityId
        self.transaction.initiatingEntity.returnUrl = transaction?.initiatingEntity?.returnUrl
        self.transaction.initiatingEntity.callbackUrl = self.transaction.initiatingEntity.callbackUrl
          ? self.transaction.initiatingEntity.callbackUrl
          : transaction?.initiatingEntity?.callbackUrl
        self.transaction.initiatingEntity.timeStamp = transaction?.initiatingEntityTimestamp
        self.user.id = payer?.userId
        self.user.externalId = payer.externalId
        self.transaction.statementDescriptor = transaction?.statementDescriptor ?? 'e-Mandates'
        self.transaction.remarks = transaction.remarks
          ? transaction.remarks
          : `Your account will be debited Rs ${formatAmount(String(amount?.netAmount?.toString() ?? '0'))}`
        self.transaction.payer = {
          ...self.transaction.payer,
          countryCode: payer?.mobile?.countryCode,
          number: payer?.mobile?.number,
          type: payer?.type,
          gstIn: payer?.gstIn,
          gstInvoice: payer?.gstInvoice,
          gstConsent: payer?.gstConsent,
          pan: payer?.pan,
        }
        self.transaction.payee = {
          ...self.transaction.payee,
          terminalId: payee?.terminalId,
          name: payee?.name,
          mcc: payee?.mcc,
          type: payee?.type,
        }

        const templateId = self.merchant.template?.id
        const allowedCardsLength = self.merchant.allowedPaymentModes?.length
        const notAllowedCardsLength = self.merchant.notAllowedPaymentModes?.length

        if (!templateId || (allowedCardsLength === 0 && notAllowedCardsLength === 0)) {
          if (checkout) {
            self.merchant.isAllowedPaymentModesAvailable = checkout.allowed ? true : false
          }
          console.log('templateId=', templateId)
          console.log('checkout.template=', checkout?.template)
          if (templateId) {
            if (!checkout.template) {
              checkout.template = {}
            }
            checkout.template.id = templateId
          }
          console.log('checkout.template=', checkout?.template)
          self.merchant.updateTemplate(checkout?.template)
          self.merchant.updateAllowedPaymentModes(checkout?.allowed)
          self.merchant.updateNotAllowedPaymentModes(checkout?.notAllowed)
          self.merchant.updateMiscellaneous(checkout?.miscellaneous)
          const brandColor = self.config.merchantTheme.brandColor
          if (!brandColor) {
            const merchantBrandColor = checkout?.template?.brandColor
            if (isValidColorCode(merchantBrandColor)) {
              self.config.merchantTheme.brandColor = merchantBrandColor as ColorOptions
            }
          }

          const headingText = self.config.merchantTheme.headingText
          if (!headingText) {
            const merchantHeadingText = checkout?.template?.headingText
            if (isValidColorCode(merchantHeadingText)) {
              self.config.merchantTheme.headingText = merchantHeadingText as ColorOptions
            }
          }

          const bodyBgColor = self.config.merchantTheme.bodyBgColor
          if (!bodyBgColor) {
            const merchantBodyBgColor = checkout?.template?.bodyBgColor
            if (isValidColorCode(merchantBodyBgColor)) {
              self.config.merchantTheme.bodyBgColor = merchantBodyBgColor as ColorOptions
            }
          }
          const bodyTextColor = self.config.merchantTheme.bodyTextColor
          if (!bodyTextColor) {
            const merchantBodyTextColor = checkout?.template?.bodyTextColor
            if (isValidColorCode(merchantBodyTextColor)) {
              self.config.merchantTheme.bodyTextColor = merchantBodyTextColor as ColorOptions
            }
          }
        }

        //To update the defaut values for theme if we have not updated because of invalid values
        self.config.updateMerchantTheme()
        const searchParams = self?.searchMerchantParams()
        const configParams = self?.getMerchantConfigParams()
        const [entityResponse] = yield Promise.all([
          searchEntity({ identificationNumber: self?.merchant.id?.toString() }),
        ])
        const { name, mcc, vpa, configValues, allowedCards, emiMinAmount, upiRetriesCount, walletValues } = entityResponse ?? {}
        const searchEntityConfig = {
          name,
          mcc,
          vpa,
          allowedCards,
          allowedPaymentConfigs: configValues,
        }
        self.merchant = {
          ...self.merchant,
          ...searchEntityConfig,
        }
        //If the transaction amount is morethan 1500 then only we have to display EMI
        if (
          emiMinAmount &&
          Number(self.transaction.amount.netAmount) >= Number(emiMinAmount)
        ) {
          self.merchant.updatePaymentSupport(configValues)
        } else {
          const configWithOutEMI = configValues
            .split('|')
            .filter((item: any) => item !== String(PAYMENT_MODE_TYPE.EMI))
            .join('|')
          self.merchant.updatePaymentSupport(configWithOutEMI)
        }

        self.merchant.preferences = {
          ...self.merchant.preferences,
          walletList: walletValues ?? [],
          selectedVpa: checkout?.payer?.vpa ?? '',
          selectedBankId: checkout?.payer?.bankId ?? '',
          upiMaxRetryLimit:
            Number(!Number.isNaN(upiRetriesCount) ? upiRetriesCount : '3') + 1,
        }
        self.transaction.token = checkout?.payer?.vaultId ?? ''
        self.transaction.cvv = checkout?.payer?.cvv ?? ''
        const isSinglePaymentModeAllowed = self.merchant.isSinglePaymentModeAllowed()
        self.transaction.isDirectPayment =
          isSinglePaymentModeAllowed &&
          (!isEmpty(checkout?.payer?.vpa) || !isEmpty(checkout?.payer?.vaultId) || !isEmpty(checkout?.payer?.bankId))
        const { REACT_APP_URL = '' } = process.env
        self.merchant.logo = `${REACT_APP_URL}/merchant/logo/${self.merchant.id}.png`
      } catch (error) {
        console.log('error', error)
        const customError = {
          ...error,
          isGlobalError: true,
          rUrl: self?.transaction?.initiatingEntity?.returnUrl ?? '',
        }
        throw customError
      }
    }),
    upiValidateVpaApi: flow(function* upiValidateVpaApi(upiId: string, isSave: boolean) {
      try {
        const paymentInfo = self.confirmPaymentData()
        const deviceDetails = self.deviceInfo()
        const id = self.transaction.id.intentId
        const isUpiNo = isUpiNumber(upiId)
        const validateType = isUpiNo ? 'upiNumber' : 'vpa'

        const paymentData = {
          ...paymentInfo,
          transaction: {
            ...paymentInfo.transaction,
            id,
            intentId: id,
            livemode: UPI_LIVEMODE,
            method: {
              type: UPI_METHOD_TYPE,
              subType: PAYMENT_MODE_SUBTYPES.UPI,
            },
            initiatingEntity: {
              ...paymentInfo.transaction.initiatingEntity,
              entityId: self.transaction.initiatingEntity.entityId,
            },
          },
          payer: {
            ...paymentInfo.payer,
            type: UPI_PAYER_TYPE,
            subType: UPI_PAYER_SUBTYPE,
            [validateType]: upiId,
          },
          payee: {
            merchantId: paymentInfo.payee.merchantId,
            mobile: {
              countryCode: UPI_PAYEE_COUNTRY_CODE,
            },
          },
        }
        const response = yield upiValidateVpa(paymentData, deviceDetails)
        const { data: vpaData } = response
        const status = response?.data?.transaction?.status
        if (status === 'SUCCESS') {
          const upi = {
            id: 0,
            vpa: upiId,
            isSave: isSave,
            paymentType: 'UPI',
          } as UPIType
          self.transaction.addPaymentMethod(upi)

          return vpaData
        } else {
          const customError = {
            message: errorMessage.invalidVPA ? errorMessage.invalidVPA : errorMessage.invalidUpiNumber,
          }
          throw customError
        }
      } catch (error) {
        const customError = {
          message: error?.message ?? errorMessage.defautCatchMessage,
        }
        throw customError
      }
    }),
    getAllEMIList: flow(function* getAllEMIList(showError = true) {
      const products = self.transaction?.metadata?.product?.map((item: any) => {
        return {
          productId: item.productId,
          productAmount: item.transactionAmount,
        }
      })

      try {
        const MID = self.merchant.id
        const filterData = {
          merchantId: MID,
          filters: {
            amount: self.transaction.amount.netAmount || '',
            product: [...products],
          },
        }
        const deviceDetails = self.deviceInfo()
        console.log('calling getAllEMIList called')
        const emiRetrieveResponse = yield emiRetrieve(deviceDetails, filterData)

        self.merchant.preferences.cardLessEMIList = emiRetrieveResponse.filter(
          (item: any) => item.schemeSubType === EMI_CARDTYPE.CARDLESS,
        )

        self.merchant.preferences.EMILList = emiRetrieveResponse.filter(
          (item: any) =>
            item.schemeSubType === EMI_CARDTYPE.CREDIT_CARD ||
            item.schemeSubType === EMI_CARDTYPE.DEBIT_CARD ||
            item.schemeSubType === EMI_CARDTYPE.CARDLESS_EMI,
        )
      } catch (error) {
        const customError = {
          message: error?.message ?? errorMessage.defautCatchMessage,
        }
        showError && self.message.setMessage(customError.message, MessageTypes.error, error?.code)
        throw customError
      }
    }),
    getAllEMIListForSavedCard: flow(function* getAllEMIListForSavedCard(vltId: any, schemeSubtype: any) {
      try {
        const resolveApiRequest = {
          amount: {
            netAmount: self.transaction.amount.netAmount || '',
          },
          entity: {
            initiatingEntityId: self?.transaction?.initiatingEntity?.entityId,
            application: self?.transaction?.id?.application,
            type: 11,
            entityId: self?.merchant?.id,
          },
          user: {
            userId: self?.user?.id,
            externalId: self.user.externalId,
          },
        }
        const cardToken = yield resolveApi(vltId, resolveApiRequest)

        const resp = yield self.getCardEligibility(cardToken, false, schemeSubtype)

        return { ...resp, cardBin: cardToken }
      } catch (error) {
        console.log('HTAG ERR', error)
        const customError = {
          message: error?.message ?? errorMessage.defautCatchMessage,
        }
        self.message.setMessage(customError.message, MessageTypes.error, error?.code)
        throw customError
      }
    }),
    getEMICardsEligibility: flow(function* getEMICardsEligibility() {
      try {
        const userCards = self.user.paymentMethod.filter((item) => getType(item).name === 'Card') as [CardType]
        if (userCards && userCards.length > 0) {
          const userCardTokens = userCards.map((item) => item.token)

          const deviceDetails = self.deviceInfo()
          console.log('userCardTokens', userCardTokens)
          const filterData = {
            bin: userCardTokens.join(),
            binType: 'TOKEN',
          }
          console.log('deviceDetails', JSON.stringify(deviceDetails))
          console.log('filderData', JSON.stringify(filterData))
          const response = yield emiCardsEligibility(deviceDetails, filterData)
          const updatedUserCards = userCards.map((item: any) => ({
            ...item,
            emiBankId: response.find((responseItem: any) => responseItem.token === item.token)?.emiBankId,
            isEMIEligible: response.find((responseItem: any) => responseItem.token === item.token)?.isEMIEligible,
          }))

          self.user.addSavedCards(updatedUserCards)
          return response
        }
      } catch (error) {
        const customError = {
          message: error?.message ?? errorMessage.defautCatchMessage,
        }
        console.log('error', error, customError)
        self.message.setMessage(customError.message, MessageTypes.error, error?.code)
        throw customError
      }
    }),
    getCardOfferEMIEligibility: flow(function* getEMIList(
      cardBin: string,
      isNewCard: boolean,
      schemeSubType: string,
      amount: string = self.transaction.amount.netAmount,
      bankId: string = '',
    ) {
      const [card]: any = self.user?.paymentMethod?.filter((item: any) => item.token === cardBin)
      try {
        const MID = self.merchant.id
        const filterData = {
          merchantId: MID,
          ...(isNewCard && {
            filters: {
              cardBin: cardBin,
              amount: amount,
              schemeSubType,
              ...(bankId && { emiBankId: bankId }),
            },
          }),
          ...(!isNewCard && {
            filters: {
              token: cardBin,
              emiBankId: card.emiBankId,
              amount: amount,
            },
          }),
        }
        const deviceDetails = self.deviceInfo()
        const emiRetrieveResponse = yield emiRetrieve(deviceDetails, filterData)
        console.log('emiRetrieveResponse', emiRetrieveResponse)

        //  self.merchant.updateCardEMIListMap(cardBin, emiRetrieveResponse)
        // self.merchant.preferences.cardEMIList = emiRetrieveResponse
        //  const itertatorTest = self.merchant.preferences.cardEMIListMap.keys()

        // for (const item of itertatorTest) {
        //   console.log('item', item.car)
        // }
        return emiRetrieveResponse
      } catch (error) {
        const customError = {
          message: error?.message ?? errorMessage.defautCatchMessage,
        }
        self.message.setMessage(customError.message, MessageTypes.error, error?.code)
        throw customError
      }
    }),
    getCardEligibility: flow(function* getEMIList(
      cardBin: string,
      isNewCard: boolean,
      schemeSubType: string,
      amount: string = self.transaction.amount.netAmount,
      bankId: string = '',
    ) {
      const products = self.transaction?.metadata?.product?.map((item: any) => {
        return {
          productId: item.productId,
          productAmount: item.transactionAmount,
        }
      })
      const [card]: any = self.user?.paymentMethod?.filter((item: any) => item.token === cardBin)
      try {
        const MID = self.merchant.id
        const filterData = {
          merchantId: MID,
          ...(isNewCard && {
            filters: {
              cardBin: cardBin,
              amount: amount,
              schemeSubType,
              ...(bankId && { emiBankId: bankId }),
              product: [...products],
            },
          }),
          ...(!isNewCard && {
            filters: {
              token: cardBin,
              emiBankId: card?.emiBankId,
              amount: amount,
              schemeSubType,
            },
          }),
        }
        const deviceDetails = self.deviceInfo()
        console.log('HTAG deviceDetails', JSON.stringify(deviceDetails))
        console.log('HTAG filterData', JSON.stringify(filterData))
        const emiRetrieveResponse = yield emiRetrieve(deviceDetails, filterData)
        console.log('emiRetrieveResponse', emiRetrieveResponse)
        console.log('{cardBin}_${schemeSubType', `${cardBin}_${schemeSubType}`)
        self.merchant.updateCardEmiList(
          `${cardBin.replace(/[^0-9]/g, '').slice(0, 6)}_${schemeSubType}`,
          emiRetrieveResponse,
        )
        //  self.merchant.updateCardEMIListMap(cardBin, emiRetrieveResponse)
        // self.merchant.preferences.cardEMIList = emiRetrieveResponse
        //  const itertatorTest = self.merchant.preferences.cardEMIListMap.keys()

        // for (const item of itertatorTest) {
        //   console.log('item', item.car)
        // }
        return emiRetrieveResponse
      } catch (error) {
        const customError = {
          message: error?.message ?? errorMessage.defautCatchMessage,
        }
        self.message.setMessage(customError.message, MessageTypes.error, error?.code)
        throw customError
      }
    }),
    getClientIpApi: flow(function* getClientIpApi() {
      try {
        const loc = yield getLocation()
        const latitude = loc?.coords?.latitude
        const longitude = loc?.coords?.longitude
        self.client.latitude = String(latitude)
        self.client.longitude = String(longitude)
      } catch (error) {
        const customError = {
          message: error?.message ?? errorMessage.defautCatchMessage,
        }
        throw customError
      }
    }),
    cancelIntentApi: flow(function* cancelIntentApi() {
      try {
        const intentId = self.transaction.id.intentId
        const response = yield cancelIntent(intentId)
        return response
      } catch (error) {
        const customError = {
          message: error?.message ?? errorMessage.defautCatchMessage,
        }
        throw customError
      }
    }),
    getInsturmentsApi: flow(function* getInstrumentsApi(instrumentType: number) {
      try {
        const merchantId = Number(self.merchant.id)
        const response = yield getInstruments(instrumentType, merchantId)
        if (response.length === 0) {
          const customError = {
            error: instrumentType === PAYMENT_MODE_SUBTYPES.WALLET ? 'No Wallets' : 'No Banks',
          }
          throw customError
        }
        if (instrumentType === PAYMENT_MODE_SUBTYPES.WALLET) {
          self.merchant.preferences = {
            ...self.merchant.preferences,
            walletList: response,
          }
        } else if (instrumentType === PAYMENT_MODE_SUBTYPES.PAYLATER) {
          self.merchant.preferences = {
            ...self.merchant.preferences,
            payLaterList: response,
          }
        } else if (instrumentType === PAYMENT_MODE_SUBTYPES.FOOD_CARD) {
          self.merchant.preferences = {
            ...self.merchant.preferences,
            foodCardList: response,
          }
        } else if (instrumentType === PAYMENT_MODE_SUBTYPES.CORP_NB) {
          const allBanks: any = [...response, ...self.merchant.preferences.bankList]
          self.merchant.preferences = MERGE_NB_CNB
            ? {
              ...self.merchant.preferences,
              bankList: allBanks,
            }
            : {
              ...self.merchant.preferences,
              corpBankList: response,
            }
        } else {
          const allBanks: any = [...response, ...self.merchant.preferences.bankList]
          self.merchant.preferences = {
            ...self.merchant.preferences,
            bankList: allBanks,
          }
          const isSubscriptionEnabled = self.merchant.subscription.isEnabled
          const isCorpNbAllowedInConfigApi = self.merchant.allowedPaymentConfigs.split('|').includes('620')
          const isCorpNbAllowedForTnx =
            self.merchant.allowedPaymentModes.length === 0 ||
            self.merchant.allowedPaymentModes.filter(
              (item: any) => item.methodType === '110' && item.methodSubType === '620',
            )?.length > 0
          const isCorpNbNotAllowedForTnx =
            self.merchant.notAllowedPaymentModes.length > 0 &&
            self.merchant.notAllowedPaymentModes.filter(
              (item: any) => item.methodType === '110' && item.methodSubType === '620',
            )?.length > 0
          const isCnbAllowed =
            !isSubscriptionEnabled && isCorpNbAllowedInConfigApi && isCorpNbAllowedForTnx && !isCorpNbNotAllowedForTnx
          if (MERGE_NB_CNB && isCnbAllowed) {
            return (self as any).getInsturmentsApi(PAYMENT_MODE_SUBTYPES.CORP_NB)
          }
        }
      } catch (error) {
        const customError = {
          message: error?.message ?? errorMessage.defautCatchMessage,
        }
        if (error?.code === TOKEN_EXPIRY_CODE || instrumentType === PAYMENT_MODE_SUBTYPES.NEW_TO_CREDIT) {
          self.message.setMessage(customError.message, MessageTypes.error, error?.code)
        }
        throw customError
      }
    }),
    binServiceApi: flow(function* binServiceApi(cardNumber: string) {
      try {
        const params = {
          inputMap: {
            ...self.binServiceParams().inputMap,
            CARD_NO: cardNumber,
          },
        }
        const response = yield binService(params)
        if (response.statusCode === 'error') {
          const customError = {
            message: response?.statusMessage ?? errorMessage.defautCatchMessage,
          }
          self.message.setMessage(customError.message, MessageTypes.error)
          throw customError
        } else {
          const {
            result: {
              output: { BIN },
            },
          } = response

          const [cardInfo] = BIN[cardNumber]
          const card = {
            type: cardInfo.ACCT_FUND_SRC,
            scheme: cardInfo.CARD_SCHEME,
            isInternationalCard: cardInfo.IS_DOMESTIC !== 'Y',
            product: cardInfo.CARD_PRODUCT_ID,
            isDomestic: cardInfo.IS_DOMESTIC === 'Y',
          } as any
          card?.isInternationalCard && (self as any).isInternationalCardAllowed(card)
          cardInfo.IS_DOMESTIC === 'Y' && (self as any).isDomesticCardAllowed(card)
          return card
        }
      } catch (error) {
        const errMessage = error?.message ?? 'Invalid Card'
        const customError = {
          message: errMessage,
        }
        //Invalid Identifier Token Passed
        if (error?.code === TOKEN_EXPIRY_CODE) {
          self.message.setMessage(customError.message, MessageTypes.error, error?.code)
        }
        // self.message.setMessage(errMessage, MessageTypes.error)
        throw customError
      }
    }),
    isInternationalCardAllowed: function isInternationalCardAllowed(card: any) {
      const isInternationalCardAllowed = self.merchant.allowedCards.some(
        (item) =>
          item.type === card?.type &&
          item.scheme === card?.scheme &&
          item.isInternationalAllowed === card?.isInternationalCard,
      )

      if (!isInternationalCardAllowed) {
        throw new Error('Invalid Card')
      }
      return isInternationalCardAllowed
    },
    isDomesticCardAllowed: function isDomesticCardAllowed(card: any) {
      const isDomesticCardAllowed = self.merchant.allowedCards.some(
        (item) => item.type === card?.type && item.scheme === card?.scheme && item.isDomesticAllowed,
      )

      if (!isDomesticCardAllowed) {
        throw new Error('Invalid Card')
      }
      return isDomesticCardAllowed
    },
    preProcessApi: flow(function* preProcessApi(params: any, payerInfo: any, isCardLessEMI: boolean) {
      console.log('****** params: ', params)
      try {
        const deviceDetails = self.deviceInfo()
        const paymentData = {
          transaction: {
            idempotentKey: getRandomAlphaNumString(8),
            currency: self?.transaction?.amount?.currency,
            invoice: self?.transaction?.id?.invoiceno,
            mode: self?.transaction?.mode,
            captureMethod: CAPTURE_METHOD,
            method: {
              type: 306,
              subType: isCardLessEMI ? PAYMENT_MODE_SUBTYPES.CARDLESS_EMI : PAYMENT_MODE_SUBTYPES.PAYLATER,
            },
            livemode: LIVE_MODE,
            application: self?.transaction?.id?.application,
            intentId: self?.transaction?.id?.intentId,
            initiatingEntityTimestamp: self?.transaction?.initiatingEntity?.timeStamp,
            initiatingEntity: {
              entityId: self?.transaction?.initiatingEntity?.entityId,
              callbackUrl: self?.transaction?.initiatingEntity?.callbackUrl,
            },
            responseTime: self?.transaction?.timestamp,
          },
          amount: {
            grossAmount: Number(self?.transaction?.amount?.grossAmount),
            netAmount: Number(self?.transaction?.amount?.netAmount),
          },
          payer: {
            bankId: payerInfo.id,
            bankName: payerInfo.text,
            type: self?.transaction?.payer?.type,
            ...(isCardLessEMI
              ? {
                mobile: {
                  ...params,
                },
              }
              : {
                metadata: {
                  ...params,
                },
              }),
          },
          payee: {
            type: self?.transaction?.payee?.type,
            terminalId: self?.transaction?.payee?.terminalId,
            merchantId: self.merchant.id,
            name: self?.transaction?.payee?.name, //Todo we have to remove hardcode
          },
        }
        const response = yield payLaterPreProcess(paymentData, deviceDetails)
        console.log('response: ', response)

        const transaction = response?.transaction

        if (transaction?.status === 'FAILED' || transaction?.status === 'FAILURE') {
          const customError = {
            message: transaction?.failureMessage ?? errorMessage.defautCatchMessage,
          }
          self.message.setMessage(transaction?.failureMessage ?? errorMessage.defautCatchMessage, MessageTypes.info)
          throw customError
        }

        self.transaction.paymentStatus = transaction?.status
        self.transaction.id.preProcessId = transaction?.originalId
        self.transaction.payer.number = response?.payer?.mobile?.number
      } catch (error) {
        const customError = {
          message: error?.message ?? errorMessage.defautCatchMessage,
        }
        self.message.setMessage(error?.message ?? errorMessage.defautCatchMessage, MessageTypes.info)
        throw customError
      }
    }),
    getCardBalance: flow(function* getCardBalance(token: string) {
      try {
        const cardDetails = self.getCardBalanceBody(token)
        self.user.updateCardBalanceLoader(token, true)
        const response = yield getSodexoCardBalance(cardDetails)
        if (response?.status === 'SUCCESS') {
          self.user.updateCardBalance(token, response?.totalBalance)
          if (Number(response?.totalBalance) < Number(self.getTransactionAmount())) {
            const customError = {
              message: 'Insufficient balance to proceed, choose another card or a different payment method',
              vaultId: response?.vaultId,
            }
            self.user.updateCardBalanceError(token, customError.message, response?.totalBalance)
          }
        } else {
          const customError = {
            message: 'Unable to fetch card balance, click on Get Balance to fetch again',
            vaultId: response?.vaultId,
          }
          self.user.updateCardBalanceError(String(customError.vaultId), customError.message)
        }
        return response
      } catch (error) {
        const customError = {
          message: 'Unable to fetch card balance, click on Get Balance to fetch again',
          vaultId: token,
        }
        self.user.updateCardBalanceError(String(customError.vaultId), customError.message)
        return customError
      }
    }),
    getConvenienceApi: flow(function* getConvenienceApi(data: any, paymentSubType: number, isOfferApplied: boolean) {
      try {
        console.log('getConvenienceApi called1', isOfferApplied)
        if (isOfferApplied) {
          if (!self.transaction.isConFeeAvailable(paymentSubType)) {
            const params: any = {
              ...self.getConvenienceData(!isOfferApplied),
              queryParameters: {
                ...data,
              },
            }
            const offerParams: any = {
              ...self.getConvenienceData(isOfferApplied),
              queryParameters: {
                ...data,
              },
            }
            const [response, offerResponse] = yield Promise.all([
              fetchConvenienceFee(params, paymentSubType),
              fetchConvenienceFee(offerParams, paymentSubType),
            ])
            const feeDetails = response?.feeDetails
            self.updateConvenienceFeeDetails(feeDetails, paymentSubType, !isOfferApplied)

            const offerFeeDetails = offerResponse?.feeDetails
            self.updateConvenienceFeeDetails(offerFeeDetails, paymentSubType, isOfferApplied)
            return response
          } else {
            const offerParams: any = {
              ...self.getConvenienceData(isOfferApplied),
              queryParameters: {
                ...data,
              },
            }
            const offerResponse = yield fetchConvenienceFee(offerParams, paymentSubType)

            const offerFeeDetails = offerResponse?.feeDetails
            console.log('feeDetails', offerFeeDetails)
            self.updateConvenienceFeeDetails(offerFeeDetails, paymentSubType, isOfferApplied)
            return offerResponse
          }
        } else {
          const params: any = {
            ...self.getConvenienceData(isOfferApplied),
            queryParameters: {
              ...data,
            },
          }
          const response = yield fetchConvenienceFee(params, paymentSubType)

          const feeDetails = response?.feeDetails
          console.log('feeDetails', feeDetails)
          self.updateConvenienceFeeDetails(feeDetails, paymentSubType, isOfferApplied)
          return response
        }
        // const response = yield fetchConvenienceFee(params, paymentSubType)

        // switch (paymentSubType) {
        //   case PAYMENT_MODE_SUBTYPES.CARD:
        //     // const cardBin = fee?.card?.cardBin
        //     self.transaction.convenienceFee.sgst = feeTax?.sgst
        //     self.transaction.convenienceFee.igst = feeTax?.igst
        //     self.transaction.convenienceFee.cgst = feeTax?.cgst
        //     self.transaction.convenienceFee.totalFee = fee?.totalConvenienceFee
        // }
        // self.transaction.convenienceFee.sgst = feeTax?.sgst
        // self.transaction.convenienceFee.igst = feeTax?.igst
        // self.transaction.convenienceFee.cgst = feeTax?.cgst
        // self.transaction.convenienceFee.totalFee = totalConvenienceFee

        // console.log('getConvenienceApi', feeTax, totalConvenienceFee)
      } catch (error) {
        const customError = {
          message: error?.message ?? errorMessage.defautCatchMessage,
        }
        throw customError
      }
    }),
    generateQrCode: flow(function* generateQrCode(amount?: any) {
      try {
        const intentId = self?.transaction?.id.intentId
        const data = generateQrCodeRequest(
          '' + self?.merchant?.id,
          amount,
          intentId,
          'BASE64',
          self?.user?.mobileNumber,
        )
        let response
        response = yield generateQr(data)
        const modifiedResponse = {
          ...response,
          id: intentId,
        }
        return modifiedResponse
      } catch (e) {
        const customError = {
          message: e?.message ?? errorMessage.defautCatchMessage,
        }
        if (e?.code === TOKEN_EXPIRY_CODE) {
          self.message.setMessage(customError.message, MessageTypes.error, e?.code)
        }
        throw customError
      }
    }),
  }))

const RootStore = Root.create({
  user: UserInitialData,
  // @ts-expect-error: Let's ignore a compile error like this
  merchant: MerchantInitialData,
  transaction: TransactionInitialData,
  config: ConfigInitialData,
  client: ClientInitalData,
  message: MessageInitalData,
  jioPayFinanceHub: JioPayFinanceHubInitialData,
})

onSnapshot(RootStore, (snapshot) => {
  console.log('%c%s', 'color: green; background: yellow; font-size: 14px;', 'SnapShot!:', snapshot)
})

export type RootType = Instance<typeof Root>
export { RootStore }
